import * as _bowser2 from "bowser";
var _bowser = _bowser2;
try {
  if ("default" in _bowser2) _bowser = _bowser2.default;
} catch (e) {}
import * as _extends2 from "@babel/runtime/helpers/extends";
var _extends = _extends2;
try {
  if ("default" in _extends2) _extends = _extends2.default;
} catch (e) {}
import * as _asyncToGenerator2 from "@babel/runtime/helpers/asyncToGenerator";
var _asyncToGenerator = _asyncToGenerator2;
try {
  if ("default" in _asyncToGenerator2) _asyncToGenerator = _asyncToGenerator2.default;
} catch (e) {}
import * as _regenerator2 from "@babel/runtime/regenerator";
var _regenerator = _regenerator2;
try {
  if ("default" in _regenerator2) _regenerator = _regenerator2.default;
} catch (e) {}
import * as _inheritsLoose2 from "@babel/runtime/helpers/inheritsLoose";
var _inheritsLoose = _inheritsLoose2;
try {
  if ("default" in _inheritsLoose2) _inheritsLoose = _inheritsLoose2.default;
} catch (e) {}
import * as _promisePolyfill2 from "promise-polyfill";
var _promisePolyfill = _promisePolyfill2;
try {
  if ("default" in _promisePolyfill2) _promisePolyfill = _promisePolyfill2.default;
} catch (e) {}
import * as _events2 from "events";
var _events = _events2;
try {
  if ("default" in _events2) _events = _events2.default;
} catch (e) {}
import * as _mergeWith2 from "lodash/mergeWith";
var _mergeWith = _mergeWith2;
try {
  if ("default" in _mergeWith2) _mergeWith = _mergeWith2.default;
} catch (e) {}
import * as _wrapNativeSuper2 from "@babel/runtime/helpers/wrapNativeSuper";
var _wrapNativeSuper = _wrapNativeSuper2;
try {
  if ("default" in _wrapNativeSuper2) _wrapNativeSuper = _wrapNativeSuper2.default;
} catch (e) {}
import * as _createClass2 from "@babel/runtime/helpers/createClass";
var _createClass = _createClass2;
try {
  if ("default" in _createClass2) _createClass = _createClass2.default;
} catch (e) {}
var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
/*! For license information please see index.js.LICENSE.txt */
!function () {
  var e = {
      293: function (e) {
        self, e.exports = function () {
          "use strict";

          var e = {
              228: function (e) {
                var t = Object.prototype.hasOwnProperty,
                  n = "~";
                function r() {}
                function i(e, t, n) {
                  (this || _global).fn = e, (this || _global).context = t, (this || _global).once = n || !1;
                }
                function o(e, t, r, o, a) {
                  if ("function" != typeof r) throw new TypeError("The listener must be a function");
                  var s = new i(r, o || e, a),
                    u = n ? n + t : t;
                  return e._events[u] ? e._events[u].fn ? e._events[u] = [e._events[u], s] : e._events[u].push(s) : (e._events[u] = s, e._eventsCount++), e;
                }
                function a(e, t) {
                  0 == --e._eventsCount ? e._events = new r() : delete e._events[t];
                }
                function s() {
                  (this || _global)._events = new r(), (this || _global)._eventsCount = 0;
                }
                Object.create && (r.prototype = Object.create(null), new r().__proto__ || (n = !1)), s.prototype.eventNames = function () {
                  var e,
                    r,
                    i = [];
                  if (0 === (this || _global)._eventsCount) return i;
                  for (r in e = (this || _global)._events) t.call(e, r) && i.push(n ? r.slice(1) : r);
                  return Object.getOwnPropertySymbols ? i.concat(Object.getOwnPropertySymbols(e)) : i;
                }, s.prototype.listeners = function (e) {
                  var t = n ? n + e : e,
                    r = (this || _global)._events[t];
                  if (!r) return [];
                  if (r.fn) return [r.fn];
                  for (var i = 0, o = r.length, a = new Array(o); i < o; i++) a[i] = r[i].fn;
                  return a;
                }, s.prototype.listenerCount = function (e) {
                  var t = n ? n + e : e,
                    r = (this || _global)._events[t];
                  return r ? r.fn ? 1 : r.length : 0;
                }, s.prototype.emit = function (e, t, r, i, o, a) {
                  var s = n ? n + e : e;
                  if (!(this || _global)._events[s]) return !1;
                  var u,
                    c,
                    d = (this || _global)._events[s],
                    l = arguments.length;
                  if (d.fn) {
                    switch (d.once && this.removeListener(e, d.fn, void 0, !0), l) {
                      case 1:
                        return d.fn.call(d.context), !0;
                      case 2:
                        return d.fn.call(d.context, t), !0;
                      case 3:
                        return d.fn.call(d.context, t, r), !0;
                      case 4:
                        return d.fn.call(d.context, t, r, i), !0;
                      case 5:
                        return d.fn.call(d.context, t, r, i, o), !0;
                      case 6:
                        return d.fn.call(d.context, t, r, i, o, a), !0;
                    }
                    for (c = 1, u = new Array(l - 1); c < l; c++) u[c - 1] = arguments[c];
                    d.fn.apply(d.context, u);
                  } else {
                    var f,
                      h = d.length;
                    for (c = 0; c < h; c++) switch (d[c].once && this.removeListener(e, d[c].fn, void 0, !0), l) {
                      case 1:
                        d[c].fn.call(d[c].context);
                        break;
                      case 2:
                        d[c].fn.call(d[c].context, t);
                        break;
                      case 3:
                        d[c].fn.call(d[c].context, t, r);
                        break;
                      case 4:
                        d[c].fn.call(d[c].context, t, r, i);
                        break;
                      default:
                        if (!u) for (f = 1, u = new Array(l - 1); f < l; f++) u[f - 1] = arguments[f];
                        d[c].fn.apply(d[c].context, u);
                    }
                  }
                  return !0;
                }, s.prototype.on = function (e, t, n) {
                  return o(this || _global, e, t, n, !1);
                }, s.prototype.once = function (e, t, n) {
                  return o(this || _global, e, t, n, !0);
                }, s.prototype.removeListener = function (e, t, r, i) {
                  var o = n ? n + e : e;
                  if (!(this || _global)._events[o]) return this || _global;
                  if (!t) return a(this || _global, o), this || _global;
                  var s = (this || _global)._events[o];
                  if (s.fn) s.fn !== t || i && !s.once || r && s.context !== r || a(this || _global, o);else {
                    for (var u = 0, c = [], d = s.length; u < d; u++) (s[u].fn !== t || i && !s[u].once || r && s[u].context !== r) && c.push(s[u]);
                    c.length ? (this || _global)._events[o] = 1 === c.length ? c[0] : c : a(this || _global, o);
                  }
                  return this || _global;
                }, s.prototype.removeAllListeners = function (e) {
                  var t;
                  return e ? (t = n ? n + e : e, (this || _global)._events[t] && a(this || _global, t)) : ((this || _global)._events = new r(), (this || _global)._eventsCount = 0), this || _global;
                }, s.prototype.off = s.prototype.removeListener, s.prototype.addListener = s.prototype.on, s.prefixed = n, s.EventEmitter = s, e.exports = s;
              },
              815: function (e, t) {
                var n,
                  r,
                  i = (this || _global) && (this || _global).__extends || (n = function (e, t) {
                    return n = Object.setPrototypeOf || {
                      __proto__: []
                    } instanceof Array && function (e, t) {
                      e.__proto__ = t;
                    } || function (e, t) {
                      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }, n(e, t);
                  }, function (e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function r() {
                      (this || _global).constructor = e;
                    }
                    n(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
                  });
                function o(e) {
                  return 60 * e * 60;
                }
                function a(e) {
                  return 60 * e * 60 * 24;
                }
                Object.defineProperty(t, "__esModule", {
                  value: !0
                }), t.daysToSeconds = t.hoursToSeconds = t.DeviceConfigPropertyHolder = t.DeviceConfigManager = t.DeviceConfigEnv = void 0, function (e) {
                  e.BETA = "beta", e.PROD = "prod", e.CUSTOM = "custom";
                }(r || (t.DeviceConfigEnv = r = {})), t.hoursToSeconds = o, t.daysToSeconds = a;
                var s = function (e) {
                    function t(t) {
                      return e.call(this || _global, t) || this || _global;
                    }
                    return i(t, e), t;
                  }(Error),
                  u = "data",
                  c = o(1),
                  d = a(3),
                  l = o(2),
                  f = "base64",
                  h = function () {
                    function e(e, t) {
                      var n, i, o, a, s, f, h, v;
                      if (!t.fileKey) throw new Error("options.fileKey cannot be empty");
                      var p = null !== (n = t.clock) && void 0 !== n ? n : new T(),
                        y = p.getMillis();
                      switch ((this || _global).context = e, (this || _global).fileKey = t.fileKey, (this || _global).env = t.standardEnv, t.standardEnv) {
                        case r.BETA:
                          (this || _global).fetchServer = "beta.ivs-device-config-beta.live-video.net";
                          break;
                        case r.PROD:
                          (this || _global).fetchServer = "prod.ivs-device-config.live-video.net";
                          break;
                        case r.CUSTOM:
                          if (!t.customServer) throw new Error("Custom env requires options.customServer");
                          (this || _global).fetchServer = t.customServer;
                          break;
                        default:
                          throw new Error("Invalid value for standardEnv: ".concat(t.standardEnv));
                      }
                      (this || _global).trace = null !== (i = t.trace) && void 0 !== i ? i : new g((this || _global).env), (this || _global).fetch = null !== (o = t.fetch) && void 0 !== o ? o : new m(e), (this || _global).storage = new E("amazon_ivs_device_config_v1_" + t.fileKey, e.localStorage), (this || _global).state = new _((this || _global).storage, "state"), (this || _global).refresh = {
                        refreshIntervalSeconds: null !== (a = t.refresh.refreshIntervalSeconds) && void 0 !== a ? a : c,
                        retryCount: null !== (s = t.refresh.retryCount) && void 0 !== s ? s : 3,
                        retryIntervalSeconds: null !== (f = t.refresh.retryIntervalSeconds) && void 0 !== f ? f : 10,
                        maxCacheAgeSeconds: null !== (h = t.refresh.maxCacheAgeSeconds) && void 0 !== h ? h : d,
                        stopRefreshAfterSeconds: null !== (v = t.refresh.stopRefreshAfterSeconds) && void 0 !== v ? v : l,
                        canRefreshNow: t.refresh.canRefreshNow
                      }, (this || _global).emitMetrics = t.emitMetrics, (this || _global).clock = p, (this || _global).isInitialRefreshDone = !1;
                      var S = 0,
                        b = (this || _global).state.getState();
                      b && b.fetchServer === (this || _global).fetchServer && b.lastFetchWhenMs && (S = b.lastFetchWhenMs);
                      var C = p.getMillis(),
                        w = (C - S) / 1000;
                      if (w <= (this || _global).refresh.maxCacheAgeSeconds) {
                        var k = (this || _global).storage.getJson(u);
                        k && k.fetchServer === (this || _global).fetchServer && this.setData(k.json);
                      }
                      if ((this || _global).lastUseMs = C, w >= (this || _global).refresh.refreshIntervalSeconds || 0 == S) (this || _global).trace.onTrace("Will start refresh right now"), (this || _global).fetchTask = (this || _global).context.setTimeout((this || _global).startRefresh.bind(this || _global), 0);else {
                        var I = Math.round((this || _global).refresh.refreshIntervalSeconds - w);
                        (this || _global).trace.onTrace("Will start refresh in " + I + " seconds"), (this || _global).fetchTask = (this || _global).context.setTimeout((this || _global).startRefresh.bind(this || _global), 1000 * I), (this || _global).isInitialRefreshDone = !0;
                      }
                      var P = p.getMillis();
                      (this || _global).initialLoadTime = P - y;
                    }
                    return e.getInstance = function (t, n) {
                      try {
                        if (!(t.fetch && t.setTimeout && t.clearTimeout && t.localStorage)) return void console.log("Context needs to provide fetch, setTimeout, clearTimeout, localStorage");
                      } catch (e) {
                        return void console.error("Error checking for context properties " + e);
                      }
                      if ((this || _global).gInstance) {
                        if ((this || _global).gInstance.fileKey != n.fileKey) throw new Error("Existing instance has file key ".concat((this || _global).gInstance.fileKey, ", now asking for ").concat(n.fileKey));
                        return (this || _global).gInstance;
                      }
                      return (this || _global).gInstance = new e(t, n), (this || _global).gInstance;
                    }, e.prototype.getConfigurationHolder = function (e) {
                      var t,
                        n = (this || _global).clock.getMillis();
                      (this || _global).lastUseMs = n;
                      var r = null !== (t = e.analytics) && void 0 !== t ? t : new y((this || _global).env),
                        i = 0,
                        o = (this || _global).state.getState();
                      return o && o.fetchServer === (this || _global).fetchServer && o.lastFetchWhenMs && (i = o.lastFetchWhenMs), (n - i) / 1000 <= (this || _global).refresh.maxCacheAgeSeconds ? new v(r, (this || _global).properties) : new v(r, void 0);
                    }, e.prototype.getFetchUrl = function () {
                      var e = "https://".concat((this || _global).fetchServer, "/").concat((this || _global).fileKey, ".json"),
                        t = new URL(e);
                      return t.searchParams.set("version", "1.0"), t;
                    }, e.clearInstance = function () {
                      var e;
                      null === (e = (this || _global).gInstance) || void 0 === e || e.clearInstanceImpl(), (this || _global).gInstance = void 0;
                    }, e.prototype.clearInstanceImpl = function () {
                      (this || _global).context.clearTimeout((this || _global).fetchTask), (this || _global).fetchTask = void 0, (this || _global).context.clearTimeout((this || _global).retryTask), (this || _global).retryTask = void 0;
                    }, e.prototype.startRefresh = function () {
                      var e = this || _global;
                      (this || _global).trace.onTrace("Starting refresh request..."), (this || _global).fetchTask = void 0, (this || _global).retryTask && ((this || _global).context.clearTimeout((this || _global).retryTask), (this || _global).retryTask = void 0);
                      var t = (this || _global).clock.getMillis();
                      if ((t - (this || _global).lastUseMs) / 1000 > (this || _global).refresh.stopRefreshAfterSeconds) return (this || _global).trace.onTrace("Actually will not refresh due to refresh timeout"), void ((this || _global).fetchTask = (this || _global).context.setTimeout((this || _global).startRefresh.bind(this || _global), 1000 * (this || _global).refresh.refreshIntervalSeconds));
                      if ((this || _global).isInitialRefreshDone && !(this || _global).refresh.canRefreshNow()) return (this || _global).trace.onTrace("Will not refresh due to callback having returned false"), void ((this || _global).fetchTask = (this || _global).context.setTimeout((this || _global).startRefresh.bind(this || _global), 1000 * (this || _global).refresh.refreshIntervalSeconds));
                      var n = {};
                      this.fetchData().then(function (r) {
                        e.processResponse(r, n, t);
                      }).catch(function (t) {
                        e.exceptionMetrics(n, t), e.trace.onTrace("Fetch error: " + t), e.refresh.retryCount > 0 && e.scheduleRetry(1);
                      }).finally(function () {
                        e.isInitialRefreshDone = !0, e.emitMetricsImpl(n), e.fetchTask = e.context.setTimeout(e.startRefresh.bind(e), 1000 * e.refresh.refreshIntervalSeconds);
                      });
                    }, e.prototype.fetchData = function () {
                      var e = this.getFetchUrl(),
                        t = new Headers(),
                        n = (this || _global).state.getState();
                      return n.fetchServer === (this || _global).fetchServer && (n.lastFetchWhenFullMs && (this || _global).clock.getMillis() - n.lastFetchWhenFullMs > 1000 * o(24) ? (this || _global).trace.onTrace("Forcing full refresh") : (this || _global).properties && n.lastFetchEtagHeader && t.set("If-None-Match", n.lastFetchEtagHeader)), (this || _global).fetch.fetchUrl(e, t);
                    }, e.prototype.processResponse = function (e, t, n) {
                      var r = {
                          fetchServer: (this || _global).fetchServer,
                          lastFetchWhenMs: (this || _global).clock.getMillis()
                        },
                        i = e.headers.get("etag");
                      i && (r.lastFetchEtagHeader = i);
                      try {
                        if (e.status < 300 && e.json) {
                          if (this.setData(e.json)) {
                            (this || _global).trace.onTrace("Successfully parsed fetched data"), (this || _global).storage.setJson(u, {
                              fetchServer: (this || _global).fetchServer,
                              json: e.json
                            });
                            var o = (this || _global).clock.getMillis();
                            r.lastFetchWhenFullMs = o, t.success_new_data_count = 1, t.fetch_duration_average = Math.max(0, o - n);
                          } else t.fail_invalid_data_count = 1;
                        } else {
                          if (304 !== e.status) {
                            var a = "Unexpected http fetch status: " + e.status;
                            throw (this || _global).trace.onTrace(a), new s(a);
                          }
                          (this || _global).trace.onTrace("Server said no change in data"), o = (this || _global).clock.getMillis(), r.lastFetchWhenMs = o, t.success_no_change_count = 1, t.fetch_duration_average = Math.max(0, o - n);
                        }
                      } finally {
                        (this || _global).state.setState(r);
                      }
                    }, e.prototype.scheduleRetry = function (e) {
                      var t = this || _global;
                      (this || _global).retryTask && (this || _global).context.clearTimeout((this || _global).retryTask);
                      var n = e * (this || _global).refresh.retryIntervalSeconds;
                      (this || _global).retryTask = (this || _global).context.setTimeout(function () {
                        t.retryTask = void 0, t.fetchRetry(e);
                      }, 1000 * n);
                    }, e.prototype.fetchRetry = function (e) {
                      var t = this || _global;
                      (this || _global).trace.onTrace("Starting retry request ".concat(e, "..."));
                      var n = {},
                        r = (this || _global).clock.getMillis();
                      this.fetchData().then(function (e) {
                        t.processResponse(e, n, r);
                      }).catch(function (r) {
                        t.exceptionMetrics(n, r), t.trace.onTrace("Fetch error: " + r), t.refresh.retryCount > e && t.scheduleRetry(e + 1);
                      }).finally(function () {
                        t.emitMetricsImpl(n);
                      });
                    }, e.prototype.setData = function (e) {
                      if (!e) return !1;
                      if ("1.0" !== e.version) return (this || _global).trace.onTrace("Data version is not 1.0, not applying"), !1;
                      var t = e.properties;
                      if (!t || !Array.isArray(t)) return (this || _global).trace.onTrace("Data properties is not an array, not applying"), !1;
                      for (var n = new Map(), r = 0, i = t; r < i.length; r++) {
                        var o = i[r];
                        if (o.name && o.type && this.isValidValueType(o.type)) {
                          if (o.value_string && "string" != typeof o.value_string) {
                            (this || _global).trace.onTrace("Invalid type of value.value_string " + typeof o.value_string);
                            continue;
                          }
                          if (o.value_number && "number" != typeof o.value_number) {
                            (this || _global).trace.onTrace("Invalid type of value.value_number " + typeof o.value_number);
                            continue;
                          }
                          if (o.value_boolean && "boolean" != typeof o.value_boolean) {
                            (this || _global).trace.onTrace("Invalid type of value.value_boolean " + typeof o.value_boolean);
                            continue;
                          }
                          if (o.value_json && "string" != typeof o.value_json) {
                            (this || _global).trace.onTrace("Invalid type of value.value_json " + typeof o.value_json);
                            continue;
                          }
                          if (o.value_analytics && "string" != typeof o.value_analytics) {
                            (this || _global).trace.onTrace("Invalid type of item.value_analytics " + typeof o.value_analytics);
                            continue;
                          }
                          var a = new S(o.name, this.parseValueType(o.type), o.value_string, o.value_number, o.value_boolean, o.value_json, o.value_analytics, o.encoding);
                          n.set(a.name, a);
                        }
                      }
                      return 0 != n.size && ((this || _global).properties = n, !0);
                    }, e.prototype.isValidValueType = function (e) {
                      return "string" === e || "number" === e || "boolean" === e || "json" == e;
                    }, e.prototype.parseValueType = function (e) {
                      switch (e) {
                        case "string":
                          return p.STRING;
                        case "number":
                          return p.NUMBER;
                        case "boolean":
                          return p.BOOLEAN;
                        case "json":
                          return p.JSON;
                        default:
                          throw new Error("Unsupported value type ".concat(e));
                      }
                    }, e.prototype.emitMetricsImpl = function (e) {
                      var t,
                        n,
                        r,
                        i,
                        o,
                        a,
                        s = {
                          initial_load_time: (this || _global).initialLoadTime,
                          fetch_attempt_count: 1,
                          fetch_duration_average: null !== (t = e.fetch_duration_average) && void 0 !== t ? t : 0,
                          success_no_change_count: null !== (n = e.success_no_change_count) && void 0 !== n ? n : 0,
                          success_new_data_count: null !== (r = e.success_new_data_count) && void 0 !== r ? r : 0,
                          fail_exception_count: null !== (i = e.fail_exception_count) && void 0 !== i ? i : 0,
                          fail_http_error_count: null !== (o = e.fail_http_error_count) && void 0 !== o ? o : 0,
                          fail_invalid_data_count: null !== (a = e.fail_invalid_data_count) && void 0 !== a ? a : 0
                        };
                      this.emitMetrics(s);
                    }, e.prototype.exceptionMetrics = function (e, t) {
                      t instanceof s || t.message.startsWith("http error") ? e.fail_http_error_count = 1 : e.fail_exception_count = 1;
                    }, e;
                  }();
                t.DeviceConfigManager = h;
                var v = function () {
                  function e(e, t) {
                    (this || _global).analytics = e, (this || _global).properties = t;
                  }
                  return e.prototype.getSize = function () {
                    return (this || _global).properties ? (this || _global).properties.size : -1;
                  }, e.prototype.getStringValue = function (e) {
                    var t, n;
                    if ((this || _global).properties) {
                      var r = (this || _global).properties.get(e);
                      if (r) {
                        if (r.type === p.STRING) {
                          var i = null !== (t = r.valueString) && void 0 !== t ? t : "";
                          return (this || _global).analytics.onValue(e, null !== (n = r.valueAnalytics) && void 0 !== n ? n : i), i;
                        }
                        (this || _global).analytics.onError(e, "Type is not string");
                      }
                    } else (this || _global).analytics.onTrace(e, "Configuration is not available");
                  }, e.prototype.getNumberValue = function (e) {
                    var t, n;
                    if ((this || _global).properties) {
                      var r = (this || _global).properties.get(e);
                      if (r) {
                        if (r.type === p.NUMBER) {
                          var i = null !== (t = r.valueNumber) && void 0 !== t ? t : 0;
                          return (this || _global).analytics.onValue(e, null !== (n = r.valueAnalytics) && void 0 !== n ? n : i.toString()), i;
                        }
                        (this || _global).analytics.onError(e, "Type is not number");
                      }
                    } else (this || _global).analytics.onTrace(e, "Configuration is not available");
                  }, e.prototype.getBooleanValue = function (e) {
                    var t, n;
                    if ((this || _global).properties) {
                      var r = (this || _global).properties.get(e);
                      if (r) {
                        if (r.type === p.BOOLEAN) {
                          var i = null !== (t = r.valueBoolean) && void 0 !== t && t;
                          return (this || _global).analytics.onValue(e, null !== (n = r.valueAnalytics) && void 0 !== n ? n : i.toString()), i;
                        }
                        (this || _global).analytics.onError(e, "Type is not boolean");
                      }
                    } else (this || _global).analytics.onTrace(e, "Configuration is not available");
                  }, e.prototype.getJsonValue = function (e) {
                    var t, n;
                    if ((this || _global).properties) {
                      var r = (this || _global).properties.get(e);
                      if (r) {
                        if (r.type === p.JSON) {
                          var i = r.valueJson;
                          if (!i) return (this || _global).analytics.onValue(e, null !== (t = r.valueAnalytics) && void 0 !== t ? t : ""), null;
                          try {
                            var o = JSON.parse(i);
                            return (this || _global).analytics.onValue(e, null !== (n = r.valueAnalytics) && void 0 !== n ? n : i), o;
                          } catch (t) {
                            return void (this || _global).analytics.onError(e, "Json parse error");
                          }
                        }
                        (this || _global).analytics.onError(e, "Type is not json");
                      }
                    } else (this || _global).analytics.onTrace(e, "Configuration is not available");
                  }, e;
                }();
                t.DeviceConfigPropertyHolder = v;
                var p,
                  m = function () {
                    function e(e) {
                      (this || _global).context = e;
                    }
                    return e.prototype.fetchUrl = function (e, t) {
                      var n = this || _global;
                      return new Promise(function (r, i) {
                        n.context.fetch(e, {
                          headers: t,
                          cache: "no-store"
                        }).then(function (e) {
                          if (e.status >= 400) i(new s("http error ".concat(e.status, ", ").concat(e.statusText)));else {
                            var t = {
                              status: e.status,
                              headers: e.headers
                            };
                            e.json().then(function (e) {
                              t.json = e;
                            }).catch(function () {}).finally(function () {
                              r(t);
                            });
                          }
                        }).catch(function (e) {
                          i(e);
                        });
                      });
                    }, e;
                  }(),
                  g = function () {
                    function e(e) {
                      (this || _global).env = e;
                    }
                    return e.prototype.onTrace = function (e) {
                      (this || _global).env != r.PROD && console.log("DeviceConfig: " + e);
                    }, e;
                  }(),
                  y = function () {
                    function e(e) {
                      (this || _global).env = e;
                    }
                    return e.prototype.onValue = function (e, t) {
                      (this || _global).env != r.PROD && console.log("Configuration for ".concat(e, ": value = ").concat(t));
                    }, e.prototype.onError = function (e, t) {
                      (this || _global).env != r.PROD && console.error("Configuration for ".concat(e, ": error = ").concat(t));
                    }, e.prototype.onTrace = function (e, t) {
                      (this || _global).env != r.PROD && console.log("Configuration for ".concat(e, ": trace = ").concat(t));
                    }, e;
                  }(),
                  E = function () {
                    function e(e, t) {
                      (this || _global).prefix = e, (this || _global).storage = t;
                    }
                    return e.prototype.getJson = function (e) {
                      var t = (this || _global).prefix + "_" + e;
                      try {
                        var n = (this || _global).storage.getItem(t);
                        if (n) return JSON.parse(n);
                      } catch (e) {
                        console.error("Error getting local storage key ".concat(t) + e);
                      }
                      return null;
                    }, e.prototype.setJson = function (e, t) {
                      var n = (this || _global).prefix + "_" + e;
                      try {
                        (this || _global).storage.setItem(n, JSON.stringify(t));
                      } catch (e) {
                        console.error("Error setting local storage key ".concat(n, ": ") + e);
                      }
                    }, e;
                  }(),
                  T = function () {
                    function e() {}
                    return e.prototype.getMillis = function () {
                      return Date.now();
                    }, e;
                  }();
                !function (e) {
                  e[e.STRING = 0] = "STRING", e[e.NUMBER = 1] = "NUMBER", e[e.BOOLEAN = 2] = "BOOLEAN", e[e.JSON = 3] = "JSON";
                }(p || (p = {}));
                var S = function (e, t, n, r, i, o, a, s) {
                    switch ((this || _global).name = e, (this || _global).type = t, (this || _global).valueString = n, (this || _global).valueNumber = r, (this || _global).valueBoolean = i, (this || _global).valueJson = o, (this || _global).valueAnalytics = a, (this || _global).type) {
                      case p.STRING:
                        s === f && n && ((this || _global).valueString = atob(n));
                        break;
                      case p.JSON:
                        s === f && o && ((this || _global).valueJson = atob(o));
                    }
                  },
                  _ = function () {
                    function e(e, t) {
                      var n;
                      (this || _global).storage = e, (this || _global).key = t, (this || _global).state = null !== (n = e.getJson(t)) && void 0 !== n ? n : {};
                    }
                    return e.prototype.getState = function () {
                      return (this || _global).state;
                    }, e.prototype.setState = function (e) {
                      Object.assign((this || _global).state, e), (this || _global).storage.setJson((this || _global).key, (this || _global).state);
                    }, e;
                  }();
              },
              456: function (e, t, n) {
                var r = (this || _global) && (this || _global).__createBinding || (Object.create ? function (e, t, n, r) {
                    void 0 === r && (r = n);
                    var i = Object.getOwnPropertyDescriptor(t, n);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                      enumerable: !0,
                      get: function () {
                        return t[n];
                      }
                    }), Object.defineProperty(e, r, i);
                  } : function (e, t, n, r) {
                    void 0 === r && (r = n), e[r] = t[n];
                  }),
                  i = (this || _global) && (this || _global).__exportStar || function (e, t) {
                    for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
                  };
                Object.defineProperty(t, "__esModule", {
                  value: !0
                }), i(n(903), t);
              },
              903: function (e, t, n) {
                var r = (this || _global) && (this || _global).__spreadArray || function (e, t, n) {
                  if (n || 2 === arguments.length) for (var r, i = 0, o = t.length; i < o; i++) !r && i in t || (r || (r = Array.prototype.slice.call(t, 0, i)), r[i] = t[i]);
                  return e.concat(r || Array.prototype.slice.call(t));
                };
                Object.defineProperty(t, "__esModule", {
                  value: !0
                }), t.TypedEmitter = void 0;
                var i = n(228),
                  o = function () {
                    function e(e) {
                      var t = e.propagateErrors;
                      (this || _global).emitter = new i.EventEmitter(), (this || _global).propagateErrors = null != t && t;
                    }
                    return e.prototype.on = function (e, t) {
                      t.call = this.wrapCall(e, t), (this || _global).emitter.on(e, t);
                    }, e.prototype.off = function (e, t) {
                      (this || _global).emitter.off(e, t);
                    }, e.prototype.emit = function (e) {
                      for (var t, n = [], i = 1; i < arguments.length; i++) n[i - 1] = arguments[i];
                      (t = (this || _global).emitter).emit.apply(t, r([e], n, !1));
                    }, e.prototype.removeAllListeners = function () {
                      (this || _global).emitter.removeAllListeners();
                    }, e.prototype.wrapCall = function (e, t) {
                      var n = this || _global;
                      return function (r) {
                        for (var i = [], o = 1; o < arguments.length; o++) i[o - 1] = arguments[o];
                        if (n.propagateErrors) t.apply(r, i);else try {
                          t.apply(r, i);
                        } catch (n) {
                          var a = "Error in callback for ".concat(e),
                            s = t.name;
                          return s && (a += " for function ".concat(s)), void console.error(a, n);
                        }
                      };
                    }, e;
                  }();
                t.TypedEmitter = o;
              },
              987: function (e, t, n) {
                var r,
                  i = (this || _global) && (this || _global).__extends || (r = function (e, t) {
                    return r = Object.setPrototypeOf || {
                      __proto__: []
                    } instanceof Array && function (e, t) {
                      e.__proto__ = t;
                    } || function (e, t) {
                      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
                    }, r(e, t);
                  }, function (e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
                    function n() {
                      (this || _global).constructor = e;
                    }
                    r(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
                  }),
                  o = (this || _global) && (this || _global).__createBinding || (Object.create ? function (e, t, n, r) {
                    void 0 === r && (r = n);
                    var i = Object.getOwnPropertyDescriptor(t, n);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                      enumerable: !0,
                      get: function () {
                        return t[n];
                      }
                    }), Object.defineProperty(e, r, i);
                  } : function (e, t, n, r) {
                    void 0 === r && (r = n), e[r] = t[n];
                  }),
                  a = (this || _global) && (this || _global).__setModuleDefault || (Object.create ? function (e, t) {
                    Object.defineProperty(e, "default", {
                      enumerable: !0,
                      value: t
                    });
                  } : function (e, t) {
                    e.default = t;
                  }),
                  s = (this || _global) && (this || _global).__importStar || function (e) {
                    if (e && e.__esModule) return e;
                    var t = {};
                    if (null != e) for (var n in e) "default" !== n && Object.prototype.hasOwnProperty.call(e, n) && o(t, e, n);
                    return a(t, e), t;
                  };
                Object.defineProperty(t, "__esModule", {
                  value: !0
                }), t.createFsm = t.FsmWildcardState = t.RejectedTransitionError = t.InvalidStateTransitionError = void 0;
                var u = s(n(293)),
                  c = function (e) {
                    function t(t, n) {
                      var r = e.call(this || _global, "Invalid transition from '".concat(n, "' via event '").concat(t, "'")) || this || _global;
                      return r.name = "InvalidStateTransitionError", r;
                    }
                    return i(t, e), t;
                  }(Error);
                t.InvalidStateTransitionError = c;
                var d = function (e) {
                  function t(t, n, r) {
                    var i = e.call(this || _global, "Transition from '".concat(n, "' via event '").concat(t, "' was rejected for: ").concat(r)) || this || _global;
                    return i.name = "RejectedTransitionError", i;
                  }
                  return i(t, e), t;
                }(Error);
                t.RejectedTransitionError = d, t.FsmWildcardState = "*", t.createFsm = function (e) {
                  var n,
                    r = e.transitions,
                    i = e.callbacks,
                    o = e.initialState,
                    a = function (e) {
                      var n,
                        i = null === (n = r[e]) || void 0 === n ? void 0 : n.from;
                      return !!i && ("string" == typeof i ? i === t.FsmWildcardState : i.includes(o));
                    };
                  return {
                    canTransition: a,
                    transition: function (e, t) {
                      var s, l, f, h, v, p;
                      if (!a(e)) return u.err(new c(String(o), String(e)));
                      var m = r[e];
                      return void 0 === m.shouldTransition || m.shouldTransition(o) ? (null === (l = null === (s = null == i ? void 0 : i[o]) || void 0 === s ? void 0 : s.onExiting) || void 0 === l || l.call(s), null === (f = null == i ? void 0 : i.onStateExiting) || void 0 === f || f.call(i, o), n = o, o = m.to, null === (v = null === (h = null == i ? void 0 : i[o]) || void 0 === h ? void 0 : h.onChanged) || void 0 === v || v.call(h, n, t), null === (p = null == i ? void 0 : i.onStateChanged) || void 0 === p || p.call(i, n, o, t), u.ok(o)) : u.err(new d(String(o), String(e), "shouldTransition returned false"));
                    },
                    previousState: function () {
                      return n;
                    },
                    currentState: function () {
                      return o;
                    }
                  };
                };
              },
              156: function (e, t, n) {
                var r = (this || _global) && (this || _global).__createBinding || (Object.create ? function (e, t, n, r) {
                    void 0 === r && (r = n);
                    var i = Object.getOwnPropertyDescriptor(t, n);
                    i && !("get" in i ? !t.__esModule : i.writable || i.configurable) || (i = {
                      enumerable: !0,
                      get: function () {
                        return t[n];
                      }
                    }), Object.defineProperty(e, r, i);
                  } : function (e, t, n, r) {
                    void 0 === r && (r = n), e[r] = t[n];
                  }),
                  i = (this || _global) && (this || _global).__exportStar || function (e, t) {
                    for (var n in e) "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
                  };
                Object.defineProperty(t, "__esModule", {
                  value: !0
                }), t.VERSION = void 0, t.VERSION = "0.4.2", i(n(815), t), i(n(456), t), i(n(987), t), i(n(293), t);
              },
              293: function (e, t) {
                Object.defineProperty(t, "__esModule", {
                  value: !0
                }), t.getErr = t.getOk_or = t.getOk = t.isNotOk = t.isOk = t.err = t.ok = void 0, t.ok = function (e) {
                  return {
                    ok: !0,
                    value: e
                  };
                }, t.err = function (e) {
                  return {
                    ok: !1,
                    error: e
                  };
                }, t.isOk = function (e) {
                  return !0 === e.ok;
                }, t.isNotOk = function (e) {
                  return !(0, t.isOk)(e);
                }, t.getOk = function (e) {
                  return !0 === e.ok ? e.value : void 0;
                }, t.getOk_or = function (e, t) {
                  return !0 === e.ok ? e.value : t;
                }, t.getErr = function (e) {
                  return !0 === e.ok ? void 0 : e.error;
                };
              }
            },
            t = {};
          return function n(r) {
            var i = t[r];
            if (void 0 !== i) return i.exports;
            var o = t[r] = {
              exports: {}
            };
            return e[r].call(o.exports, o, o.exports, n), o.exports;
          }(156);
        }();
      },
      967: function (e, t, n) {
        "use strict";

        n.d(t, {
          cp: function () {
            return d;
          }
        });
        var r = _bowser,
          i = n(446),
          o = /^(\d+)\.(\d+)\.(\d+)[+|-]?(.*)?$/,
          a = /^(\d+)\.(\d+)[+|-]?(.*)?$/,
          s = /^(\d+)$/,
          u = {
            chrome: !1,
            chromecast: !1,
            domain: "",
            electron: !1,
            family: "",
            firefox: !1,
            host: "",
            major: -1,
            minor: -1,
            msEdgeLegacy: !1,
            msEdgeChromium: !1,
            msIE: !1,
            name: "",
            opera: !1,
            osName: "",
            osVersion: "",
            patch: -1,
            safari: !1,
            url: "",
            userAgent: "",
            mobile: !1,
            supportsDataChannels: !1,
            supportsWebTransport: !1,
            supportsMSEInWorkers: !1
          },
          c = null;
        function d() {
          if (c) return c;
          if ("undefined" == typeof window || "undefined" == typeof navigator) return c = u;
          var e,
            t,
            n = r.getParser(navigator.userAgent),
            d = (e = String(n.getBrowserVersion()), t = o.exec(e) || a.exec(e) || s.exec(e) || [], {
              major: parseInt(t[1], 10) || 0,
              minor: parseInt(t[2], 10) || 0,
              patch: parseInt(t[3], 10) || 0
            }),
            l = n.getEngine();
          return c = {
            chrome: !!n.some(["chrome"]),
            chromecast: navigator.userAgent.toLowerCase().indexOf("crkey") > -1,
            domain: window.location.host.split(".").slice(-2).join("."),
            electron: !!n.some(["electron"]),
            family: n.getBrowserName().toLowerCase(),
            firefox: !!n.some(["firefox"]),
            host: window.location.host,
            major: d.major,
            minor: d.minor,
            msEdgeLegacy: !!n.some(["microsoft edge"]) && "Blink" !== l.name,
            msEdgeChromium: !!n.some(["microsoft edge"]) && "Blink" === l.name,
            msIE: !!n.some(["internet explorer"]),
            name: navigator.appVersion,
            opera: !!n.some(["opera"]),
            osName: n.getOSName(),
            osVersion: String(n.getOSVersion()),
            patch: d.patch,
            safari: !!n.some(["safari"]),
            url: window.location.href,
            userAgent: navigator.userAgent,
            mobile: !(!n.some(["mobile"]) && !n.some(["tablet"])),
            supportsDataChannels: "RTCPeerConnection" in window,
            supportsWebTransport: "WebTransport" in window,
            supportsMSEInWorkers: i.Z.isSupportedInWorker()
          };
        }
      },
      856: function (e, t, n) {
        "use strict";

        n.d(t, {
          YJ: function () {
            return s;
          },
          aP: function () {
            return i;
          },
          bz: function () {
            return o;
          },
          dq: function () {
            return a;
          }
        });
        var r = n(967);
        function i() {
          return "undefined" != typeof MediaSource;
        }
        function o() {
          var e = "video/mp4; codecs=\"hvc1.1.40000000.L60.80.0.0.0.0.0\"";
          return i() ? MediaSource.isTypeSupported(e) : "" !== document.createElement("video").canPlayType(e);
        }
        function a() {
          var e = "video/mp4; codecs=\"av01.0.05M.08\"";
          return i() ? MediaSource.isTypeSupported(e) : "" !== document.createElement("video").canPlayType(e);
        }
        function s() {
          var e = (0, r.cp)();
          return "Windows" === e.osName && (e.chrome || e.firefox || e.msEdgeChromium) && i() ? "mediaCapabilities" in navigator ? navigator.mediaCapabilities.decodingInfo({
            type: "media-source",
            video: {
              contentType: "video/mp4;codecs=\"vp09.00.41.08\"",
              width: 1920,
              height: 1080,
              bitrate: 8000000,
              framerate: 60
            }
          }).then(function (e) {
            return e.supported && e.smooth;
          }) : Promise.resolve(MediaSource.isTypeSupported("video/mp4;codecs=\"vp09.00.10.08\"")) : Promise.resolve(!1);
        }
      },
      296: function (e, t, n) {
        "use strict";

        n.d(t, {
          g: function () {
            return r;
          }
        });
        var r = function (e) {
          return e.UNKNOWN = "Unspecified", e.FILE = "File", e.SEGMENT = "Segment", e.SOURCE = "Source", e.DECODER = "Decode", e.RENDERER = "Render", e.MASTER_PLAYLIST = "MasterPlaylist", e.MEDIA_PLAYLIST = "MediaPlaylist", e.DRM = "DRM", e;
        }({});
      },
      949: function (e, t, n) {
        "use strict";

        n.d(t, {
          B: function () {
            return r;
          },
          y: function () {
            return i;
          }
        });
        var r = function (e) {
            return e.GENERIC = "Error", e.NOT_SUPPORTED = "ErrorNotSupported", e.NO_SOURCE = "ErrorNoSource", e.INVALID_DATA = "ErrorInvalidData", e.INVALID_STATE = "ErrorInvalidState", e.INVALID_PARAMETER = "ErrorInvalidParameter", e.TIMEOUT = "ErrorTimeout", e.NETWORK = "ErrorNetwork", e.NETWORK_IO = "ErrorNetworkIO", e.AUTHORIZATION = "ErrorAuthorization", e.NOT_AVAILABLE = "ErrorNotAvailable", e;
          }({}),
          i = function (e) {
            return e[e.GEOBLOCKED = 1] = "GEOBLOCKED", e[e.UNSUPPORTED_DEVICE = 2] = "UNSUPPORTED_DEVICE", e[e.ANONYMIZER_BLOCKED = 3] = "ANONYMIZER_BLOCKED", e[e.CELLULAR_NETWORK_PROHIBITED = 4] = "CELLULAR_NETWORK_PROHIBITED", e[e.UNAUTHORIZATION_ENTITLEMENTS = 5] = "UNAUTHORIZATION_ENTITLEMENTS", e[e.VOD_RESTRICTED = 6] = "VOD_RESTRICTED", e;
          }({});
      },
      601: function (e, t, n) {
        "use strict";

        n.d(t, {
          P: function () {
            return r;
          }
        });
        var r = function (e) {
          return e.CAPTURE_ENABLED = "CaptureEnabled", e.CAPTURE_BUNDLE = "CaptureBundle", e.CAPTURE_ANALYTICS = "CaptureAnalytics", e.FMP4_SEGMENT = "FMP4Segment", e;
        }({});
      },
      502: function (e, t, n) {
        "use strict";

        n.d(t, {
          C: function () {
            return r;
          },
          _: function () {
            return i;
          }
        });
        var r = function (e) {
            return e.ID3 = "MetaID3", e.CAPTION = "MetaCaption", e;
          }({}),
          i = function (e) {
            return e.METADATA_ID = "metadata.live-video.net", e.INBAND_METADATA_ID = "inband.metadata.live-video.net", e;
          }({});
      },
      338: function (e, t, n) {
        "use strict";

        n.d(t, {
          a: function () {
            return r;
          }
        });
        var r = function (e) {
          return e.INITIALIZED = "PlayerInitialized", e.QUALITY_CHANGED = "PlayerQualityChanged", e.DURATION_CHANGED = "PlayerDurationChanged", e.VOLUME_CHANGED = "PlayerVolumeChanged", e.MUTED_CHANGED = "PlayerMutedChanged", e.PLAYBACK_RATE_CHANGED = "PlayerPlaybackRateChanged", e.REBUFFERING = "PlayerRebuffering", e.AUDIO_BLOCKED = "PlayerAudioBlocked", e.PLAYBACK_BLOCKED = "PlayerPlaybackBlocked", e.ERROR = "PlayerError", e.RECOVERABLE_ERROR = "PlayerRecoverableError", e.ANALYTICS_EVENT = "PlayerAnalyticsEvent", e.TIME_UPDATE = "PlayerTimeUpdate", e.SYNC_TIME_UPDATE = "PlayerSyncTimeUpdate", e.BUFFER_UPDATE = "PlayerBufferUpdate", e.SEEK_COMPLETED = "PlayerSeekCompleted", e.SESSION_DATA = "PlayerSessionData", e.STATE_CHANGED = "PlayerStateChanged", e.WORKER_ERROR = "PlayerWorkerError", e.METADATA = "PlayerMetadata", e.TEXT_CUE = "PlayerTextCue", e.TEXT_METADATA_CUE = "PlayerTextMetadataCue", e.AD_CUE = "PlayerAdCue", e.STREAM_SOURCE_CUE = "PlayerStreamSourceCue", e.NETWORK_UNAVAILABLE = "PlayerNetworkUnavailable", e.SEGMENT_DISCONTINUITY = "PlayerSegmentDiscontinuity", e.SEGMENT_METADATA = "PlayerSegmentMetadata", e;
        }({});
      },
      385: function (e, t, n) {
        "use strict";

        n.d(t, {
          G: function () {
            return r;
          }
        });
        var r = function (e) {
          return e.AVAILABLE = "RemotePlayerAvailable", e.UNAVAILABLE = "RemotePlayerUnavailable", e.SESSION_STARTED = "RemotePlayerSessionStarted", e.SESSION_ENDED = "RemotePlayerSessionEnded", e;
        }({});
      },
      214: function (e, t, n) {
        "use strict";

        n.d(t, {
          p: function () {
            return r;
          }
        });
        var r = function (e) {
          return e.IDLE = "Idle", e.READY = "Ready", e.BUFFERING = "Buffering", e.PLAYING = "Playing", e.ENDED = "Ended", e;
        }({});
      },
      638: function (e, t, n) {
        "use strict";

        n.d(t, {
          KJ: function () {
            return fn;
          },
          vt: function () {
            return dn;
          },
          Zx: function () {
            return sn;
          },
          HF: function () {
            return ln;
          },
          i$: function () {
            return cn;
          },
          TH: function () {
            return un;
          }
        });
        var r = n(967),
          i = _extends,
          o = n.n(i),
          a = n(338),
          s = null,
          u = null;
        function c(e) {
          if (!e || !e.arg || !e.arg.name) return e;
          var t = e.type,
            n = e.arg,
            r = t === a.a.ANALYTICS_EVENT,
            i = "video-play" === n.name || "minute-watched" === n.name || "video_error" === n.name || n.name.includes("gpu_");
          if (!r || !i) return e;
          if (!s && !u) try {
            var o = document.createElement("canvas"),
              c = o.getContext("webgl") || o.getContext("experimental-webgl");
            if (c && "getExtension" in c) {
              var d = c.getExtension("WEBGL_debug_renderer_info");
              d && "getParameter" in c && (s = c.getParameter(d.UNMASKED_RENDERER_WEBGL), u = c.getParameter(d.UNMASKED_VENDOR_WEBGL));
            }
          } catch (e) {}
          return e.arg.properties.gl_renderer = s, e.arg.properties.gl_vendor = u, e;
        }
        var d = function () {
            function e() {
              var t = this || _global;
              (this || _global).batteryManager = void 0, (this || _global).processor = (this || _global).processor.bind(this || _global), e.isSupported() && window.navigator.getBattery().then(function (e) {
                t.batteryManager = e;
              });
            }
            return e.isSupported = function () {
              var e;
              return void 0 !== (null == (e = window) || null == (e = e.navigator) ? void 0 : e.getBattery);
            }, e.prototype.processor = function (e) {
              var t = e.type === a.a.ANALYTICS_EVENT,
                n = e.arg && "minute-watched" === e.arg.name;
              return t && n && (this || _global).batteryManager && (e.arg.properties.battery_percent = (this || _global).batteryManager.level), e;
            }, e;
          }(),
          l = _asyncToGenerator,
          f = n.n(l),
          h = _regenerator,
          v = n.n(h),
          p = n(721);
        function m(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var g = {
            enabled: !1,
            levels: {
              debug: !0,
              info: !0,
              warn: !0,
              error: !0
            }
          },
          y = function (e) {
            var t = o()({}, g),
              n = function (e) {
                if (t.enabled && t.levels[e]) {
                  for (var n = new Date().toTimeString().split(" ")[0], r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];
                  console[e].apply(console, [n + " - [VideoTransformer]"].concat(i));
                }
              };
            return {
              debug: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, [p.$.DEBUG].concat(t));
              },
              log: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, [p.$.INFO].concat(t));
              },
              info: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, [p.$.INFO].concat(t));
              },
              warn: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, [p.$.WARN].concat(t));
              },
              error: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, [p.$.ERROR].concat(t));
              },
              setConfig: function (e) {
                var n = {
                    debug: !1,
                    info: !1,
                    warn: !1,
                    error: !1
                  },
                  r = function (e, t) {
                    for (var r, i = function (e, t) {
                        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (n) return (n = n.call(e)).next.bind(n);
                        if (Array.isArray(e) || (n = function (e, t) {
                          if (e) {
                            if ("string" == typeof e) return m(e, t);
                            var n = Object.prototype.toString.call(e).slice(8, -1);
                            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? m(e, t) : void 0;
                          }
                        }(e)) || t && e && "number" == typeof e.length) {
                          n && (e = n);
                          var r = 0;
                          return function () {
                            return r >= e.length ? {
                              done: !0
                            } : {
                              done: !1,
                              value: e[r++]
                            };
                          };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                      }(e); !(r = i()).done;) {
                      var o = r.value;
                      n[o] = t;
                    }
                  };
                switch (e.level) {
                  case p.$.DEBUG:
                    r([p.$.DEBUG, p.$.INFO, p.$.WARN, p.$.ERROR], !0);
                    break;
                  case p.$.INFO:
                    r([p.$.INFO, p.$.WARN, p.$.ERROR], !0);
                    break;
                  case p.$.WARN:
                    r([p.$.WARN, p.$.ERROR], !0);
                    break;
                  case p.$.ERROR:
                    r([p.$.ERROR], !0);
                }
                t.enabled = e.enabled, t.levels = o()({}, n);
              }
            };
          }();
        y.setConfig({
          enabled: !0,
          level: p.$.WARN
        });
        var E = function (e) {
            return e.gpu_pending = "Awaiting WebGPU adapter", e.gpu_unavailable = "WebGPU unavailable", e.gpu_adapter_unavailable = "WebGPU adapter unavailable", e.gpu_error = "WebGPU error", e;
          }({}),
          T = n(856),
          S = n(904),
          _ = {
            keySystem: "org.w3.clearkey",
            uuid: "1077efec-c0b2-4d02-ace3-3c1e52e2fb4b"
          },
          b = {
            keySystem: "com.apple.fps.2_0",
            certUrl: "https://fairplay.twitch.keyos.com/api/v4/getCertificate?certHash=a17fd33d3843df9b17679ccf50a419b2",
            licenseUrl: "https://fairplay.twitch.keyos.com/api/v4/getLicense",
            uuid: "94CE86FB-07FF-4F43-ADB8-93D2FA968CA2"
          },
          C = {
            keySystem: "com.microsoft.playready",
            licenseUrl: "https://playready.twitch.keyos.com/api/v4/getLicense",
            uuid: "9a04f079-9840-4286-ab92-e65be0885f95"
          },
          w = {
            keySystem: "com.widevine.alpha",
            licenseUrl: "https://widevine.twitch.keyos.com/api/v4/getLicense",
            uuid: "edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
          },
          k = {
            CLEARKEY: _,
            FAIRPLAY: b,
            PLAYREADY: C,
            WIDEVINE: w
          },
          I = {
            "com.widevine.alpha": w,
            "com.microsoft.playready": C,
            "com.apple.fps.2_0": b,
            "org.w3.clearkey": _
          },
          P = S.a1,
          A = S.Pt,
          D = {
            value: A,
            message: "Your browser does not support any DRM Content Decryption Modules"
          },
          L = {
            value: A,
            message: "There was an issue while updating DRM License"
          },
          R = {
            value: S.Ec,
            message: "Error while requesting DRM license"
          },
          x = {
            value: S.Ri,
            message: "DRM license not available"
          },
          M = {
            NO_CDM_SUPPORT: D,
            SESSION_UPDATE: L,
            LICENSE_REQUEST: R,
            LICENSE_REQUEST_AUTHORIZATION: {
              value: S.$1,
              message: "DRM license not authorized for this browser version"
            },
            LICENSE_REQUEST_NOT_AVAILABLE: x,
            LICENSE_SERVER: {
              value: S.xA,
              message: "DRM license server error"
            },
            KEY_SESSION_CREATION: {
              value: A,
              message: "Error creating key session"
            },
            KEY_SESSION_INTERNAL: {
              value: A,
              message: "Encryption key not usable because of internal error in CDM"
            },
            NO_PSSH_FOUND: {
              value: A,
              message: "Unable to find valid CDM support on media"
            },
            AUTH_XML_REQUEST: {
              value: P,
              message: "Request for AuthXML failed"
            },
            CERT_REQUEST: {
              value: P,
              message: "Request for DRM certificate failed"
            }
          };
        function N(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        function O(e) {
          return window.WebKitMediaKeys && "function" == typeof window.WebKitMediaKeys.isTypeSupported && window.WebKitMediaKeys.isTypeSupported(k.FAIRPLAY.keySystem) ? k.FAIRPLAY.uuid : "function" == typeof navigator.requestMediaKeySystemAccess ? e.safari ? "" : e.msIE || e.msEdgeLegacy ? k.PLAYREADY.uuid : k.WIDEVINE.uuid : "";
        }
        function U(e, t) {
          if ((e = F(e)) === (t = F(t))) return !0;
          if (e.byteLength !== t.byteLength) return !1;
          for (var n = new DataView(e), r = new DataView(t), i = 0; i < n.byteLength; i++) if (n.getUint8(i) !== r.getUint8(i)) return !1;
          return !0;
        }
        function F(e) {
          return e instanceof Uint8Array || e instanceof Uint16Array ? e.buffer : e;
        }
        function H(e) {
          return t = function (e) {
            if (null === e) return [];
            for (var t = new DataView(e.buffer || e), n = [], r = 0; !(r >= t.buffer.byteLength);) {
              var i = r + t.getUint32(r);
              if (r += 4, t.getUint32(r) === W("pssh")) {
                r += 4;
                var o = t.getUint8(r);
                if (0 === o || 1 === o) {
                  r++, r += 3;
                  for (var a = "", s = 0; s < 4; s++) a += j(t.getUint8(r + s));
                  r += 4, a += "-";
                  for (var u = 0; u < 2; u++) a += j(t.getUint8(r + u));
                  r += 2, a += "-";
                  for (var c = 0; c < 2; c++) a += j(t.getUint8(r + c));
                  r += 2, a += "-";
                  for (var d = 0; d < 2; d++) a += j(t.getUint8(r + d));
                  r += 2, a += "-";
                  for (var l = 0; l < 6; l++) a += j(t.getUint8(r + l));
                  r += 6, a = a.toLowerCase(), r += 4, n.push(a), r = i;
                } else r = i;
              } else r = i;
            }
            return n;
          }(e), n = [], t.forEach(function (e) {
            Object.keys(k).forEach(function (t) {
              var r = k[t];
              r.uuid.toLowerCase() === e.toLowerCase() && n.push(r);
            });
          }), n;
          var t, n;
        }
        function V(e, t) {
          return new Promise(function (n, r) {
            var i = new XMLHttpRequest();
            for (var o in i.open(t.method, e, !0), t.headers) Object.prototype.hasOwnProperty.call(t.headers, o) && i.setRequestHeader(o, t.headers[o]);
            i.responseType = t.responseType, i.onload = function () {
              200 === i.status && n(i.response);
            }, i.onloadend = function () {
              r(i.status);
            }, i.send(t.body);
          });
        }
        function G(e) {
          var t = B(K(JSON.parse(String.fromCharCode.apply(null, e)).sinf[0]), "schi");
          return function (e) {
            for (var t, n = "", r = function (e, t) {
                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (n) return (n = n.call(e)).next.bind(n);
                if (Array.isArray(e) || (n = function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return N(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? N(e, t) : void 0;
                  }
                }(e)) || t && e && "number" == typeof e.length) {
                  n && (e = n);
                  var r = 0;
                  return function () {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }(e); !(t = r()).done;) n += j(t.value);
            return n;
          }(B(t, "tenc").subarray(8, 24));
        }
        function B(e, t) {
          for (var n = new DataView(e.buffer, e.byteOffset, e.byteLength), r = W(t), i = 0; i < e.byteLength;) {
            var o = n.getUint32(i);
            if (n.getUint32(i + 4) === r) return e.subarray(i + 8, i + o);
            i += o;
          }
          return new Uint8Array(e);
        }
        function W(e) {
          return (e.charCodeAt(0) << 24) + (e.charCodeAt(1) << 16) + (e.charCodeAt(2) << 8) + e.charCodeAt(3);
        }
        function j(e) {
          var t = e.toString(16);
          return 1 === t.length ? "0" + t : t;
        }
        function K(e) {
          for (var t = atob(e), n = t.length, r = new Uint8Array(n), i = 0; i < n; i++) r[i] = t.charCodeAt(i);
          return r;
        }
        function z(e) {
          return decodeURIComponent(e.replace(/\+/g, " "));
        }
        var q = n(502),
          Q = n(385),
          Y = n(214);
        function Z(e) {
          var t = e.querySelector("Challenge"),
            n = null == t ? void 0 : t.textContent;
          return n ? atob(n) : "";
        }
        function X(e) {
          var t = e.querySelectorAll("HttpHeader");
          return Array.from(t).reduce(function (e, t) {
            var n,
              r,
              i = null == (n = t.querySelector("name")) ? void 0 : n.textContent,
              o = null == (r = t.querySelector("value")) ? void 0 : r.textContent;
            return i && o && (e[i] = o), e;
          }, {});
        }
        function J(e) {
          var t = String.fromCharCode.apply(null, new Uint16Array(e)),
            n = new DOMParser().parseFromString(t, "application/xml");
          return {
            headers: X(n),
            body: Z(n)
          };
        }
        function $(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var ee = [{
            initDataTypes: ["cenc"],
            audioCapabilities: [{
              contentType: "audio/mp4;codecs=\"mp4a.40.2\""
            }],
            videoCapabilities: [{
              robustness: "SW_SECURE_CRYPTO",
              contentType: "video/mp4;codecs=\"avc1.42E01E\""
            }]
          }],
          te = function () {
            function e(e) {
              var t = this || _global;
              (this || _global).video = void 0, (this || _global).listener = void 0, (this || _global).cdmSupport = void 0, (this || _global).selectedCDM = void 0, (this || _global).mediaKeys = void 0, (this || _global).pendingSessions = void 0, (this || _global).sessions = void 0, (this || _global).authXml = void 0, (this || _global).video = e.video, (this || _global).listener = e.listener, (this || _global).cdmSupport = null, (this || _global).selectedCDM = null, (this || _global).mediaKeys = void 0, (this || _global).pendingSessions = [], this.reset(), (this || _global).video.addEventListener("encrypted", function (e) {
                return t.handleEncrypted(e);
              }), (this || _global).video.addEventListener("webkitneedkey", function (e) {
                return t.handleWebKitEncrypted(e);
              });
            }
            var t = e.prototype;
            return t.configure = function (e) {
              var t = this || _global;
              if (!(this || _global).authXml) {
                var n = new URL(e),
                  r = n.pathname.split("/"),
                  i = r[r.length - 1].split(".")[0],
                  o = function (e) {
                    var t = new URL(e).searchParams,
                      n = {};
                    return t.forEach(function (e, t) {
                      n[z(t)] = e ? z(e) : "";
                    }), n;
                  }(e),
                  a = o.token,
                  s = o.sig,
                  u = "https://" + n.host + "/api/authxml/" + i + "?token=" + encodeURIComponent(a) + "&sig=" + s;
                (this || _global).authXml = V(u, {
                  method: "GET",
                  responseType: "text"
                }).catch(function (e) {
                  t.handleError(Object.assign({
                    code: e
                  }, M.AUTH_XML_REQUEST));
                });
              }
            }, t.reset = function () {
              (this || _global).authXml = null, (this || _global).sessions = [];
            }, t.isProtected = function () {
              return null !== (this || _global).authXml;
            }, t.handleError = function (e) {
              (this || _global).listener.onSinkError({
                value: e.value || S.Pt,
                code: e.code || 0,
                message: e.message || ""
              });
            }, t.hasSession = function (e) {
              if (!e) return !1;
              for (var t, n = function (e, t) {
                  var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                  if (n) return (n = n.call(e)).next.bind(n);
                  if (Array.isArray(e) || (n = function (e, t) {
                    if (e) {
                      if ("string" == typeof e) return $(e, t);
                      var n = Object.prototype.toString.call(e).slice(8, -1);
                      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? $(e, t) : void 0;
                    }
                  }(e)) || t && e && "number" == typeof e.length) {
                    n && (e = n);
                    var r = 0;
                    return function () {
                      return r >= e.length ? {
                        done: !0
                      } : {
                        done: !1,
                        value: e[r++]
                      };
                    };
                  }
                  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }((this || _global).sessions); !(t = n()).done;) {
                var r = t.value;
                if (r.initData && U(r.initData, e)) return !0;
              }
              return !1;
            }, t.createKeySystemSupportChain = function () {
              if (null === (this || _global).cdmSupport || 0 === (this || _global).cdmSupport.length) return Promise.reject(M.NO_PSSH_FOUND);
              var e = Promise.reject();
              return (this || _global).cdmSupport.forEach(function (t) {
                e = e.catch(function () {
                  return navigator.requestMediaKeySystemAccess(t.keySystem, ee);
                });
              }), e = e.catch(function () {
                return Promise.reject(M.NO_CDM_SUPPORT);
              });
            }, t.handleEncrypted = function () {
              var e = f()(v().mark(function e(t) {
                var n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!this.hasSession(t.initData)) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return");
                    case 2:
                      if ((this || _global).sessions.push(t), "sinf" !== t.initDataType) {
                        e.next = 6;
                        break;
                      }
                      return this.handleWebKitEncrypted(t), e.abrupt("return");
                    case 6:
                      if (null === (this || _global).cdmSupport && ((this || _global).cdmSupport = H(t.initData)), void 0 !== (this || _global).mediaKeys) {
                        e.next = 24;
                        break;
                      }
                      return (this || _global).mediaKeys = null, e.prev = 9, e.next = 12, this.createKeySystemSupportChain();
                    case 12:
                      return n = e.sent, (this || _global).selectedCDM = I[n.keySystem], e.next = 16, n.createMediaKeys();
                    case 16:
                      return r = e.sent, e.next = 19, this.setMediaKeys(r);
                    case 19:
                      e.next = 24;
                      break;
                    case 21:
                      e.prev = 21, e.t0 = e.catch(9), this.handleError(e.t0);
                    case 24:
                      this.addSession(t);
                    case 25:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[9, 21]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.setMediaKeys = function (e) {
              var t = this || _global;
              return (this || _global).mediaKeys = e, (this || _global).pendingSessions.forEach(function (e) {
                return t.createSessionRequest(e).catch(function () {
                  t.handleError(M.KEY_SESSION_CREATION);
                });
              }), (this || _global).pendingSessions = [], (this || _global).video.setMediaKeys((this || _global).mediaKeys);
            }, t.addSession = function (e) {
              var t = this || _global;
              (this || _global).mediaKeys ? this.createSessionRequest(e).catch(function () {
                t.handleError(M.KEY_SESSION_CREATION);
              }) : (this || _global).pendingSessions.push(e);
            }, t.createSessionRequest = function (e) {
              var t,
                n = this || _global,
                r = e.initDataType,
                i = e.initData,
                o = null == (t = (this || _global).mediaKeys) ? void 0 : t.createSession();
              return o ? (o.addEventListener("message", function (e) {
                return n.handleMessage(e);
              }), o.addEventListener("keystatuseschange", function (e) {
                return n.handleKeyStatusesChange(e, i);
              }), o.generateRequest(r, i)) : Promise.reject();
            }, t.handleKeyStatusesChange = function (e, t) {
              var n = this || _global,
                r = e.target,
                i = !1;
              r.keyStatuses.forEach(function (e) {
                switch (e) {
                  case "expired":
                    i = !0;
                    break;
                  case "internal-error":
                    n.handleError(M.KEY_SESSION_INTERNAL);
                }
              }), i && r.close().then(function () {
                return n.removeSession(t);
              });
            }, t.removeSession = function (e) {
              for (var t = 0; t < (this || _global).sessions.length; t++) if ((this || _global).sessions[t].initData === e) return void (this || _global).sessions.splice(t, 1);
            }, t.handleMessage = function () {
              var e = f()(v().mark(function e(t) {
                var n,
                  r,
                  i = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return n = t.target, e.next = 3, this.generateLicense(t.message);
                    case 3:
                      (r = e.sent) && n.update(r).catch(function () {
                        i.handleError(M.SESSION_UPDATE);
                      });
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.generateLicense = function () {
              var e = f()(v().mark(function e(t) {
                var n, r, i, o;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if ((this || _global).selectedCDM !== k.CLEARKEY) {
                        e.next = 5;
                        break;
                      }
                      return n = JSON.parse(new TextDecoder().decode(t)), r = n.kids.map(function (e) {
                        return {
                          kty: "oct",
                          alg: "A128KW",
                          kid: e,
                          k: e
                        };
                      }), i = new TextEncoder().encode(JSON.stringify({
                        keys: r
                      })), e.abrupt("return", Promise.resolve(i));
                    case 5:
                      if (!(this || _global).authXml) {
                        e.next = 10;
                        break;
                      }
                      return e.next = 8, (this || _global).authXml;
                    case 8:
                      return o = e.sent, e.abrupt("return", this.requestLicense(t, o));
                    case 10:
                      this.handleError(M.AUTH_XML_REQUEST);
                    case 11:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.requestLicense = function () {
              var e = f()(v().mark(function e(t, n) {
                var r,
                  i,
                  o,
                  a = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return i = {
                        method: "POST",
                        responseType: "arraybuffer",
                        body: t,
                        headers: {
                          customdata: n,
                          "Content-Type": "application/octet-stream"
                        }
                      }, (this || _global).selectedCDM === k.PLAYREADY && (o = J(t), i.body = o.body, i.headers = Object.assign(i.headers, o.headers)), e.abrupt("return", V((null == (r = (this || _global).selectedCDM) ? void 0 : r.licenseUrl) || "", i).catch(function (e) {
                        var t;
                        switch (e) {
                          case 0:
                            t = M.LICENSE_REQUEST;
                            break;
                          case 404:
                            t = M.LICENSE_REQUEST_NOT_AVAILABLE;
                            break;
                          case 403:
                            t = M.LICENSE_REQUEST_AUTHORIZATION;
                            break;
                          default:
                            t = M.LICENSE_SERVER;
                        }
                        a.handleError(Object.assign({
                          code: e
                        }, t));
                      }));
                    case 3:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.handleWebKitEncrypted = function () {
              var e = f()(v().mark(function e(t) {
                var n,
                  r = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return (this || _global).selectedCDM = k.FAIRPLAY, e.prev = 1, e.next = 4, V(k.FAIRPLAY.certUrl || "", {
                        method: "GET",
                        responseType: "arraybuffer",
                        headers: {
                          Pragma: "Cache-Control: no-cache",
                          "Cache-Control": "max-age=0"
                        }
                      });
                    case 4:
                      n = e.sent, this.setupWebKitMediaKeys(t, n).catch(function (e) {
                        return r.handleError(e);
                      }), e.next = 11;
                      break;
                    case 8:
                      e.prev = 8, e.t0 = e.catch(1), this.handleError(Object.assign({
                        code: e.t0
                      }, M.CERT_REQUEST));
                    case 11:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[1, 8]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.setupWebKitMediaKeys = function (e, t) {
              var n = this || _global;
              if (!e.initData) return Promise.reject("Missing initData on MediaEncryptedEvent");
              (this || _global).video.webkitKeys || (this || _global).video.webkitSetMediaKeys(new window.WebKitMediaKeys(k.FAIRPLAY.keySystem));
              var r = G(e.initData),
                i = (this || _global).video.webkitKeys.createSession("video/mp4", e.initData);
              return i.contentId = r, new Promise(function (e, o) {
                if (n.video.webkitKeys || o("Issue setting fairplay media keys"), !i) return o("Could not create key session");
                i.addEventListener("webkitkeymessage", function (e) {
                  var i = e.target;
                  "certificate" === String.fromCharCode.apply(null, e.message) ? i.update(new Uint8Array(t)) : n.getWebkitLicense(e.message, r).then(function (e) {
                    var t = e.trim();
                    "<ckc>" === t.substr(0, 5) && "</ckc>" === t.substr(-6) && (t = t.slice(5, -6)), i.update(K(t));
                  }).catch(o);
                }), i.addEventListener("webkitkeyadded", e), i.addEventListener("webkitkeyerror", o);
              });
            }, t.getWebkitLicense = function (e, t) {
              return (this || _global).authXml ? (this || _global).authXml.then(function (n) {
                var r;
                return V(k.FAIRPLAY.licenseUrl || "", {
                  method: "POST",
                  body: "spc=" + (r = e, btoa(String.fromCharCode.apply(null, new Uint16Array(r))) + "&assetId=") + t,
                  responseType: "text",
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    customdata: n
                  }
                }).catch(function (e) {
                  return Promise.reject(Object.assign({
                    code: e
                  }, M.LICENSE_REQUEST));
                });
              }) : Promise.reject(M.AUTH_XML_REQUEST);
            }, e;
          }(),
          ne = _inheritsLoose,
          re = n.n(ne),
          ie = function () {
            function e() {}
            var t = e.prototype;
            return t.addTrack = function (e) {}, t.bufferDuration = function () {
              return 0;
            }, t.buffered = function () {
              return {
                start: 0,
                end: 0
              };
            }, t.getBufferedRanges = function (e) {
              return [];
            }, t.captureGesture = function () {}, t.configure = function (e) {}, t.delete = function () {}, t.endOfStream = function () {}, t.enqueue = function (e) {}, t.getCurrentTime = function () {
              return 0;
            }, t.getPlaybackRate = function () {
              return 0;
            }, t.getVolume = function () {
              return 0;
            }, t.invoke = function (e) {
              (this || _global)[e.name].call(this || _global, e.arg);
            }, t.isMuted = function () {
              return !1;
            }, t.onSourceDurationChanged = function (e) {}, t.pause = function () {}, t.play = function () {}, t.reinit = function () {}, t.remove = function (e) {}, t.seekTo = function (e) {}, t.setMuted = function (e) {}, t.setPlaybackRate = function (e) {}, t.setTimestampOffset = function (e) {}, t.setVolume = function (e) {}, t.changeSrc = function (e) {}, t.changeSrcObj = function (e) {}, t.onSegmentDiscontinuity = function () {}, e;
          }(),
          oe = "pc-chromecast-sender",
          ae = function (e) {
            function t(n) {
              var r;
              return (r = e.call(this || _global) || this || _global).remotePlayer = void 0, r.remotePlayerController = void 0, r.listener = void 0, r.seekTime = void 0, r.currentDuration = void 0, r.listener = n, r.currentDuration = 0, t.prepareCastContext().then(function () {
                r.remotePlayer = new cast.framework.RemotePlayer(), r.remotePlayerController = new cast.framework.RemotePlayerController(r.remotePlayer);
              }).catch(function () {
                r.listener.onSessionError();
              }), r;
            }
            re()(t, e), t.canCast = function () {
              return (0, r.cp)().chrome;
            }, t.stopLookingForRemotePlaybackDevices = function (e) {
              window.cast && window.cast.framework && cast.framework.CastContext.getInstance().removeEventListener(cast.framework.CastContextEventType.CAST_STATE_CHANGED, e);
            }, t.lookForRemotePlaybackDevices = function () {
              var e = f()(v().mark(function e(n) {
                var r, i;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.prev = 0, e.next = 3, t.prepareCastContext();
                    case 3:
                      return r = e.sent, i = function (e) {
                        switch (e.castState) {
                          case cast.framework.CastState.NO_DEVICES_AVAILABLE:
                            break;
                          case cast.framework.CastState.NOT_CONNECTED:
                            n.onRemoteDevice(!0);
                            break;
                          case cast.framework.CastState.CONNECTED:
                            var t = r.getCurrentSession();
                            t && t.getSessionState() === cast.framework.SessionState.SESSION_RESUMED && n.onRemoteReconnect();
                        }
                      }, r.addEventListener(cast.framework.CastContextEventType.CAST_STATE_CHANGED, i), r.setOptions({
                        receiverApplicationId: "B3DCF968",
                        autoJoinPolicy: chrome.cast.AutoJoinPolicy.TAB_AND_ORIGIN_SCOPED
                      }), e.abrupt("return", i);
                    case 10:
                      e.prev = 10, e.t0 = e.catch(0), n.onRemoteDevice(!1);
                    case 13:
                    case "end":
                      return e.stop();
                  }
                }, e, null, [[0, 10]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.prepareCastContext = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!window.cast || !window.cast.framework) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", Promise.resolve(cast.framework.CastContext.getInstance()));
                    case 2:
                      return e.abrupt("return", new Promise(function (e, t) {
                        if (n.g.__onGCastApiAvailable = function (n) {
                          n ? e(cast.framework.CastContext.getInstance()) : t();
                        }, !document.getElementById(oe)) {
                          var r = document.createElement("script");
                          r.id = oe, r.onerror = function () {
                            document.body.removeChild(r), n.g.__onGCastApiAvailable = function () {}, t();
                          }, r.async = !0, r.src = "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1", document.body.appendChild(r);
                        }
                      }));
                    case 3:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }();
            var i = t.prototype;
            return i.configure = function () {
              var e = f()(v().mark(function e(n) {
                var r, i, o, a, s, u, c;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return r = n.path, e.prev = 1, e.next = 4, t.prepareCastContext();
                    case 4:
                      if (o = e.sent, a = o.getCurrentSession()) {
                        e.next = 13;
                        break;
                      }
                      return e.next = 9, o.requestSession();
                    case 9:
                      a = o.getCurrentSession(), this.setupRemotePlayerListeners(a), e.next = 14;
                      break;
                    case 13:
                      a.getSessionState() === cast.framework.SessionState.SESSION_RESUMED && this.setupRemotePlayerListeners(a);
                    case 14:
                      return (s = new chrome.cast.media.MediaInfo(r, "")).streamType = chrome.cast.media.StreamType.BUFFERED, u = new chrome.cast.media.GenericMediaMetadata(), s.metadata = u, s.customData = {
                        analytics: {
                          chromecast_sender: "player-core",
                          platform: "web"
                        }
                      }, (this || _global).remotePlayerController.stop(), c = new chrome.cast.media.LoadRequest(s), (this || _global).seekTime > 0 && (c.currentTime = (this || _global).seekTime, (this || _global).seekTime = 0), (this || _global).currentDuration = 0, e.next = 25, null == (i = a) ? void 0 : i.loadMedia(c);
                    case 25:
                      e.next = 30;
                      break;
                    case 27:
                      return e.prev = 27, e.t0 = e.catch(1), e.abrupt("return", this.handleError(e.t0));
                    case 30:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[1, 27]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), i.stopMedia = function () {
              var e = f()(v().mark(function e(n) {
                var r, i;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return void 0 === n && (n = !0), e.next = 3, t.prepareCastContext();
                    case 3:
                      r = e.sent, (i = r.getCurrentSession()) && i.getSessionState() !== cast.framework.SessionState.SESSION_RESUMED && i.endSession(n);
                    case 6:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), i.invoke = function (e) {
              (this || _global)[e.name].call(this || _global, e.arg);
            }, i.play = function () {
              (this || _global).remotePlayer && (this || _global).remotePlayer.isPaused && (this || _global).remotePlayerController.playOrPause();
            }, i.pause = function () {
              (this || _global).remotePlayer && !(this || _global).remotePlayer.isPaused && (this || _global).remotePlayerController.playOrPause();
            }, i.seekTo = function (e) {
              (this || _global).remotePlayer && ((this || _global).remotePlayer.playerState !== chrome.cast.media.PlayerState.IDLE ? ((this || _global).remotePlayer.currentTime = e, (this || _global).remotePlayerController.seek()) : (this || _global).seekTime = e);
            }, i.getCurrentTime = function () {
              return (this || _global).remotePlayer ? (this || _global).remotePlayer.currentTime : 0;
            }, i.delete = function () {
              (this || _global).remotePlayer && this.stopMedia();
            }, i.setMuted = function (e) {
              (this || _global).remotePlayer && e !== (this || _global).remotePlayer.isMuted && (this || _global).remotePlayerController.muteOrUnmute();
            }, i.isMuted = function () {
              return !!(this || _global).remotePlayer && (this || _global).remotePlayer.isMuted;
            }, i.setVolume = function (e) {
              (this || _global).remotePlayer && ((this || _global).remotePlayer.volumeLevel = e, (this || _global).remotePlayerController.setVolumeLevel());
            }, i.getVolume = function () {
              return (this || _global).remotePlayer ? (this || _global).remotePlayer.volumeLevel : 0;
            }, i.getDevice = function () {
              var e = f()(v().mark(function e() {
                var n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, t.prepareCastContext();
                    case 2:
                      return n = e.sent, r = n.getCurrentSession(), e.abrupt("return", (null == r ? void 0 : r.getCastDevice().friendlyName) || "");
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), i.setupRemotePlayerListeners = function (e) {
              var t = this || _global,
                n = function () {
                  var n = f()(v().mark(function n() {
                    var r, i;
                    return v().wrap(function (n) {
                      for (;;) switch (n.prev = n.next) {
                        case 0:
                          (r = e.getMediaSession()) && (i = r.media, 0 === t.currentDuration && null === i.duration && (t.currentDuration = 1 / 0, t.listener.onSinkDurationChanged(t.currentDuration)), t.listener.onSinkTimeUpdate());
                        case 2:
                        case "end":
                          return n.stop();
                      }
                    }, n);
                  }));
                  return function () {
                    return n.apply(this || _global, arguments);
                  };
                }(),
                r = function () {
                  switch (t.remotePlayer.playerState) {
                    case chrome.cast.media.PlayerState.BUFFERING:
                      t.listener.onSinkIdle();
                      break;
                    case chrome.cast.media.PlayerState.PLAYING:
                      t.listener.onSinkPlaying(!1);
                      break;
                    case chrome.cast.media.PlayerState.IDLE:
                      var n = e.getMediaSession();
                      n && n.idleReason === chrome.cast.media.IdleReason.FINISHED && t.listener.onSinkEnded();
                  }
                },
                i = function () {
                  t.listener.onSinkVolumeChanged(t.remotePlayer.volumeLevel, !0);
                },
                o = function () {
                  t.listener.onSinkMutedChanged(t.remotePlayer.isMuted);
                },
                a = function () {
                  0 !== t.remotePlayer.duration && (t.currentDuration = t.remotePlayer.duration, t.listener.onSinkDurationChanged(t.currentDuration));
                },
                s = function () {
                  t.remotePlayerController.removeEventListener(cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED, n), t.remotePlayerController.removeEventListener(cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED, r), t.remotePlayerController.removeEventListener(cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED, i), t.remotePlayerController.removeEventListener(cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED, o), t.remotePlayerController.removeEventListener(cast.framework.RemotePlayerEventType.DURATION_CHANGED, a), t.listener.onSessionStop();
                };
              e.addEventListener(cast.framework.SessionEventType.MEDIA_SESSION, function () {
                t.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED, n), t.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED, r), t.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED, i), t.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED, o), t.remotePlayerController.addEventListener(cast.framework.RemotePlayerEventType.DURATION_CHANGED, a), t.listener.onSessionStarted(e.getCastDevice().friendlyName);
              });
              var u = e.getSessionObj();
              u.addUpdateListener(function () {
                u.status === chrome.cast.SessionStatus.STOPPED && s();
              }), u.addMediaListener(s);
            }, i.handleError = function (e) {
              if (chrome.cast) switch (e) {
                case chrome.cast.ErrorCode.SESSION_ERROR:
                  (this || _global).listener.onSessionError();
                  break;
                case chrome.cast.ErrorCode.RECEIVER_UNAVAILABLE:
                  (this || _global).listener.onRemoteDevice(!1);
                  break;
                case chrome.cast.ErrorCode.LOAD_MEDIA_FAILED:
                  (this || _global).listener.onLoadMediaError();
                  break;
                case chrome.cast.ErrorCode.CANCEL:
                  (this || _global).listener.onUserCancel();
                  break;
                default:
                  (this || _global).listener.onSinkError({
                    value: 1,
                    code: 0,
                    message: "Error requesting chromecast session"
                  });
              } else (this || _global).listener.onSinkError({
                value: 1,
                code: 0,
                message: "Error loading chromecast SDK"
              });
            }, t;
          }(ie),
          se = function (e) {
            function t(t) {
              var n;
              return (n = e.call(this || _global) || this || _global).video = void 0, n.video = t, n;
            }
            re()(t, e);
            var n = t.prototype;
            return n.seekTo = function (e) {
              (this || _global).video.currentTime = e;
            }, n.setPlaybackRate = function (e) {
              (this || _global).video.playbackRate = e;
            }, n.setVolume = function (e) {
              (this || _global).video.volume = e;
            }, n.getVolume = function () {
              return (this || _global).video.volume;
            }, n.isMuted = function () {
              return (this || _global).video.muted;
            }, n.setMuted = function (e) {
              (this || _global).video.muted = e;
            }, n.getPlaybackRate = function () {
              return (this || _global).video.playbackRate;
            }, t;
          }(ie),
          ue = n(477),
          ce = function () {
            function e(e, t) {
              (this || _global).muted = void 0, (this || _global).video = void 0, (this || _global).listener = void 0, (this || _global).unsubscribes = [], (this || _global).expectingMutedChanged = !1, (this || _global).expectingVolumeChanged = !1, (this || _global).expectedRateChange = void 0, (this || _global).video = e, (this || _global).listener = t, (this || _global).muted = e.muted, (this || _global).unsubscribes.push((0, ue.B1)(e, "volumechange", (this || _global).volumeChange.bind(this || _global))), (this || _global).unsubscribes.push((0, ue.B1)(e, "ratechange", (this || _global).rateChange.bind(this || _global)));
            }
            var t = e.prototype;
            return t.volumeChange = function () {
              var e = !(this || _global).expectingVolumeChanged;
              (this || _global).expectingMutedChanged = !1, (this || _global).expectingVolumeChanged = !1;
              var t = (this || _global).video.muted;
              (this || _global).muted !== t ? ((this || _global).muted = t, (this || _global).listener.onSinkMutedChanged(t)) : (this || _global).listener.onSinkVolumeChanged((this || _global).video.volume, e);
            }, t.rateChange = function () {
              (this || _global).video.playbackRate !== (this || _global).expectedRateChange && (this || _global).listener.onSinkPlaybackRateChanged((this || _global).video.playbackRate);
            }, t.unsubscribe = function () {
              (this || _global).unsubscribes.forEach(function (e) {
                return e();
              });
            }, t.onConfigure = function () {
              (this || _global).expectingVolumeChanged && ((this || _global).listener.onSinkVolumeChanged((this || _global).video.volume, !1), (this || _global).expectingVolumeChanged = !1), (this || _global).expectingMutedChanged && ((this || _global).muted = (this || _global).video.muted, (this || _global).listener.onSinkMutedChanged((this || _global).video.muted), (this || _global).expectingMutedChanged = !1), (this || _global).expectedRateChange = void 0;
            }, t.trackRPC = function (e) {
              var t = e.name,
                n = e.arg;
              "setVolume" === t && (this || _global).video.volume !== n ? (this || _global).expectingVolumeChanged = !0 : "setMuted" === t && (this || _global).video.muted !== n ? (this || _global).expectingMutedChanged = !0 : "setPlaybackRate" === t && (this || _global).video.playbackRate !== n && ((this || _global).expectedRateChange = n);
            }, e;
          }(),
          de = _promisePolyfill,
          le = n.n(de),
          fe = ("undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n.g ? n.g : void 0).Promise || le(),
          he = function (e) {
            function t(t, n) {
              var r;
              return (r = e.call(this || _global) || this || _global).paused = !0, r.listener = void 0, r.video = void 0, r.unsubscribers = void 0, r.lastVolumeChangeEvent = void 0, r.video = t, r.listener = n, r.paused = !0, r.unsubscribers = [], r.addListener("volumechange", r.recordMuteChange.bind(r)), r.recordMuteChange(), r;
            }
            re()(t, e);
            var n = t.prototype;
            return n.pause = function () {
              (this || _global).paused = !0, (this || _global).video.pause();
            }, n.setPlaybackRate = function (e) {
              (this || _global).video.playbackRate = e;
            }, n.delete = function () {
              (this || _global).unsubscribers.forEach(function (e) {
                return e();
              });
            }, n.addListener = function (e, t, n) {
              void 0 === n && (n = (this || _global).video), (this || _global).unsubscribers.push((0, ue.B1)(n, e, t));
            }, n.recordMuteChange = function () {
              (this || _global).lastVolumeChangeEvent = {
                time: (this || _global).video.currentTime,
                muted: (this || _global).video.muted
              };
            }, n.checkStopped = function (e) {
              return !(this || _global).video.paused || (this || _global).video.ended || (this || _global).video.error || (this || _global).paused || (this || _global).listener.onSinkStop(e || this.unmuteAutopause()), !1;
            }, n.unmuteAutopause = function () {
              var e = (this || _global).lastVolumeChangeEvent;
              return !(this || _global).video.muted && !e.muted && (this || _global).video.currentTime === e.time;
            }, t;
          }(ie),
          ve = n(887),
          pe = function (e) {
            function t(t, n) {
              var r;
              return (r = e.call(this || _global, t, n) || this || _global).onSinkIdle = void 0, r.intervalId = void 0, r.idle = void 0, r.lastPlayhead = void 0, r.lastBufferEnd = void 0, r.idleTimeout = void 0, r.playAttempt = !1, r.seeking = !1, r.audioBufferList = void 0, r.awaitingAutoplayCompletion = !1, r.intervalId = 0, r.idle = !0, r.lastPlayhead = 0, r.lastBufferEnd = 0, r.idleTimeout = -1, r.audioBufferList = [], r.bindEvents(), r;
            }
            re()(t, e);
            var n = t.prototype;
            return n.bindEvents = function () {
              var e = this || _global;
              this.addListener("play", function () {
                return e.onVideoPlay();
              }), this.addListener("pause", function () {
                return e.onVideoPause();
              }), this.addListener("timeupdate", function () {
                return e.onVideoTimeUpdate();
              }), this.addListener("ended", function () {
                return e.onVideoEnded();
              }), this.addListener("error", function () {
                return e.onVideoError();
              }), this.addListener("playing", function () {
                return e.onVideoPlaying();
              }), this.addListener("seeking", function () {
                return e.onVideoSeeking();
              });
            }, n.delete = function () {
              e.prototype.delete.call(this || _global), (this || _global).audioBufferList = [], clearInterval((this || _global).intervalId);
            }, n.play = function () {
              (this || _global).paused = !1;
              for (var e = (this || _global).video.buffered, t = 0, n = 0; n < e.length; n++) {
                var r = e.start(n);
                if ((this || _global).video.currentTime <= r) {
                  t = r;
                  break;
                }
              }
              (this || _global).video.currentTime < t && (console.warn("Moving to buffered region", t, (this || _global).video.currentTime), (this || _global).listener.onSinkGapJump(t - (this || _global).video.currentTime), this.seekTo(t)), this.playInternal();
            }, n.endOfStream = function () {
              (this || _global).idle = !1, clearTimeout((this || _global).idleTimeout), (this || _global).idleTimeout = -1;
            }, n.seekTo = function (e) {
              (this || _global).video.seekable.length && e !== (this || _global).video.currentTime && ((this || _global).seeking = !0, (this || _global).video.currentTime = e);
            }, n.addSourceBuffer = function (e, t) {
              (t.indexOf("mp4a") > -1 || t.indexOf("opus") > -1) && ((this || _global).audioBufferList = [e]);
            }, n.clearSourceBuffers = function () {
              (this || _global).audioBufferList = [];
            }, n.onIdle = function () {
              var e;
              (this || _global).listener.onSinkIdle(), null == (e = (this || _global).onSinkIdle) || e.call(this || _global);
            }, n.onVideoPlay = function () {
              var e = this || _global;
              (this || _global).playAttempt ? ((this || _global).lastPlayhead = (this || _global).video.currentTime, clearInterval((this || _global).intervalId), (this || _global).intervalId = self.setInterval(function () {
                return e.heartbeat();
              }, ve.HJ)) : (this.pause(), (this || _global).listener.play()), (this || _global).playAttempt = !1;
            }, n.onVideoPause = function () {
              (this || _global).awaitingAutoplayCompletion || (this.checkStopped(!1), clearInterval((this || _global).intervalId));
            }, n.onVideoTimeUpdate = function () {
              clearTimeout((this || _global).idleTimeout), (this || _global).idleTimeout = -1, (this || _global).listener.onSinkTimeUpdate();
              var e = (0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de);
              this.checkBufferUpdate(e), this.updateIdle(e);
            }, n.onVideoEnded = function () {
              (this || _global).listener.onSinkEnded();
            }, n.onVideoPlaying = function () {
              (this || _global).video.paused || (this || _global).listener.onSinkPlaying((this || _global).paused);
            }, n.onVideoSeeking = function () {
              (this || _global).seeking ? (this || _global).seeking = !1 : (this || _global).listener.seekTo((this || _global).video.currentTime);
            }, n.onVideoError = function () {
              var e,
                t,
                n = null != (e = null == (this || _global) || null == (t = (this || _global).video) ? void 0 : t.error) ? e : {},
                r = n.code,
                i = void 0 === r ? -1 : r,
                o = n.message,
                a = void 0 === o ? "" : o;
              (this || _global).listener.onSinkError({
                value: i,
                code: i,
                message: a
              });
            }, n.heartbeat = function () {
              var e = (0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de);
              if ((this || _global).video.paused) clearInterval((this || _global).intervalId);else if ((this || _global).video.currentTime === (this || _global).lastPlayhead) {
                var t = (0, ue.tX)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de);
                t !== (this || _global).video.currentTime && ((this || _global).audioBufferList.map(function (e) {
                  (0, ue.gd)("Audio Buffer", e.buffered);
                }), (0, ue.gd)("<video> Buffer", (this || _global).video.buffered), console.warn("jumping " + (t - (this || _global).video.currentTime) + "s gap, current position " + (this || _global).video.currentTime + ", new position " + t), (this || _global).listener.onSinkGapJump(t - (this || _global).video.currentTime), this.seekTo(t)), this.updateIdle(e, t === (this || _global).video.currentTime);
              } else this.checkBufferUpdate(e), (this || _global).lastPlayhead = (this || _global).video.currentTime;
            }, n.checkBufferUpdate = function (e) {
              var t = e.end;
              t !== (this || _global).lastBufferEnd && ((this || _global).lastBufferEnd = t, (this || _global).listener.onSinkBufferUpdate());
            }, n.updateIdle = function (e, t) {
              var n = this || _global,
                r = e.end,
                i = void 0 === r ? 0 : r;
              void 0 === t && (t = !1);
              var o = (this || _global).video,
                a = o.buffered,
                s = o.currentTime;
              if (o.paused) (this || _global).idle = !0;else {
                var u = [i].concat((this || _global).audioBufferList.map(function (e) {
                    return (0, ue.vG)(e.buffered, s, ve.de).end;
                  })),
                  c = Math.max.apply(null, u);
                Number.isFinite(c) || (c = 0);
                var d = a.length,
                  l = d > 0 ? a.end(d - 1) : i,
                  f = c - s < ve.de || t && i > l;
                f && !(this || _global).idle && (console.warn("playhead", s, "max buffer", c, "max played", l), clearTimeout((this || _global).idleTimeout), (this || _global).idleTimeout = self.setTimeout(function () {
                  return n.onBufferingTimeout();
                }, ve.Pp), this.onIdle()), (this || _global).idle = f;
              }
            }, n.onBufferingTimeout = function () {
              clearTimeout((this || _global).idleTimeout), (this || _global).idleTimeout = -1, (this || _global).listener.onSinkError({
                value: S.yY,
                code: S.yY,
                message: "Buffering timeout"
              });
            }, n.playInternal = function () {
              var e = this || _global;
              (this || _global).playAttempt = !0, (this || _global).awaitingAutoplayCompletion = !0, fe.resolve((this || _global).video.play()).then(function () {
                e.awaitingAutoplayCompletion = !1;
              }).catch(function () {
                e.playAttempt = !1, e.checkStopped(!0);
              });
            }, t;
          }(he),
          me = function (e) {
            function t(t, n) {
              var r;
              return (r = e.call(this || _global) || this || _global).listener = t, r.video = n, r.playbackMonitor = void 0, r.controlsObserver = void 0, r.playbackMonitor = new pe(n, t), r.observeControlsChange(), r;
            }
            re()(t, e);
            var n = t.prototype;
            return n.configure = function (e) {
              var t = e.srcObj;
              (this || _global).video.srcObject || ((this || _global).video.srcObject = t);
            }, n.invoke = function (e) {
              (this || _global)[e.name].call(this || _global, e.arg);
            }, n.play = function () {
              (this || _global).playbackMonitor.play();
            }, n.pause = function () {
              (this || _global).playbackMonitor.pause();
            }, n.seekTo = function (e) {
              (this || _global).playbackMonitor.seekTo(e);
            }, n.endOfStream = function () {
              (this || _global).playbackMonitor.endOfStream();
            }, n.setVolume = function (e) {
              (this || _global).video.volume !== e && ((this || _global).video.volume = e);
            }, n.getVolume = function () {
              return (this || _global).video.volume;
            }, n.isMuted = function () {
              return (this || _global).video.muted;
            }, n.setMuted = function (e) {
              (this || _global).video.muted !== e && ((this || _global).video.muted = e);
            }, n.setPlaybackRate = function (e) {
              (this || _global).playbackMonitor.setPlaybackRate(e);
            }, n.getPlaybackRate = function () {
              return (this || _global).video.playbackRate;
            }, n.getCurrentTime = function () {
              return (this || _global).video.currentTime;
            }, n.buffered = function () {
              return (0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de);
            }, n.bufferDuration = function () {
              var e = this.buffered(),
                t = e.start;
              return e.end - Math.max(t, (this || _global).video.currentTime);
            }, n.captureGesture = function () {
              (this || _global).playbackMonitor.play(), (this || _global).playbackMonitor.pause();
            }, n.changeSrcObj = function (e) {
              var t = (this || _global).video,
                n = t.playbackRate;
              t.srcObject = e, t.playbackRate = n;
            }, n.delete = function () {
              var e;
              (this || _global).playbackMonitor.delete(), (this || _global).video.srcObject = null, (0, ue.v8)((this || _global).video), null == (e = (this || _global).controlsObserver) || e.disconnect();
            }, n.observeControlsChange = function () {
              var e = (this || _global).listener,
                t = (this || _global).video;
              try {
                ((this || _global).controlsObserver = new MutationObserver(function () {
                  e.onSinkControlsChanged(t.controls);
                })).observe(t, {
                  attributeFilter: ["controls"]
                }), e.onSinkControlsChanged(t.controls);
              } catch (e) {}
            }, t;
          }(ie),
          ge = n(446),
          ye = function () {
            function e(e, t, n) {
              void 0 === n && (n = new pe(t, e)), (this || _global).listener = e, (this || _global).video = t, (this || _global).playbackMonitor = n, (this || _global).controlsObserver = void 0, (this || _global).mseSink = void 0, (this || _global).awaitSink = void 0, this.observeControlsChange(), (this || _global).awaitSink = void 0, (0, ue.B1)(t, "error", (this || _global).onVideoError.bind(this || _global));
            }
            var t = e.prototype;
            return t.invoke = function (e) {
              var t = (this || _global).awaitSink,
                n = (this || _global).mseSink;
              t && n ? ["enqueue", "addTrack", "setTimestampOffset"].includes(e.name) ? this.invokeAsync(e) : this.invokeSync(e) : t ? this.invokeAsync(e) : n && this.invokeSync(e);
            }, t.initSink = function () {
              var e = this || _global,
                t = (this || _global).awaitSink;
              if (!(this || _global).mseSink && !t) {
                var n = ge.Z.create((this || _global).onMediaSourceEnded.bind(this || _global), (this || _global).onMediaSourceError.bind(this || _global));
                (this || _global).awaitSink = new fe(function (t, r) {
                  n.sink.then(function (n) {
                    e.handleCreateSuccess(n), t();
                  }).catch(function (t) {
                    e.handleCreateError(t), r();
                  });
                }), this.changeSrc(URL.createObjectURL(n.ms));
              }
            }, t.configure = function (e) {
              var t = e.trackID,
                n = e.codec,
                r = e.group,
                i = e.isProtected;
              this.initSink(), (this || _global).awaitSink || !this.isContentProtectionChanging(e) && !this.isChangingToFromAudioOnly(e) || this.queueNewSink(), this.invoke({
                name: "addTrack",
                arg: o()({}, Ee, {
                  trackID: t,
                  codec: n,
                  group: r,
                  isProtected: i
                })
              });
            }, t.queueNewSink = function () {
              var e = this || _global;
              (this || _global).awaitSink = new fe(function (t, n) {
                e.deferUntilIdle().then(function () {
                  var t = ge.Z.create(e.onMediaSourceEnded.bind(e), e.onMediaSourceError.bind(e));
                  return e.changeSrc(URL.createObjectURL(t.ms)), t.sink;
                }).then(function (n) {
                  e.destroyMSESink(), e.handleCreateSuccess(n), e.play(), t();
                }).catch(function (t) {
                  e.handleCreateError(t), n();
                });
              });
            }, t.addTrack = function (e) {
              var t = e.trackID,
                n = e.codec,
                r = e.group,
                i = e.isProtected,
                o = (this || _global).mseSink;
              try {
                var a = null == o ? void 0 : o.addTrack(t, n, r, i);
                a && (this || _global).playbackMonitor.addSourceBuffer(a, n);
              } catch (e) {
                this.handleCreateError(e);
              }
            }, t.enqueue = function (e) {
              var t,
                n = e.trackID,
                r = e.buffer;
              null == (t = (this || _global).mseSink) || t.append(n, r);
            }, t.endOfStream = function () {
              var e,
                t = this || _global;
              null == (e = (this || _global).mseSink) || e.scheduleUpdate().then(function () {
                return t.playbackMonitor.endOfStream();
              });
            }, t.setTimestampOffset = function (e) {
              var t,
                n = e.trackID,
                r = e.offset;
              null == (t = (this || _global).mseSink) || t.setTimestampOffset(n, r);
            }, t.onSourceDurationChanged = function (e) {
              var t = (this || _global).mseSink,
                n = (this || _global).video;
              if (t) {
                var r = t.duration,
                  i = function (e, t, n) {
                    var r = e;
                    return e === 1 / 0 || e === ve.Sf ? n ? r = 1 / 0 : n || (r = ve.Sf) : e !== t && (r = e), r;
                  }(e, r, n.controls);
                i !== r && t.setDuration(i);
              }
            }, t.play = function () {
              var e,
                t = this || _global;
              null == (e = (this || _global).mseSink) || e.scheduleUpdate().then(function () {
                return t.playbackMonitor.play();
              });
            }, t.pause = function () {
              var e,
                t = this || _global;
              null == (e = (this || _global).mseSink) || e.scheduleUpdate().then(function () {
                return t.playbackMonitor.pause();
              });
            }, t.remove = function (e) {
              var t,
                n = e.start,
                r = e.end;
              null == (t = (this || _global).mseSink) || t.remove(n, r);
            }, t.seekTo = function (e) {
              var t = (this || _global).mseSink,
                n = (this || _global).playbackMonitor,
                r = (this || _global).video,
                i = (0, ue.vG)(r.buffered, r.currentTime, ve.de),
                o = i.start,
                a = i.end;
              e >= o && e < a ? null == t || t.scheduleUpdate().then(function () {
                return n.seekTo(e);
              }) : n.seekTo(e);
            }, t.setVolume = function (e) {
              (this || _global).video.volume !== e && ((this || _global).video.volume = e);
            }, t.getVolume = function () {
              return (this || _global).video.volume;
            }, t.isMuted = function () {
              return (this || _global).video.muted;
            }, t.setMuted = function (e) {
              (this || _global).video.muted !== e && ((this || _global).video.muted = e);
            }, t.setPlaybackRate = function (e) {
              (this || _global).playbackMonitor.setPlaybackRate(e);
            }, t.getPlaybackRate = function () {
              return (this || _global).video.playbackRate;
            }, t.getCurrentTime = function () {
              return (this || _global).video.currentTime;
            }, t.buffered = function () {
              return (0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de);
            }, t.getBufferedRanges = function (e) {
              var t, n;
              return null != (t = null == (n = (this || _global).mseSink) ? void 0 : n.getBufferedRanges(e)) ? t : [];
            }, t.bufferDuration = function () {
              var e = this.buffered(),
                t = e.start;
              return e.end - Math.max(t, (this || _global).video.currentTime);
            }, t.captureGesture = function () {
              (this || _global).playbackMonitor.play(), (this || _global).playbackMonitor.pause();
            }, t.changeSrc = function (e) {
              (0, ue.GX)((this || _global).video, e);
            }, t.changeSrcObj = function (e) {}, t.delete = function () {
              var e;
              (this || _global).playbackMonitor.delete(), null == (e = (this || _global).controlsObserver) || e.disconnect(), this.destroyMSESink(), (0, ue.v8)((this || _global).video);
            }, t.invokeSync = function (e) {
              (this || _global)[e.name].call(this || _global, e.arg);
            }, t.invokeAsync = function (e) {
              var t,
                n = this || _global;
              null == (t = (this || _global).awaitSink) || t.then(function () {
                return n.invokeSync(e);
              }).catch(function () {});
            }, t.onMediaSourceEnded = function () {
              (this || _global).video.load(), (this || _global).listener.onSinkReset();
            }, t.destroyMSESink = function () {
              var e = this || _global,
                t = function () {
                  e.mseSink && e.mseSink.destroy(), e.awaitSink = void 0, e.mseSink = void 0;
                };
              (this || _global).mseSink ? t() : (this || _global).awaitSink && (this || _global).awaitSink.then(function () {
                return t();
              }), (this || _global).playbackMonitor && (this || _global).playbackMonitor.clearSourceBuffers();
            }, t.isContentProtectionChanging = function (e) {
              var t, n;
              return (null != (t = null == (n = (this || _global).mseSink) ? void 0 : n.isDrmProtected()) && t) !== e.isProtected;
            }, t.isChangingToFromAudioOnly = function (e) {
              var t, n;
              return (null != (t = null == (n = (this || _global).mseSink) ? void 0 : n.isAudioOnly()) && t) !== ("audio_only" === e.group);
            }, t.deferUntilIdle = function () {
              var e = this || _global,
                t = (this || _global).mseSink,
                n = (this || _global).playbackMonitor;
              return new fe(function (r) {
                t && !e.video.paused ? n.onSinkIdle = function () {
                  n.onSinkIdle = void 0, r();
                } : r();
              });
            }, t.handleCreateSuccess = function (e) {
              (this || _global).mseSink = e, (this || _global).awaitSink = void 0, this.onSourceDurationChanged(ve.Sf), (this || _global).mseSink.setLiveSeekableRange(0, ve.Sf);
            }, t.handleCreateError = function (e) {
              (this || _global).listener.onSinkError({
                value: S.Pt,
                code: S.Pt,
                message: e.toString()
              });
            }, t.onMediaSourceError = function (e, t, n, r) {
              var i = {
                value: e,
                code: t,
                message: n
              };
              r ? (this || _global).listener.onSinkError(i) : (this || _global).listener.onSinkRecoverableError(i);
            }, t.onVideoError = function () {
              this.destroyMSESink();
            }, t.observeControlsChange = function () {
              var e = this || _global,
                t = (this || _global).video;
              try {
                ((this || _global).controlsObserver = new MutationObserver(function () {
                  e.invoke({
                    name: "onSourceDurationChanged",
                    arg: t.duration
                  });
                })).observe(t, {
                  attributeFilter: ["controls"]
                });
              } catch (e) {}
            }, t.onSegmentDiscontinuity = function () {}, e;
          }(),
          Ee = {
            trackID: 0,
            codec: "codecs=\"magic\"",
            mode: "mse",
            isProtected: !1,
            path: "",
            group: "",
            srcObj: null
          },
          Te = _events,
          Se = function () {
            function e() {
              (this || _global).emitter = void 0, (this || _global).emitter = new Te.EventEmitter();
            }
            var t = e.prototype;
            return t.on = function (e, t) {
              (this || _global).emitter.on(String(e), t);
            }, t.removeListener = function (e, t) {
              (this || _global).emitter.removeListener(String(e), t);
            }, t.emit = function (e) {
              for (var t, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
              (t = (this || _global).emitter).emit.apply(t, [String(e)].concat(r));
            }, t.removeAllListeners = function () {
              (this || _global).emitter.removeAllListeners();
            }, e;
          }(),
          _e = function (e) {
            return e.Pending = "pending", e.Ready = "ready", e.Configuring = "configuring", e.Active = "active", e.Error = "error", e;
          }({}),
          be = function (e) {
            return e.Heartbeat = "heartbeat", e.Configure = "configure", e.Set_Log_Config = "setLogConfig", e.Debug = "debug", e.Destroy = "destroy", e;
          }({}),
          Ce = function (e) {
            return e.State_Changed = "stateChanged", e.Manifest_Load_Analytics = "manifestLoadAnalytics", e.Available_Segments = "availableSegments", e;
          }({});
        function we(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var ke = {
            enabled: !1,
            levels: {
              debug: !0,
              log: !0,
              info: !0,
              warn: !0,
              error: !0
            }
          },
          Ie = new Se(),
          Pe = function (e) {
            var t = e.name,
              n = function (e) {
                if (ke.enabled && ke.levels[e]) {
                  for (var n = new Date().toTimeString().split(" ")[0], r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) i[o - 1] = arguments[o];
                  console[e].apply(console, [n + " - (" + t + ")"].concat(i));
                }
              };
            return {
              debug: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, ["debug"].concat(t));
              },
              log: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, ["log"].concat(t));
              },
              info: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, ["info"].concat(t));
              },
              warn: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, ["warn"].concat(t));
              },
              error: function () {
                for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
                return n.apply(void 0, ["error"].concat(t));
              }
            };
          },
          Ae = Pe({
            name: "sw-host-config"
          });
        function De(e, t) {
          var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (n) return (n = n.call(e)).next.bind(n);
          if (Array.isArray(e) || (n = function (e, t) {
            if (e) {
              if ("string" == typeof e) return Le(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Le(e, t) : void 0;
            }
          }(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0;
            return function () {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function Le(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var Re,
          xe = Pe({
            name: "sw-host"
          }),
          Me = function () {
            return Re;
          },
          Ne = function (e) {
            return e[e.Pending = 0] = "Pending", e[e.Installing = 1] = "Installing", e[e.Ready = 2] = "Ready", e[e.Error = 3] = "Error", e;
          }(Ne || {}),
          Oe = function (e) {
            var t,
              n = function () {
                return {
                  isMSESupported: (0, T.aP)()
                };
              };
            if (((t = e) ? t.url || (Ae.error("Service worker config must specify a url"), 0) : (Ae.error("Service worker config is required"), 0)) && function (e, t) {
              return !(!t.forceActivate && e.isMSESupported);
            }(n(), e)) {
              var r,
                i,
                a = new Se(),
                s = !0,
                u = Ne.Pending,
                c = [],
                d = [],
                l = [],
                h = _e.Pending,
                p = !1,
                m = function () {
                  var t = f()(v().mark(function t() {
                    var n, r;
                    return v().wrap(function (t) {
                      for (;;) switch (t.prev = t.next) {
                        case 0:
                          return t.prev = 0, E(Ne.Installing), navigator.serviceWorker.addEventListener("message", _), t.prev = 3, t.next = 6, g(e.url);
                        case 6:
                          t.next = 11;
                          break;
                        case 8:
                          t.prev = 8, t.t0 = t.catch(3), xe.error("[registerAndActivate] Failed to unregister service worker instances: " + t.t0);
                        case 11:
                          return n = void 0 !== e.scope ? {
                            scope: e.scope
                          } : void 0, t.next = 14, navigator.serviceWorker.register(e.url, n);
                        case 14:
                          return (r = t.sent).installing ? xe.log("Service worker installing") : r.waiting ? xe.log("Service worker installed") : r.active && xe.log("Service worker active"), t.next = 18, y(r);
                        case 18:
                          E(Ne.Ready), t.next = 25;
                          break;
                        case 21:
                          t.prev = 21, t.t1 = t.catch(0), xe.error("Registration failed with " + t.t1), E(Ne.Error);
                        case 25:
                        case "end":
                          return t.stop();
                      }
                    }, t, null, [[0, 21], [3, 8]]);
                  }));
                  return function () {
                    return t.apply(this || _global, arguments);
                  };
                }(),
                g = function () {
                  var e = f()(v().mark(function e(t) {
                    var n;
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return n = new RegExp(t), e.next = 3, navigator.serviceWorker.getRegistrations().then(function () {
                            var e = f()(v().mark(function e(t) {
                              var r, i, o;
                              return v().wrap(function (e) {
                                for (;;) switch (e.prev = e.next) {
                                  case 0:
                                    xe.debug("[unregisterOtherWorkerInstances] registrations", t), r = De(t);
                                  case 2:
                                    if ((i = r()).done) {
                                      e.next = 16;
                                      break;
                                    }
                                    if (null === (o = i.value).active || !n.test(o.active.scriptURL)) {
                                      e.next = 14;
                                      break;
                                    }
                                    return xe.debug("[unregisterOtherWorkerInstances] unregistering:", o), e.prev = 6, e.next = 9, o.unregister();
                                  case 9:
                                    e.next = 14;
                                    break;
                                  case 11:
                                    e.prev = 11, e.t0 = e.catch(6), xe.error("[unregisterOtherWorkerInstances] Failed to unregister service worker: " + e.t0);
                                  case 14:
                                    e.next = 2;
                                    break;
                                  case 16:
                                  case "end":
                                    return e.stop();
                                }
                              }, e, null, [[6, 11]]);
                            }));
                            return function (t) {
                              return e.apply(this || _global, arguments);
                            };
                          }());
                        case 3:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                y = function () {
                  var e = f()(v().mark(function e(t) {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return e.abrupt("return", new Promise(function (e, n) {
                            null !== t.installing || null !== t.waiting ? (t.installing || t.waiting).addEventListener("statechange", function (t) {
                              var r = t.target;
                              xe.debug("sw registration, statechange", r.state), "activated" === r.state ? (xe.log("Service worker activated"), e()) : "redundant" === r.state && n();
                            }) : e();
                          }));
                        case 1:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                E = function (e) {
                  if (xe.log("[changeHostState] host state changed from " + u + " to " + e), (u = e) === Ne.Ready) {
                    var t = c.slice();
                    c = [];
                    for (var n, r = De(t); !(n = r()).done;) (0, n.value)();
                    var i = d.slice();
                    d = [];
                    for (var o, a = De(i); !(o = a()).done;) {
                      var s = o.value;
                      b(s);
                    }
                  } else if (u === Ne.Error) {
                    var f = l.slice();
                    l = [];
                    for (var h, v = De(f); !(h = v()).done;) (0, h.value)();
                  }
                },
                S = function (e) {
                  u === Ne.Error ? e() : l.push(e);
                },
                _ = function (e) {
                  var t = e.data;
                  switch (t.type) {
                    case Ce.State_Changed:
                      var n = t.state;
                      h === _e.Configuring && (p = !1), n === _e.Ready && h !== _e.Pending && xe.warn("[handleMessage] worker was restarted by the browser"), h = n;
                      break;
                    case Ce.Manifest_Load_Analytics:
                      xe.debug("Manifest_Load_Analytics", t);
                  }
                  a.emit(t.type, t);
                },
                b = function () {
                  var e = f()(v().mark(function e(t) {
                    var n;
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return xe.log("[sendMessage] sending message: ", t), e.abrupt("return", null == (n = navigator.serviceWorker.controller) ? void 0 : n.postMessage(t));
                        case 2:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                C = function () {
                  var e = f()(v().mark(function e(t) {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (h !== _e.Pending) {
                            e.next = 4;
                            break;
                          }
                          return xe.log("[sendMessageWhenReady] worker is not ready, queueing message", t), d.push(t), e.abrupt("return");
                        case 4:
                          b(t);
                        case 5:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                w = function () {
                  i && clearTimeout(i), i = setTimeout(function () {
                    k();
                  }, 10000);
                },
                k = function () {
                  s && h !== _e.Pending && (b({
                    type: be.Heartbeat
                  }), w());
                },
                I = function (e, t) {
                  a.on(Ce.State_Changed, function n(r) {
                    r.type === Ce.State_Changed && r.state === e && (a.removeListener(Ce.State_Changed, n), t(r));
                  });
                },
                P = function () {
                  var e = f()(v().mark(function e() {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (u !== Ne.Ready) {
                            e.next = 2;
                            break;
                          }
                          return e.abrupt("return");
                        case 2:
                          return e.abrupt("return", new Promise(function (e, t) {
                            var n;
                            n = function () {
                              xe.log("[ensureHostReady] host state changed to ready"), e();
                            }, u === Ne.Ready ? n() : c.push(n), S(function () {
                              xe.log("[ensureHostReady] host state changed to error"), t();
                            });
                          }));
                        case 3:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function () {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                A = function () {
                  var e = f()(v().mark(function e() {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (h === _e.Pending) {
                            e.next = 2;
                            break;
                          }
                          return e.abrupt("return");
                        case 2:
                          return e.abrupt("return", new Promise(function (e, t) {
                            I(_e.Ready, function (t) {
                              xe.log("[ensureWorkerReady] worker state changed to ready", t), e();
                            });
                          }));
                        case 3:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function () {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                D = function () {
                  var e = f()(v().mark(function e() {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return e.next = 2, P();
                        case 2:
                          return e.next = 4, A();
                        case 4:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function () {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                L = function () {
                  var e = f()(v().mark(function e(t) {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          return p = !0, r = R(null != t ? t : {}), e.next = 4, D();
                        case 4:
                          b({
                            type: be.Configure,
                            config: r
                          });
                        case 5:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function (t) {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                R = function (e) {
                  return o()({}, r, e);
                },
                x = function () {
                  var e = f()(v().mark(function e() {
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (p || h !== _e.Active) {
                            e.next = 2;
                            break;
                          }
                          return e.abrupt("return");
                        case 2:
                          return e.next = 4, D();
                        case 4:
                          return e.abrupt("return", new Promise(function (e, t) {
                            I(_e.Active, function (t) {
                              xe.log("[ensureConfigured] worker state changed to active", t), e();
                            });
                          }));
                        case 5:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  }));
                  return function () {
                    return e.apply(this || _global, arguments);
                  };
                }(),
                M = function (e) {
                  C({
                    type: be.Set_Log_Config,
                    config: e
                  });
                };
              return function () {
                var t,
                  i,
                  a,
                  s,
                  u,
                  c,
                  d,
                  l,
                  f,
                  h,
                  v,
                  p,
                  m,
                  g,
                  y,
                  E,
                  T,
                  S,
                  _,
                  C,
                  k = n().isMSESupported ? {
                    cacheMultivariant: !1,
                    transformTargetDuration: !1,
                    lowLatencyMode: {
                      enabled: !1,
                      useLocalSegment: !1,
                      convertPrefetchSegment: !1,
                      preloadPrefetchSegments: !1
                    },
                    driftDetection: {
                      enabled: !1,
                      maxPlaylistPosition: 0,
                      triggerDetectionThreshold: 0,
                      minDurationBetweenCorrections: 0
                    },
                    debug: {
                      addMultivariantDelay: void 0,
                      addFirstVariantDelay: void 0
                    }
                  } : {
                    cacheMultivariant: !0,
                    transformTargetDuration: !1,
                    lowLatencyMode: {
                      enabled: !0,
                      useLocalSegment: !0,
                      convertPrefetchSegment: !0,
                      preloadPrefetchSegments: !1
                    },
                    driftDetection: {
                      enabled: !0,
                      maxPlaylistPosition: 3,
                      triggerDetectionThreshold: 10,
                      minDurationBetweenCorrections: 60
                    },
                    debug: {
                      addMultivariantDelay: void 0,
                      addFirstVariantDelay: void 0
                    }
                  };
                r = {
                  cacheMultivariant: null != (t = e.cacheMultivariant) ? t : k.cacheMultivariant,
                  transformTargetDuration: null != (i = e.transformTargetDuration) ? i : k.transformTargetDuration,
                  lowLatencyMode: {
                    enabled: null != (a = null == (s = e.lowLatencyMode) ? void 0 : s.enabled) ? a : k.lowLatencyMode.enabled,
                    useLocalSegment: null != (u = null == (c = e.lowLatencyMode) ? void 0 : c.useLocalSegment) ? u : k.lowLatencyMode.useLocalSegment,
                    convertPrefetchSegment: null != (d = null == (l = e.lowLatencyMode) ? void 0 : l.convertPrefetchSegment) ? d : k.lowLatencyMode.convertPrefetchSegment,
                    preloadPrefetchSegments: null != (f = null == (h = e.lowLatencyMode) ? void 0 : h.preloadPrefetchSegments) ? f : k.lowLatencyMode.preloadPrefetchSegments
                  },
                  driftDetection: {
                    enabled: null != (v = null == (p = e.driftDetection) ? void 0 : p.enabled) ? v : k.driftDetection.enabled,
                    maxPlaylistPosition: null != (m = null == (g = e.driftDetection) ? void 0 : g.maxPlaylistPosition) ? m : k.driftDetection.maxPlaylistPosition,
                    triggerDetectionThreshold: null != (y = null == (E = e.driftDetection) ? void 0 : E.triggerDetectionThreshold) ? y : k.driftDetection.triggerDetectionThreshold,
                    minDurationBetweenCorrections: null != (T = null == (S = e.driftDetection) ? void 0 : S.minDurationBetweenCorrections) ? T : k.driftDetection.minDurationBetweenCorrections
                  },
                  debug: {
                    addMultivariantDelay: null == (_ = e.debug) ? void 0 : _.addMultivariantDelay,
                    addFirstVariantDelay: null == (C = e.debug) ? void 0 : C.addFirstVariantDelay
                  }
                }, xe.info("[init] instantiating with config", r), void 0 !== e.debug && (e.debug.api = {
                  delayNextMediaManifest: function (e) {
                    !function (e) {
                      if ("delayNextMediaManifest" === e.api) {
                        var t = e.delayInMs;
                        xe.log("[handleDebugApiMessage] delaying next manifest by " + t + "ms");
                      }
                      b(o()({
                        type: be.Debug
                      }, e));
                    }({
                      api: "delayNextMediaManifest",
                      delayInMs: e
                    });
                  }
                }), Ie.on("logConfigUpdated", M), w();
              }(), {
                registerAndActivate: m,
                addListener: function (e, t) {
                  a.on(e, t);
                },
                removeListener: function (e, t) {
                  a.removeListener(e, t);
                },
                sendMessage: b,
                ensureReady: D,
                configure: L,
                ensureConfigured: x,
                getConfig: function () {
                  return r;
                },
                getDriftDetectionConfig: function () {
                  var e;
                  return null == (e = r) ? void 0 : e.driftDetection;
                },
                setLogConfig: M,
                destroy: function () {
                  xe.log("[destroy] destroying"), s = !1, i && clearTimeout(i), a.removeAllListeners(), Ie.removeListener("logConfigUpdated", M), navigator.serviceWorker.removeEventListener("message", _), b({
                    type: be.Destroy
                  });
                },
                debugPassthroughAnalytics: function (t) {
                  var n;
                  null == (n = e.debug) || null == n.onPassthroughAnalytics || n.onPassthroughAnalytics(t);
                }
              };
            }
          },
          Ue = n(806),
          Fe = n(898),
          He = n.n(Fe),
          Ve = function () {
            function e() {
              (this || _global).serverOffsetVal = e.SERVER_OFFSET_DEFAULT, (this || _global).liveLatencyVal = 0, (this || _global).lastTranscodeReceive = -1;
            }
            var t = e.prototype;
            return t.tryGenerateServerOffset = function (t) {
              return (this || _global).serverOffsetVal !== e.SERVER_OFFSET_DEFAULT ? (console.warn("[generateServerOffset] the server offset has already been generated, skipping"), !1) : ((this || _global).serverOffsetVal = function (e, t) {
                return new Date(1000 * t).getTime() - e;
              }(Date.now(), t), !0);
            }, t.tryUpdateLatency = function (t) {
              return (this || _global).serverOffsetVal !== e.SERVER_OFFSET_DEFAULT && (t < (this || _global).lastTranscodeReceive ? (console.warn("[updateLatency] received latency values too old, ignoring. previous: " + (this || _global).lastTranscodeReceive + " current: " + t), !1) : ((this || _global).liveLatencyVal = function (e, t, n) {
                return (e + t - n) / 1000;
              }(Date.now(), (this || _global).serverOffsetVal, t), (this || _global).lastTranscodeReceive = t, !0));
            }, He()(e, [{
              key: "serverOffset",
              get: function () {
                return (this || _global).serverOffsetVal;
              }
            }, {
              key: "liveLatency",
              get: function () {
                return (this || _global).liveLatencyVal;
              }
            }]);
          }();
        Ve.SERVER_OFFSET_DEFAULT = -1;
        var Ge = function (e) {
            var t = parseFloat(e);
            if (!isNaN(t)) return t;
          },
          Be = function (e) {
            return e.Live_Latency_Load = "liveLatencyLoad", e.Live_Latency_Stats = "liveLatencyStats", e;
          }({}),
          We = function (e) {
            return e.Trigger_Drift_Correction = "triggerDriftCorrection", e;
          }({}),
          je = function (e) {
            return e.ID3 = "org.id3", e.APPLE_HLS = "com.apple.quicktime.HLS", e;
          }(je || {}),
          Ke = function (e) {
            return e.PRIV = "PRIV", e.TXXX = "TXXX", e.TDEN = "TDEN", e.STREAM_LEVEL_SERVER_TIME = "X-SERVER-TIME", e;
          }(Ke || {}),
          ze = Pe({
            name: "sink"
          }),
          qe = function (e) {
            function t(t, n) {
              var r;
              (r = e.call(this || _global, n, t) || this || _global).intervalId = void 0, r.bufferingTimeoutId = void 0, r.attemptingToPlay = void 0, r.hasPlayedSrc = void 0, r.hasReloadedOnDecodeError = void 0, r.unsubscribersForTrackEvents = void 0, r.latencyStatistics = void 0, r.processedInitialCues = void 0, r.serviceWorker = void 0, r.serviceWorkerHandler = void 0, r.positionTracker = void 0, r.driftDetector = void 0, r.driftDetectorHandler = void 0, r.analytics = void 0, r.analyticsHandler = void 0, r.intervalId = -1, r.bufferingTimeoutId = -1, r.attemptingToPlay = !1, r.hasPlayedSrc = !1, r.hasReloadedOnDecodeError = !1, r.unsubscribersForTrackEvents = [], r.latencyStatistics = new Ve(), r.processedInitialCues = !1, r.addListener("waiting", function () {
                return r.onVideoWaiting();
              }, r.video), r.addListener("timeupdate", function () {
                return r.onVideoTimeUpdate();
              }, r.video), r.addListener("durationchange", function () {
                return r.onVideoDurationChange();
              }, r.video), r.addListener("error", function () {
                return r.onVideoError();
              }, r.video), r.addListener("play", function () {
                return r.onVideoPlay();
              }, r.video), r.addListener("pause", function () {
                return r.onVideoPause();
              }, r.video), r.addListener("ended", function () {
                return r.onVideoEnded();
              }, r.video), r.addListener("playing", function () {
                return r.onVideoPlaying();
              }, r.video);
              var i,
                a,
                s,
                u,
                c,
                d,
                l,
                f,
                h,
                v,
                p,
                m,
                g,
                y,
                E = (0, Ue.sQ)(document).visibilityChange;
              if (r.addListener(E, function () {
                return r.onVisibilityChange();
              }, document), r.serviceWorker = Me(), r.serviceWorkerHandler = function (e) {
                return r.onServiceWorkerMessage(e);
              }, r.addServiceWorkerListeners(), void 0 !== r.serviceWorker) {
                var T;
                r.positionTracker = (p = [], m = -1, g = function () {
                  return 0 === p.length || void 0 === v ? (m = -1, !1) : -1 !== (m = y(v));
                }, y = function (e) {
                  var t = new RegExp("^" + e);
                  if (p) {
                    var n = p.findIndex(function (e) {
                      return t.test(e.pdt);
                    });
                    if (-1 === n) for (var r = new Date(e + "Z"), i = 0; i < p.length; i++) {
                      var o = p[i],
                        a = new Date(o.pdt);
                      if (a.getTime() <= r.getTime() && a.getTime() + 1000 * o.duration > r.getTime()) {
                        n = i;
                        break;
                      }
                    }
                    if (-1 !== n) return n;
                  }
                  return console.warn("Couldn't find segment for PDT " + e), -1;
                }, {
                  processAvailableSegments: function (e) {
                    return p = e, g();
                  },
                  processTDEN: function (e) {
                    return v = e, g();
                  },
                  getCurrentPosition: function () {
                    return m;
                  }
                });
                var S = null == (T = r.serviceWorker) ? void 0 : T.getDriftDetectionConfig();
                void 0 !== S && S.enabled && (r.driftDetector = (i = {
                  maxPlaylistPosition: S.maxPlaylistPosition,
                  triggerDetectionThreshold: S.triggerDetectionThreshold,
                  minDurationBetweenCorrections: S.minDurationBetweenCorrections
                }, c = new Se(), d = 0, l = 0, f = function () {
                  if (void 0 !== a && void 0 !== s) if (a <= i.maxPlaylistPosition) l = 0;else if ((l += 1) > i.triggerDetectionThreshold) {
                    console.debug("[handleDriftDetection] above detection threshold");
                    var e = Date.now();
                    (void 0 === u || e - u > i.minDurationBetweenCorrections) && (console.debug("[handleDriftDetection] within min duration, triggering rebuffer-to-live"), h(e, a, s));
                  }
                }, h = function (e, t, n) {
                  d += 1, u = e, l = 0;
                  var r = {
                    type: We.Trigger_Drift_Correction,
                    playlistPosition: t,
                    playhead: n,
                    rebufferCount: d
                  };
                  c.emit(We.Trigger_Drift_Correction, r);
                }, {
                  addListener: function (e, t) {
                    c.on(e, t);
                  },
                  removeListener: function (e, t) {
                    c.removeListener(e, t);
                  },
                  processPlaylistPosition: function (e) {
                    a = e;
                  },
                  processTimeUpdate: function (e) {
                    var t = Math.floor(e);
                    void 0 !== s && t === s || (s = t, f());
                  }
                }), r.driftDetectorHandler = function (e) {
                  return r.onDriftDetectorEvent(e);
                }, r.addDriftDetectorListeners()), r.analytics = function () {
                  var e,
                    t,
                    n,
                    r,
                    i = new Se(),
                    a = {},
                    s = {
                      duration: 0
                    },
                    u = {
                      min: 0,
                      avg: 0,
                      max: 0,
                      last: 0
                    },
                    c = {
                      first: void 0,
                      last: void 0
                    },
                    d = {
                      count: 0
                    },
                    l = function () {
                      if ((n = Be.Live_Latency_Load) === Be.Live_Latency_Load && void 0 === a[n] && void 0 !== e && void 0 !== t) {
                        var n,
                          r = a[Be.Live_Latency_Load] || 0;
                        a[Be.Live_Latency_Load] = r + 1, i.emit(Be.Live_Latency_Load, {
                          type: Be.Live_Latency_Load,
                          serverOffset: e,
                          manifestLoadAnalytics: t
                        });
                      }
                    },
                    f = function () {
                      var e = a[Be.Live_Latency_Stats] || 0;
                      a[Be.Live_Latency_Stats] = e + 1, i.emit(Be.Live_Latency_Stats, {
                        type: Be.Live_Latency_Stats,
                        playlistPosition: o()({}, u),
                        liveLatencyTiming: o()({}, c),
                        driftCorrection: o()({}, d)
                      });
                    };
                  return {
                    addListener: function (e, t) {
                      i.on(e, t);
                    },
                    removeListener: function (e, t) {
                      i.removeListener(e, t);
                    },
                    processServerOffset: function (t) {
                      e = {
                        serverTime: 1000 * t.serverTime,
                        clientTime: t.clientTime,
                        serverOffset: t.serverOffset
                      }, l();
                    },
                    processManifestLoadAnalytics: function (e) {
                      t = e, l();
                    },
                    processSinkState: function (e) {
                      "playing" === n && "pause" === e && f(), n = e;
                    },
                    processTimeUpdate: function (e) {
                      var t = Math.floor(e);
                      void 0 !== r && t === r || (s.duration += 1, r = t, s.duration % 10 == 0 && f());
                    },
                    processPlaylistPosition: function (e) {
                      e < u.min && (u.min = e), e > u.max && (u.max = e), 0 === u.avg ? u.avg = e : u.avg = (u.avg * s.duration + e) / (s.duration + 1), u.last = e;
                    },
                    processLiveLatencyUpdate: function (e) {
                      void 0 === c.first && (c.first = o()({}, e)), c.last = o()({}, e);
                    },
                    processDriftCorrectionStart: function () {
                      d.count += 1;
                    }
                  };
                }(), r.analyticsHandler = function (e) {
                  return r.onAnalyticsEvent(e);
                }, r.addAnalyticsListeners();
              }
              return r;
            }
            re()(t, e);
            var n = t.prototype;
            return n.invoke = function (e) {
              (this || _global)[e.name].call(this || _global, e.arg);
            }, n.configure = function (e) {
              var t = e.path;
              this.handleTrackEvents(), (this || _global).hasReloadedOnDecodeError = !1, (this || _global).hasPlayedSrc = !1, (this || _global).video.src = t;
            }, n.play = function () {
              var e = this || _global,
                t = (this || _global).video.buffered;
              if (t.length > 0) {
                var n = t.start(t.length - 1),
                  r = t.end(t.length - 1);
                (this || _global).video.duration === 1 / 0 && (r < (this || _global).video.currentTime || (this || _global).video.currentTime < n) && ((this || _global).listener.onSinkGapJump(n - (this || _global).video.currentTime), console.warn("Moving to buffered region"), (this || _global).video.currentTime = n);
              }
              (this || _global).paused = !1, (this || _global).attemptingToPlay = !0, (void 0 === e.serviceWorker || e.hasPlayedSrc ? Promise.resolve(e.video.play()) : e.serviceWorker.ensureConfigured().catch(function (e) {
                ze.warn("sw, ensureConfigured failed", e);
              }).then(function () {
                return Promise.resolve(e.video.play());
              })).then(function () {
                e.attemptingToPlay = !1, e.hasPlayedSrc = !0;
              }).catch(function () {
                e.attemptingToPlay = !1, e.checkStopped(!0);
              });
            }, n.pause = function () {
              e.prototype.pause.call(this || _global), clearTimeout((this || _global).intervalId);
            }, n.seekTo = function (e) {
              (this || _global).video.currentTime = e;
            }, n.setVolume = function (e) {
              (this || _global).video.volume = e;
            }, n.getVolume = function () {
              return (this || _global).video.volume;
            }, n.buffered = function () {
              return (0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de);
            }, n.decodedFrames = function () {
              return (0, ue.xB)((this || _global).video);
            }, n.droppedFrames = function () {
              return (0, ue.ld)((this || _global).video);
            }, n.delete = function () {
              e.prototype.delete.call(this || _global), this.removeTrackListeners(), this.removeServiceWorkerListeners(), this.removeDriftDetectorListeners(), this.removeAnalyticsListeners(), (this || _global).video.src = "", (this || _global).video.load();
            }, n.isMuted = function () {
              return (this || _global).video.muted;
            }, n.setMuted = function (e) {
              (this || _global).video.muted = e;
            }, n.getPlaybackRate = function () {
              return (this || _global).video.playbackRate;
            }, n.getCurrentTime = function () {
              return (this || _global).video.currentTime;
            }, n.bufferDuration = function () {
              var e = this.buffered(),
                t = e.start;
              return e.end - Math.max(t, (this || _global).video.currentTime);
            }, n.captureGesture = function () {
              Promise.resolve((this || _global).video.play()).catch(function () {}), (this || _global).video.pause();
            }, n.addServiceWorkerListeners = function () {
              void 0 !== (this || _global).serviceWorker && ((this || _global).serviceWorker.addListener(Ce.Manifest_Load_Analytics, (this || _global).serviceWorkerHandler), (this || _global).serviceWorker.addListener(Ce.Available_Segments, (this || _global).serviceWorkerHandler));
            }, n.onServiceWorkerMessage = function (e) {
              switch (e.type) {
                case Ce.Manifest_Load_Analytics:
                  var t;
                  null == (t = (this || _global).analytics) || t.processManifestLoadAnalytics(e.data);
                  break;
                case Ce.Available_Segments:
                  var n;
                  null == (n = (this || _global).positionTracker) || n.processAvailableSegments(e.segments);
              }
            }, n.removeServiceWorkerListeners = function () {
              void 0 !== (this || _global).serviceWorker && ((this || _global).serviceWorker.removeListener(Ce.Manifest_Load_Analytics, (this || _global).serviceWorkerHandler), (this || _global).serviceWorker.removeListener(Ce.Available_Segments, (this || _global).serviceWorkerHandler));
            }, n.addDriftDetectorListeners = function () {
              var e;
              null == (e = (this || _global).driftDetector) || e.addListener(We.Trigger_Drift_Correction, (this || _global).driftDetectorHandler);
            }, n.onDriftDetectorEvent = function (e) {
              var t;
              e.type === We.Trigger_Drift_Correction && (ze.debug("triggering drift correction", e), null == (t = (this || _global).analytics) || t.processDriftCorrectionStart(), this.resumeAtLive());
            }, n.resumeAtLive = function () {
              this.pause(), this.configure({
                path: (this || _global).video.src
              }), this.play();
            }, n.removeDriftDetectorListeners = function () {
              var e;
              null == (e = (this || _global).driftDetector) || e.removeListener(We.Trigger_Drift_Correction, (this || _global).driftDetectorHandler);
            }, n.addAnalyticsListeners = function () {
              var e, t;
              null == (e = (this || _global).analytics) || e.addListener(Be.Live_Latency_Load, (this || _global).analyticsHandler), null == (t = (this || _global).analytics) || t.addListener(Be.Live_Latency_Stats, (this || _global).analyticsHandler);
            }, n.onAnalyticsEvent = function (e) {
              var t;
              switch (null == (t = (this || _global).serviceWorker) || t.debugPassthroughAnalytics(e), e.type) {
                case Be.Live_Latency_Load:
                  ze.debug("analytics event, Live Latency Load", e.serverOffset, e.manifestLoadAnalytics);
                  break;
                case Be.Live_Latency_Stats:
                  ze.debug("analytics event, Live Latency Stats", e.playlistPosition, e.liveLatencyTiming, e.driftCorrection);
              }
            }, n.removeAnalyticsListeners = function () {
              var e, t;
              null == (e = (this || _global).analytics) || e.removeListener(Be.Live_Latency_Load, (this || _global).analyticsHandler), null == (t = (this || _global).analytics) || t.removeListener(Be.Live_Latency_Stats, (this || _global).analyticsHandler);
            }, n.addTrackListener = function (e, t, n) {
              (this || _global).unsubscribersForTrackEvents.push((0, ue.B1)(n, e, t));
            }, n.removeTrackListeners = function () {
              (this || _global).unsubscribersForTrackEvents.forEach(function (e) {
                return e();
              });
            }, n.checkTracksStatus = function () {
              for (var e = (this || _global).video.textTracks, t = 0; t < e.length; t++) {
                var n = e[t];
                "metadata" === n.kind && "disabled" === n.mode && (n.mode = "hidden");
              }
            }, n.handleTDENDataReceived = function (e) {
              if (void 0 !== (this || _global).positionTracker && (this || _global).positionTracker.processTDEN(e)) {
                var t,
                  n,
                  r = (this || _global).positionTracker.getCurrentPosition();
                null == (t = (this || _global).analytics) || t.processPlaylistPosition(r), null == (n = (this || _global).driftDetector) || n.processPlaylistPosition(r);
              }
            }, n.handleTXXXSegmentDataReceived = function (e) {
              var t,
                n = function (e) {
                  var t = (0, Ue.N8)(e);
                  if ("transc_r" in t) return {
                    transc_r: parseInt(t.transc_r)
                  };
                }(e);
              void 0 !== n && (n.transc_r > 0 && (this || _global).listener.onPassthroughSinkPropertyChanged("transcodeReceiveInSecs", n.transc_r / 1000), (this || _global).latencyStatistics.tryUpdateLatency(n.transc_r) && ((this || _global).listener.onPassthroughSinkPropertyChanged("liveLatency", (this || _global).latencyStatistics.liveLatency), null == (t = (this || _global).analytics) || t.processLiveLatencyUpdate({
                transc_r: n.transc_r,
                latency: (this || _global).latencyStatistics.liveLatency
              })));
            }, n.handleInitialCues = function (e) {
              for (var t, n, r = 0; r < e.length; ++r) {
                var i = e[r];
                i.type === je.APPLE_HLS && i.value.key === Ke.STREAM_LEVEL_SERVER_TIME && (t = Ge(i.value.data));
              }
              (this || _global).processedInitialCues = !0, void 0 !== t && (this || _global).latencyStatistics.tryGenerateServerOffset(t) && (null == (n = (this || _global).analytics) || n.processServerOffset({
                serverTime: t,
                clientTime: Date.now(),
                serverOffset: (this || _global).latencyStatistics.serverOffset
              }));
            }, n.shouldPropagateCue = function (e) {
              var t = e.type,
                n = e.value;
              return !(t !== je.ID3 || !n || !(n.key === Ke.TXXX && "segmentmetadata" !== n.info || n.key === Ke.PRIV && n.info === q._.METADATA_ID || n.key === Ke.PRIV && n.info === q._.INBAND_METADATA_ID));
            }, n.handleCueChange = function (e) {
              var t = this || _global,
                n = new Set();
              this.addTrackListener("cuechange", function () {
                var r;
                !t.processedInitialCues && e.cues && t.handleInitialCues(e.cues);
                var i = null != (r = e.activeCues) ? r : [];
                if (i.length > 0) {
                  for (var o = new Set(), a = 0; a < i.length; ++a) {
                    var s = i[a];
                    if (!n.has(s)) {
                      var u = s.value;
                      if (t.listener.onPassthroughSinkDataCue(s), u.key === Ke.TXXX && "segmentmetadata" === u.info && t.handleTXXXSegmentDataReceived(u.data), u.key === Ke.TDEN && t.handleTDENDataReceived(u.data), t.shouldPropagateCue(s)) {
                        var c = u.key === Ke.PRIV ? new TextDecoder("utf-8").decode(u.data) : u.data || "",
                          d = u.info || "";
                        t.listener.onPassthroughSinkMetadata(s.startTime, s.endTime, c, d, d);
                      }
                    }
                    o.add(s);
                  }
                  n = o;
                }
              }, e);
            }, n.handleTrackEvents = function () {
              var e = this || _global;
              this.removeTrackListeners(), void 0 === window.DataCue && void 0 === window.WebKitDataCue || (this.addTrackListener("change", function () {
                e.checkTracksStatus();
              }, (this || _global).video.textTracks), this.addTrackListener("addtrack", function (t) {
                var n = t.track;
                "metadata" === n.kind && "disabled" === n.mode && (n.mode = "hidden", e.handleCueChange(n));
              }, (this || _global).video.textTracks));
            }, n.onVideoWaiting = function () {
              var e = this || _global;
              if ((0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de).end - (this || _global).video.currentTime < ve.de) {
                (this || _global).listener.onSinkIdle(), clearTimeout((this || _global).bufferingTimeoutId), (this || _global).bufferingTimeoutId = self.setTimeout(function () {
                  e.listener.onSinkError({
                    value: S.yY,
                    code: S.yY,
                    message: "Buffering timeout"
                  });
                }, ve.Pp);
                var t = (0, ue.B1)((this || _global).video, "timeupdate", function () {
                  t(), clearTimeout(e.bufferingTimeoutId);
                });
              }
              var n = (0, ue.B1)((this || _global).video, "timeupdate", function () {
                4 === e.video.readyState && (n(), e.onVideoPlaying());
              });
            }, n.onVideoTimeUpdate = function () {
              var e, t;
              (this || _global).listener.onSinkTimeUpdate(), null == (e = (this || _global).analytics) || e.processTimeUpdate(this.getCurrentTime()), null == (t = (this || _global).driftDetector) || t.processTimeUpdate(this.getCurrentTime());
            }, n.onVideoDurationChange = function () {
              (this || _global).listener.onSinkDurationChanged((this || _global).video.duration);
            }, n.onVideoError = function () {
              var e = (this || _global).video.error,
                t = e.code,
                n = e.message,
                r = void 0 === n ? "" : n,
                i = -1 !== (this || _global).video.src.indexOf(".m3u8");
              if (t === S.Pt && !(this || _global).hasPlayedSrc && i) return clearTimeout((this || _global).bufferingTimeoutId), void (this || _global).listener.onSinkError({
                value: S.$_,
                code: S.$_,
                message: r
              });
              t !== S.ok || (this || _global).hasReloadedOnDecodeError ? (this || _global).listener.onSinkError({
                value: t,
                code: t,
                message: r
              }) : (this || _global).hasReloadedOnDecodeError || ((this || _global).hasReloadedOnDecodeError = !0, console.warn("Reload video element on MEDIA_ERR_DECODE 3"), (this || _global).video.load());
            }, n.onVideoPlay = function () {
              var e = this || _global,
                t = (this || _global).video.currentTime;
              clearTimeout((this || _global).intervalId), (this || _global).intervalId = self.setTimeout(function () {
                return e.heartbeat(t);
              }, ve.HJ);
            }, n.onVideoPause = function () {
              var e;
              clearTimeout((this || _global).intervalId), (this || _global).attemptingToPlay || (null == (e = (this || _global).analytics) || e.processSinkState("pause"), this.checkStopped(!1));
            }, n.onVideoEnded = function () {
              (this || _global).listener.onSinkEnded();
            }, n.onVideoPlaying = function () {
              var e;
              null == (e = (this || _global).analytics) || e.processSinkState("playing"), (this || _global).listener.onSinkPlaying((this || _global).paused), this.trackBufferUpdate((0, ue.vG)((this || _global).video.buffered, (this || _global).video.currentTime, ve.de).end);
            }, n.onVisibilityChange = function () {
              var e = (0, Ue.sQ)(document).hidden;
              document[e] && ((this || _global).hasReloadedOnDecodeError = !1);
            }, n.heartbeat = function (e) {
              var t = this || _global,
                n = (this || _global).video.currentTime;
              if (n === e) {
                if ((0, ue.V3)((this || _global).video, ve.de)) return void (this || _global).listener.onSinkIdle();
                var r = (0, ue.tX)((this || _global).video.buffered, n, ve.de);
                r !== n && (console.warn("jumping " + (r - n) + "s gap"), (this || _global).listener.onSinkGapJump(r - (this || _global).video.currentTime), (this || _global).video.currentTime = r, n = (this || _global).video.currentTime);
              }
              (this || _global).intervalId = self.setTimeout(function () {
                return t.heartbeat(n);
              }, ve.HJ);
            }, n.trackBufferUpdate = function (e) {
              var t = this || _global,
                n = this.buffered().end;
              n !== e && (this || _global).listener.onSinkBufferUpdate();
              var r = (0, ue.B1)((this || _global).video, "timeupdate", function () {
                r(), t.trackBufferUpdate(n);
              });
            }, t;
          }(he),
          Qe = function (e) {
            function t() {
              return e.apply(this || _global, arguments) || this || _global;
            }
            return re()(t, e), t.prototype.onIdle = function () {
              (this || _global).onSinkIdle ? this.onSinkIdle() : (this || _global).listener.onSinkIdle();
            }, t;
          }(pe),
          Ye = function (e) {
            function t(t, n, r) {
              var i;
              return (i = e.call(this || _global, t, n, new Qe(n, t)) || this || _global).listener = t, i.video = n, i.adjustments = r, i;
            }
            re()(t, e);
            var n = t.prototype;
            return n.configure = function (e) {
              var t = e.trackID,
                n = e.codec,
                r = e.group,
                i = e.isProtected;
              if (this.initSink(), this.isContentProtectionChanging(e) && this.queueNewSink(), this.isNewSinkNeeded(e)) {
                this.queueNewSink();
                var a = this.getTrack(ve.kD.audio);
                a && this.invoke({
                  name: "addTrack",
                  arg: a
                });
              }
              this.invoke({
                name: "addTrack",
                arg: o()({}, Ze, {
                  trackID: t,
                  codec: n,
                  group: r,
                  isProtected: i
                })
              });
            }, n.queueNewSink = function () {
              var e = this || _global;
              (this || _global).awaitSink = new Promise(function (t, n) {
                e.deferUntilIdle().then(function () {
                  var t = ge.Z.create(e.onMediaSourceEnded.bind(e), e.onMediaSourceError.bind(e));
                  return e.changeSrc(URL.createObjectURL(t.ms)), t.sink;
                }).then(function (n) {
                  e.invokeAsync({
                    name: "play",
                    arg: void 0
                  }), e.destroyMSESink(), e.handleCreateSuccess(n), t();
                }).catch(function (t) {
                  e.handleCreateError(t), n();
                });
              });
            }, n.deferUntilIdle = function () {
              var e = this || _global,
                t = (this || _global).mseSink,
                n = (this || _global).playbackMonitor;
              return new Promise(function (r) {
                t && !e.video.paused ? (n.onSinkIdle = function () {}, e.video.addEventListener("waiting", function () {
                  n.onSinkIdle = void 0, r();
                }, {
                  once: !0
                })) : r();
              });
            }, n.onSegmentDiscontinuity = function () {
              var e = (this || _global).adjustments,
                t = (this || _global).awaitSink,
                n = (this || _global).mseSink;
              e.rebuildMediaSinkOnDiscontinuity && n && !t && this.queueNewSink();
            }, n.isSinkVideoSourceQualityChangeRequired = function (e, t) {
              return !!(this || _global).adjustments.rebuildMediaSinkOnSourceQualityChange && "chunked" === e != ("chunked" === t);
            }, n.isNewSinkNeeded = function (e) {
              var t = (this || _global).adjustments,
                n = (this || _global).mseSink,
                r = (this || _global).awaitSink;
              if (e.trackID !== ve.kD.video) return !1;
              if (!t.rebuildMediaSinkOnSourceQualityChange) return !1;
              if (!n || r) return !1;
              var i = this.getTrack(ve.kD.video),
                o = this.getTrack(ve.kD.audio);
              return !(!i || !o) && this.isSinkVideoSourceQualityChangeRequired(i.group, e.group);
            }, n.getTrack = function (e) {
              var t,
                n = (this || _global).mseSink;
              return null != (t = null == n ? void 0 : n.bufferProperties.find(function (t) {
                return t.trackID === e;
              })) ? t : null;
            }, t;
          }(ye),
          Ze = {
            trackID: 0,
            codec: "codecs=\"magic\"",
            mode: "mse",
            isProtected: !1,
            path: "",
            group: "",
            srcObj: null
          },
          Xe = function () {
            function e(e, t, n, r) {
              (this || _global).listener = e, (this || _global).adjustments = n, (this || _global).video = void 0, (this || _global).drmManager = void 0, (this || _global).codecs = void 0, (this || _global).sink = void 0, (this || _global).observer = void 0, (this || _global).remoteDevicesListener = void 0, (this || _global).video = r, (this || _global).listener = e, (this || _global).drmManager = new te({
                video: (this || _global).video,
                listener: e
              }), (this || _global).codecs = Object.create(null), (this || _global).sink = new se((this || _global).video), t && ((this || _global).remoteDevicesListener = ae.lookForRemotePlaybackDevices((this || _global).listener)), (this || _global).observer = new ce((this || _global).video, e);
            }
            var t = e.prototype;
            return t.videoElement = function () {
              return (this || _global).video;
            }, t.delete = function () {
              var e;
              this.reset(), null == (e = (this || _global).remoteDevicesListener) || e.then(function (e) {
                e && ae.stopLookingForRemotePlaybackDevices(e);
              });
            }, t.configure = function (e) {
              var t = e.mode,
                n = e.codec,
                r = e.trackID;
              (this || _global).sink instanceof se && ((this || _global).sink = this.getSink(t)), n ? (this || _global).codecs[r] = n : e.codec = (this || _global).codecs[r], (this || _global).sink.configure(e);
              var i = e.path,
                o = e.isProtected;
              i && o && (this || _global).drmManager.configure(i), (this || _global).observer.onConfigure();
            }, t.applyRPC = function (e) {
              (this || _global).observer.trackRPC(e), (this || _global).sink.invoke(e);
            }, t.getCurrentSink = function () {
              return (this || _global).sink;
            }, t.reset = function () {
              (this || _global).sink.delete(), (this || _global).drmManager.reset(), (this || _global).sink = new se((this || _global).video), (this || _global).listener.onSinkTimeUpdate(), (this || _global).listener.onSinkBufferUpdate();
            }, t.isProtected = function () {
              return (this || _global).drmManager.isProtected();
            }, t.captureGesture = function () {
              (this || _global).video.played.length || (this || _global).sink.captureGesture();
            }, t.destroy = function () {
              (this || _global).observer.unsubscribe(), this.delete();
            }, t.isLowLatencyCapable = function () {
              return (this || _global).sink instanceof ye;
            }, t.onSegmentDiscontinuity = function () {
              (this || _global).sink.onSegmentDiscontinuity();
            }, t.getSink = function (e) {
              switch (e) {
                case "chromecast":
                  return new ae((this || _global).listener);
                case "mse-worker":
                  return new me((this || _global).listener, (this || _global).video);
                case "passthrough":
                  return new qe((this || _global).listener, (this || _global).video);
                case "webview":
                  return new Ye((this || _global).listener, (this || _global).video, (this || _global).adjustments);
                default:
                  return new ye((this || _global).listener, (this || _global).video);
              }
            }, e;
          }(),
          Je = 1111,
          $e = [{
            CLASS: "timestamp",
            attributes: new Set(["X-SERVER-TIME"])
          }, {
            CLASS: "twitch-session",
            attributes: new Set(["X-TV-TWITCH-SESSIONID"])
          }, {
            CLASS: "twitch-stitched-ad",
            attributes: new Set(["X-TV-TWITCH-AD-URL", "X-TV-TWITCH-AD-LINE-ITEM-ID", "X-TV-TWITCH-AD-AD-FORMAT", "X-TV-TWITCH-AD-DSA-VERSION", "X-TV-TWITCH-AD-CLICK-BEACON-ID", "X-TV-TWITCH-AD-POD-LENGTH", "X-TV-TWITCH-AD-POD-POSITION", "X-TV-TWITCH-AD-ROLL-TYPE", "X-TV-TWITCH-AD-RADS-TOKEN", "X-TV-TWITCH-AD-AD-SESSION-ID", "X-TV-TWITCH-AD-ADVERTISER-ID", "X-TV-TWITCH-AD-CREATIVE-ID", "X-TV-TWITCH-AD-ORDER-ID", "X-TV-TWITCH-AD-CLICK-TRACKING-URL", "X-TV-TWITCH-AD-DSA-SS-CONTEXT", "X-TV-TWITCH-AD-DSA-SS-LOCATION", "X-TV-TWITCH-AD-POD-FILLED-DURATION", "X-TV-TWITCH-AD-AF-ICR-AD-ID", "X-TV-TWITCH-AD-AF-ICR-CREATIVE-ID", "X-TV-TWITCH-AD-AF-ICR-MEDIA-DURATION", "X-TV-TWITCH-AD-LOUDNESS"])
          }, {
            CLASS: "twitch-stream-source",
            attributes: new Set(["X-TV-TWITCH-STREAM-SOURCE"])
          }, {
            CLASS: "twitch-trigger",
            attributes: new Set(["X-TV-TWITCH-TRIGGER-URL"])
          }, {
            CLASS: "twitch-ad-quartile",
            attributes: new Set(["X-TV-TWITCH-AD-QUARTILE"])
          }],
          et = function (e) {
            return e[e.STATE_CHANGED = 0] = "STATE_CHANGED", e[e.CONFIGURE = 1] = "CONFIGURE", e[e.RESET = 2] = "RESET", e[e.ADD_CUE = 3] = "ADD_CUE", e[e.GET_DECODE_INFO = 4] = "GET_DECODE_INFO", e[e.MEDIA_SINK_RPC = 5] = "MEDIA_SINK_RPC", e[e.GET_EXPERIMENTS = 6] = "GET_EXPERIMENTS", e[e.LOG_MESSAGE = 7] = "LOG_MESSAGE", e[e.DATA_CHANNEL_CREATE = 8] = "DATA_CHANNEL_CREATE", e[e.DATA_CHANNEL_CLOSE = 9] = "DATA_CHANNEL_CLOSE", e[e.DATA_CHANNEL_SEND = 10] = "DATA_CHANNEL_SEND", e[e.RTC_SET_REMOTE_DESCRIPTION = 11] = "RTC_SET_REMOTE_DESCRIPTION", e[e.PROPERTY_CHANGED = 12] = "PROPERTY_CHANGED", e[e.SYNC_TIME_CHANGED = 13] = "SYNC_TIME_CHANGED", e[e.BUFFERED_RANGES = 14] = "BUFFERED_RANGES", e[e.DESTROY = 15] = "DESTROY", e;
          }({}),
          tt = {
            rebuildMediaSinkOnSourceQualityChange: !1,
            rebuildMediaSinkOnDiscontinuity: !1,
            abrTranscodesOnly: !1
          },
          nt = function (e) {
            return e.AVC = "avc1", e.HEVC = "hvc1", e.AV1 = "av01", e;
          }({}),
          rt = _mergeWith,
          it = n.n(rt),
          ot = n(293),
          at = "beta",
          st = "player-web",
          ut = function () {
            function e(e) {
              (this || _global).emitAnalytics = void 0, (this || _global).emitAnalytics = e;
            }
            var t = e.prototype;
            return t.onValue = function (e, t) {
              this.emit("ivs_devconf_value", {
                env: at,
                client_sdk: st,
                key_name: e,
                value: t
              });
            }, t.onError = function (e, t) {
              this.emit("ivs_devconf_error", {
                env: at,
                client_sdk: st,
                key_name: e,
                message: t
              });
            }, t.onTrace = function (e, t) {
              this.emit("ivs_devconf_trace", {
                env: at,
                client_sdk: st,
                key_name: e,
                message: t
              });
            }, t.emit = function (e, t) {
              this.emitAnalytics(e, t);
            }, e;
          }();
        var ct = function (e) {
            return e.HEVC = "b8b7cac6-956d-4819-8d35-9ae57aa5f0ce", e.AV1 = "d16629fa-a0bf-4a2a-b490-c1f92af05009", e.GPU = "8b0cb43a-720b-4775-9f98-21da360d60b1", e.GPUStaff = "59d57100-3c9c-4f13-aeff-9b1c1b6b4c66", e.DeviceConfigTest = "a5c3a8f0-d293-4597-af87-f0352c58d1b3", e.PassthroughDaterangeTags = "46d7d385-62a6-4aff-bb08-ca35fbadd8e6", e;
          }({}),
          dt = function (e) {
            for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
            return it().apply(void 0, [{}, e].concat(n, [function (e, t) {
              Array.isArray(t) && [].concat(t);
            }]));
          },
          lt = function () {
            function e(e, t) {
              var n;
              if (void 0 === e && (e = {}), (this || _global).onConfigChanged = t, (this || _global).mainConfig = void 0, (this || _global).experimentHandler = void 0, (this || _global).defaultConfig = {
                media: {
                  codecConfigs: []
                },
                logLevel: "",
                features: {
                  gpu: {
                    flags: {
                      enable_render_surface: !1,
                      add_canvas_to_surface: !1,
                      allow_canvas_visible: !1,
                      init_transformer: !1,
                      run_transformer: !1
                    },
                    render: {},
                    module: {},
                    configured: !1
                  }
                },
                experiments: {}
              }, (this || _global).deviceConfigManager = void 0, (this || _global).deviceConfigAnalyticsHandler = void 0, this.resetMainConfig(), this.setupExperimentHandlers(), e.logLevel && ((this || _global).mainConfig.logLevel = e.logLevel), e.media && Object.assign((this || _global).mainConfig.media, e.media), e.features && (Object.assign((this || _global).mainConfig.features, e.features), e.features.gpu && Object.assign(null != (n = (this || _global).mainConfig.features.gpu) ? n : {}, e.features.gpu)), e.experiments) for (var r = 0, i = Object.values(e.experiments); r < i.length; r++) {
                var o = i[r];
                o && this.setExperiment(o.id, o.assignment);
              }
            }
            var t = e.prototype;
            return t.initDeviceConfigManager = function (e) {
              this.shouldEnableDeviceConfigManager() && ((this || _global).deviceConfigManager = ot.DeviceConfigManager.getInstance(window, {
                fileKey: "player-web-v1",
                standardEnv: ot.DeviceConfigEnv.BETA,
                refresh: {
                  canRefreshNow: e.canRefreshNow
                },
                emitMetrics: e.emitMetrics
              }), (this || _global).deviceConfigManager && ((this || _global).deviceConfigAnalyticsHandler = new ut(e.emitAnalytics)));
            }, t.shouldEnableDeviceConfigManager = function () {
              var e;
              return window.location.hostname.startsWith("localhost.") || "player.video.xarth.tv" === window.location.hostname || "treatment" === (null == (e = (this || _global).mainConfig.experiments[ct.DeviceConfigTest]) ? void 0 : e.assignment);
            }, t.setupExperimentHandlers = function () {
              var e = this || _global,
                t = this.handleExperiment(function () {
                  return e.mainConfig.media.codecConfigs;
                }, ht, function (t) {
                  var n = e.mainConfig.media.codecConfigs;
                  e.mainConfig.media.codecConfigs = null == n ? void 0 : n.concat(t);
                }),
                n = this.handleExperiment(function () {
                  return e.mainConfig.media.codecConfigs;
                }, vt, function (t) {
                  var n = e.mainConfig.media.codecConfigs;
                  e.mainConfig.media.codecConfigs = null == n ? void 0 : n.concat(t);
                }),
                r = this.handleExperiment(function () {
                  return e.mainConfig.features.gpu;
                }, function (e, t) {
                  if (e.configured) return e;
                  var n = ft(t),
                    r = dt(e, n);
                  return r.configured = !0, r;
                }, function (t) {
                  e.mainConfig.features.gpu = t;
                }),
                i = this.handleExperiment(function () {
                  var t;
                  return null != (t = e.mainConfig.features.passthroughDaterangeTags) && t;
                }, function (e, t) {
                  return "treatment" === t;
                }, function (t) {
                  e.mainConfig.features.passthroughDaterangeTags = t;
                });
              (this || _global).experimentHandler = new Map([[ct.HEVC, t], [ct.AV1, n], [ct.GPU, r], [ct.GPUStaff, r], [ct.PassthroughDaterangeTags, i]]);
            }, t.getDeviceConfigPropertyHolder = function () {
              if ((this || _global).deviceConfigManager && (this || _global).deviceConfigAnalyticsHandler) return (this || _global).deviceConfigManager.getConfigurationHolder({
                analytics: (this || _global).deviceConfigAnalyticsHandler
              });
            }, t.getConfigSnapshot = function () {
              return o()({}, (this || _global).mainConfig);
            }, t.setExperiment = function (e, t) {
              var n;
              e && t && ((this || _global).mainConfig.experiments[e] = {
                id: e,
                assignment: t,
                version: 0
              }, null == (n = (this || _global).experimentHandler.get(e)) || n(t));
            }, t.delete = function () {
              this.resetMainConfig();
            }, t.resetMainConfig = function () {
              (this || _global).mainConfig = o()({}, (this || _global).defaultConfig);
            }, t.handleExperiment = function (e, t, n) {
              var r = this || _global;
              return function (i) {
                var o = e(),
                  a = t(o, i);
                a !== o && (n(a), r.onConfigChanged());
              };
            }, e;
          }(),
          ft = function (e) {
            var t = {};
            if (!e) return t;
            var n = e.split("_config_"),
              r = (n[0], n[1]);
            if (!r) return t;
            try {
              t = JSON.parse(atob(r));
            } catch (t) {
              console.warn("[ConfigManager]: Invalid assignment config provided", e, t);
            }
            return t;
          };
        function ht(e, t) {
          switch (t) {
            case "control":
            case "holdback":
              return [{
                codecString: nt.HEVC,
                setting: {
                  disableUse: !0
                }
              }];
            case "forceOn":
              return [{
                codecString: nt.HEVC,
                setting: {
                  skipPlatformSupportChecks: !0
                }
              }];
            case "treatment":
              return [];
            default:
              return e;
          }
        }
        function vt(e, t) {
          switch (t) {
            case "control":
            case "holdback":
              return [{
                codecString: nt.AV1,
                setting: {
                  disableUse: !0
                }
              }];
            case "forceOn":
              return [{
                codecString: nt.AV1,
                setting: {
                  skipPlatformSupportChecks: !0
                }
              }];
            case "treatment":
              return [];
            default:
              return e;
          }
        }
        var pt = _wrapNativeSuper,
          mt = function (e) {
            function t(t, n, r, i) {
              var o;
              return (o = e.call(this || _global, r) || this || _global).source = t, o.code = n, o.message = r, o.fatal = i, o;
            }
            return re()(t, e), t;
          }(n.n(pt)()(Error)),
          gt = function (e) {
            return e[e.WebGPUNotAvailable = -1000] = "WebGPUNotAvailable", e[e.WebGPUAdapterNotAvailable = -1001] = "WebGPUAdapterNotAvailable", e[e.WebGPUDeviceNotAvailable = -1002] = "WebGPUDeviceNotAvailable", e[e.ShaderCompilationFailed = -1100] = "ShaderCompilationFailed", e[e.PipelineCreationFailed = -1101] = "PipelineCreationFailed", e[e.SamplerCreationFailed = -1102] = "SamplerCreationFailed", e[e.StreamCreationFailed = -1103] = "StreamCreationFailed", e[e.ModelInitFailed = -1104] = "ModelInitFailed", e[e.OutOfMemory = -1200] = "OutOfMemory", e[e.InvalidBuffer = -1201] = "InvalidBuffer", e[e.InvalidBufferSize = -1202] = "InvalidBufferSize", e[e.BufferCopyFailed = -1203] = "BufferCopyFailed", e[e.DeviceLost = -1300] = "DeviceLost", e[e.DeviceLostTooManyRetries = -1301] = "DeviceLostTooManyRetries", e[e.CanvasCreationFailed = -1400] = "CanvasCreationFailed", e[e.InferenceFailed = -1500] = "InferenceFailed", e[e.FetchFailed = -1600] = "FetchFailed", e[e.Render = -1700] = "Render", e[e.Init = -1800] = "Init", e[e.FrameCaptureFailed = -1900] = "FrameCaptureFailed", e[e.Performance = -2000] = "Performance", e[e.PerformanceLowRenderFramerate = -2001] = "PerformanceLowRenderFramerate", e[e.PerformanceLowCaptureFramerate = -2002] = "PerformanceLowCaptureFramerate", e[e.PerformanceTooManyOverbudgetFrames = -2010] = "PerformanceTooManyOverbudgetFrames", e[e.PerformanceTooManySkippedFrames = -2011] = "PerformanceTooManySkippedFrames", e[e.PerformanceTooManyDroppedSourceFrames = -2012] = "PerformanceTooManyDroppedSourceFrames", e[e.PerformanceTooManyMissedFrames = -2013] = "PerformanceTooManyMissedFrames", e[e.ResourceClosed = -9998] = "ResourceClosed", e[e.BadParameters = -9999] = "BadParameters", e;
          }({}),
          yt = function () {
            function e() {
              (this || _global).frameStats = void 0, this.resetStats();
            }
            var t = e.prototype;
            return t.init = function () {
              var e = this || _global;
              return new WritableStream({
                write: function (t) {
                  t && Promise.resolve().then(function () {
                    e.onFrameRecord(t);
                  }).catch(function (e) {
                    y.error(e);
                  });
                }
              });
            }, t.stats = function () {
              return o()({}, (this || _global).frameStats);
            }, t.resetStats = function () {
              (this || _global).frameStats = {
                received: 0,
                overBudget: 0,
                skipped: 0,
                failed: 0,
                transformed: 0,
                rendered: 0,
                transformTime: 0,
                renderTime: 0,
                receiveDelay: 0,
                endToEnd: 0
              };
            }, t.onFrameRecord = function (e) {
              var t = {
                receive: e.timings.received - e.timings.captured,
                transform: e.timings.transformEnd - e.timings.transformStart,
                render: e.timings.renderEnd - e.timings.renderStart,
                endToEnd: e.timings.renderEnd - e.timings.captured
              };
              (this || _global).frameStats.received++, (this || _global).frameStats.receiveDelay += t.receive, e.skipped && ((this || _global).frameStats.skipped++, y.warn("[FrameRecordSink]: Frame " + e.number + " was skipped. Frame receive delay: " + t.receive + ", Initial budget: " + e.budget + "ms, Min budget: " + e.minBudget + "ms", t, e)), e.transformed && ((this || _global).frameStats.transformed++, (this || _global).frameStats.transformTime += t.transform), e.rendered && ((this || _global).frameStats.rendered++, (this || _global).frameStats.renderTime += t.render), e.failed && ((this || _global).frameStats.failed++, y.warn("[FrameRecordSink]: Frame " + e.number + " failed to to transform or render. See error log for details.", t, e)), t.endToEnd >= e.budget && ((this || _global).frameStats.overBudget++, y.warn("[FrameRecordSink]: Frame " + e.number + " was overbudget. End to end time: " + t.endToEnd + "ms Budget: " + e.budget + "ms", t, e)), (this || _global).frameStats.endToEnd += t.endToEnd;
            }, e;
          }(),
          Et = function () {
            function e(e, t, n, r) {
              (this || _global).inputFrameStream = e, (this || _global).sink = t, (this || _global).onError = n, (this || _global).config = r, (this || _global).pipeline = void 0, (this || _global).transformer = void 0, (this || _global).frameRecordSink = void 0, (this || _global).frameRecordSink = new yt();
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e(t) {
                var n,
                  r = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      (this || _global).transformer = t, e.prev = 1, n = (this || _global).frameRecordSink.init(), (this || _global).pipeline = this.createPipeline(), (this || _global).pipeline.readable.pipeTo(n).catch(function (e) {
                        r.onError(new mt("VideoFramePipeline", gt.PipelineCreationFailed, "Failed to pipe to frameRecordStream: " + (null == e ? void 0 : e.message), !0));
                      }), (this || _global).inputFrameStream.pipeThrough((this || _global).pipeline), e.next = 11;
                      break;
                    case 8:
                      return e.prev = 8, e.t0 = e.catch(1), e.abrupt("return", new mt("VideoFramePipeline", gt.PipelineCreationFailed, "Failed to init pipeline: " + (null == e.t0 ? void 0 : e.t0.message), !0));
                    case 11:
                      return e.abrupt("return", void 0);
                    case 12:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[1, 8]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.stats = function () {
              return (this || _global).frameRecordSink.stats();
            }, t.resetStats = function () {
              (this || _global).frameRecordSink.resetStats();
            }, t.createPipeline = function () {
              var e,
                t = this || _global,
                n = new TransformStream({
                  transform: (e = f()(v().mark(function e(n, r) {
                    var i, o, a, s, u, c, d, l, h, p, m;
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (i = n.frame, o = n.record, a = performance.now(), s = void 0, u = [], c = Math.min(a - o.timings.captured, 0), o.timings.received = a, d = 1000 / t.config.minimumFramerate - (t.config.includeReceiveDelay ? c : 0), o.budget = d, o.minBudget = 0, l = function () {
                            var e = f()(v().mark(function e() {
                              var n, a;
                              return v().wrap(function (e) {
                                for (;;) switch (e.prev = e.next) {
                                  case 0:
                                    return e.next = 2, t.render(i, o, s);
                                  case 2:
                                    n = e.sent, (a = n.renderError) && u.push(a), i.close(), o.failed = !!u.length, r.enqueue(o), u.forEach(function (e) {
                                      return t.handleErrorInternal(e);
                                    });
                                  case 9:
                                  case "end":
                                    return e.stop();
                                }
                              }, e);
                            }));
                            return function () {
                              return e.apply(this || _global, arguments);
                            };
                          }(), !(d <= 0)) {
                            e.next = 16;
                            break;
                          }
                          return o.skipped = !0, e.next = 15, l();
                        case 15:
                          return e.abrupt("return");
                        case 16:
                          return e.next = 18, t.frameToTexture(i, o, d);
                        case 18:
                          return h = e.sent, p = h.transformError, m = h.texture, s = m, p && u.push(p), e.next = 25, l();
                        case 25:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  })), function (t, n) {
                    return e.apply(this || _global, arguments);
                  })
                });
              return n;
            }, t.frameToTexture = function () {
              var e = f()(v().mark(function e(t, n, r) {
                var i, o, a, s, u;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return i = performance.now(), o = void 0, n.timings.transformStart = i, e.next = 5, (this || _global).transformer.transform(t, r);
                    case 5:
                      return a = e.sent, s = a.texture, (u = a.error) ? (y.warn("[VideoFramePipeline]: Failed to transform frame " + n.number), o = u) : s && (n.transformed = !0), n.timings.transformEnd = performance.now(), e.abrupt("return", {
                        transformError: o,
                        texture: s
                      });
                    case 11:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r) {
                return e.apply(this || _global, arguments);
              };
            }(), t.render = function () {
              var e = f()(v().mark(function e(t, n, r) {
                var i, o, a, s, u, c;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return i = performance.now(), n.timings.renderStart = i, o = void 0, e.prev = 3, u = null != (a = null == r ? void 0 : r.width) ? a : t.displayWidth, c = null != (s = null == r ? void 0 : r.height) ? s : t.displayHeight, (this || _global).sink.setDimensions(u, c), e.next = 9, (this || _global).sink.render(null != r ? r : t);
                    case 9:
                      (o = e.sent) || (n.rendered = !0), e.next = 17;
                      break;
                    case 13:
                      e.prev = 13, e.t0 = e.catch(3), y.warn("[VideoFramePipeline]: Failed to render frame " + n.number), o = e.t0;
                    case 17:
                      return n.timings.renderEnd = performance.now(), e.abrupt("return", {
                        renderError: o
                      });
                    case 19:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[3, 13]]);
              }));
              return function (t, n, r) {
                return e.apply(this || _global, arguments);
              };
            }(), t.handleErrorInternal = function (e) {
              y.warn("[VideoFramePipeline]: Error transforming frame", e), this.onError(e);
            }, e;
          }(),
          Tt = function () {
            function e(e, t) {
              (this || _global).config = e, (this || _global).onError = t, (this || _global).active = !1, (this || _global).frameStream = void 0, (this || _global).frameWriter = void 0, (this || _global).stopCapture = void 0, (this || _global).captureStats = void 0, this.resetStats();
            }
            var t = e.prototype;
            return t.init = function () {
              try {
                (this || _global).frameStream = new TransformStream({}, {
                  highWaterMark: (this || _global).config.maxQueueSize
                }), (this || _global).frameWriter = (this || _global).frameStream.writable.getWriter();
              } catch (e) {
                return new mt("VideoFrameCaptureStream", gt.StreamCreationFailed, e.message, !0);
              }
            }, t.start = function (e) {
              (this || _global).active ? y.warn("[VideoFrameCaptureStream]: Start called, but already capturing") : (this.startRVFC(e), (this || _global).active = !0);
            }, t.stop = function () {
              var e;
              (this || _global).active = !1, null == (e = (this || _global).stopCapture) || e.call(this || _global);
            }, t.stats = function () {
              return (this || _global).captureStats;
            }, t.resetStats = function () {
              (this || _global).captureStats = {
                captured: 0,
                missed: 0,
                blocked: 0,
                rVFCDelay: 0
              };
            }, t.getStream = function () {
              return (this || _global).frameStream.readable;
            }, t.startRVFC = function (e) {
              var t,
                n = this || _global,
                r = void 0,
                i = -1;
              null == (t = (this || _global).stopCapture) || t.call(this || _global), (this || _global).stopCapture = function () {
                return e.cancelVideoFrameCallback(i);
              };
              var a = function () {
                var t = f()(v().mark(function t(s, u) {
                  var c, d, l, f;
                  return v().wrap(function (t) {
                    for (;;) switch (t.prev = t.next) {
                      case 0:
                        if (n.active) {
                          t.next = 2;
                          break;
                        }
                        return t.abrupt("return");
                      case 2:
                        if (t.prev = 2, d = performance.now(), n.captureStats.rVFCDelay += d - s, l = new VideoFrame(e), (f = o()({}, {
                          timings: {
                            composited: 0,
                            captured: 0,
                            received: 0,
                            transformStart: 0,
                            transformEnd: 0,
                            renderStart: 0,
                            renderEnd: 0
                          },
                          number: 0,
                          budget: 0,
                          minBudget: 0,
                          blocked: !1,
                          skipped: !1,
                          transformed: !1,
                          rendered: !1,
                          overbudget: !1,
                          failed: !1
                        })).number = u.presentedFrames, f.timings.composited = s, f.timings.captured = d, !((null != (c = n.frameWriter.desiredSize) ? c : 0) < 1)) {
                          t.next = 17;
                          break;
                        }
                        return n.captureStats.blocked++, f.blocked = !0, t.next = 15, n.frameWriter.write({
                          frame: l,
                          record: f
                        });
                      case 15:
                        t.next = 18;
                        break;
                      case 17:
                        n.frameWriter.write({
                          frame: l,
                          record: f
                        }).catch(function (e) {
                          n.onError(new mt("CaptureStream", gt.FrameCaptureFailed, "Failed to write frame to stream: " + ((null == e ? void 0 : e.message) || "unknown error"), !0));
                        });
                      case 18:
                        void 0 === r ? r = u.presentedFrames : u.presentedFrames - r > 1 && (n.captureStats.missed += u.presentedFrames - r), r = u.presentedFrames, n.captureStats.captured++, i = e.requestVideoFrameCallback(a), t.next = 27;
                        break;
                      case 24:
                        t.prev = 24, t.t0 = t.catch(2), n.errorHandler(new mt("CaptureStream", gt.FrameCaptureFailed, "Failed to write frame to stream: " + ((null == t.t0 ? void 0 : t.t0.message) || "unknown error"), !0));
                      case 27:
                      case "end":
                        return t.stop();
                    }
                  }, t, null, [[2, 24]]);
                }));
                return function (e, n) {
                  return t.apply(this || _global, arguments);
                };
              }();
              y.log("[VideoFrameCaptureStream]: Started", e), i = e.requestVideoFrameCallback(a);
            }, t.errorHandler = function (e) {
              this.stop(), this.onError(e);
            }, e;
          }(),
          St = function () {
            function e(e, t) {
              (this || _global).windowContext = e, (this || _global).config = t, (this || _global).adapter = void 0, (this || _global).adapterInfo = void 0, (this || _global).device = void 0, (this || _global).queue = void 0, (this || _global).timingInfoEnabled = void 0, (this || _global).useFP16 = void 0, (this || _global).storageFormat = void 0;
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e() {
                var t, n, r, i, o, a, s, u;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if ((this || _global).windowContext.navigator.gpu) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", new mt("WebGPUContext", gt.WebGPUNotAvailable, "WebGPU not available", !0));
                    case 2:
                      return e.next = 4, (this || _global).windowContext.navigator.gpu.requestAdapter({});
                    case 4:
                      if (t = e.sent) {
                        e.next = 7;
                        break;
                      }
                      return e.abrupt("return", new mt("WebGPUContext", gt.WebGPUAdapterNotAvailable, "WebGPU Adapter not available", !0));
                    case 7:
                      return e.next = 9, t.requestAdapterInfo();
                    case 9:
                      return n = e.sent, r = [], i = {}, o = "bgra8unorm" === (this || _global).windowContext.navigator.gpu.getPreferredCanvasFormat() && t.features.has("bgra8unorm-storage"), a = (this || _global).config.timingInfoEnabled && t.features.has("timestamp-query"), s = t.features.has("shader-f16"), o && r.push("bgra8unorm-storage"), a && r.push("timestamp-query"), s && r.push("shader-f16"), i.requiredFeatures = r, e.next = 21, this.tryGetDevice(t, i);
                    case 21:
                      if (u = e.sent) {
                        e.next = 24;
                        break;
                      }
                      return e.abrupt("return", new mt("WebGPUContext", gt.WebGPUDeviceNotAvailable, "WebGPU Device not available", !0));
                    case 24:
                      (this || _global).adapterInfo = n, (this || _global).timingInfoEnabled = a, (this || _global).storageFormat = o ? "bgra8unorm" : "rgba8unorm", (this || _global).useFP16 = s, (this || _global).adapter = t, (this || _global).device = u, (this || _global).queue = u.queue, y.info("[WebGPUContext]: WebGPU context initialized", this.properties());
                    case 32:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.properties = function () {
              var e;
              if (!(this || _global).adapterInfo) return {
                architecture: "",
                description: "",
                device: "",
                vendor: "",
                adapterFeatures: "",
                deviceFeatures: "",
                wgslFeatures: ""
              };
              var t = "";
              (this || _global).adapter.features.forEach(function (e) {
                t += e + ",";
              });
              var n = "";
              (this || _global).device.features.forEach(function (e) {
                n += e + ",";
              });
              var r = "";
              return null == (e = navigator.gpu.wgslLanguageFeatures) || e.forEach(function (e) {
                r += e + ",";
              }), {
                architecture: (this || _global).adapterInfo.architecture,
                description: (this || _global).adapterInfo.description,
                device: (this || _global).adapterInfo.device,
                vendor: (this || _global).adapterInfo.vendor,
                adapterFeatures: t,
                deviceFeatures: n,
                wgslFeatures: r
              };
            }, t.createBuffer = function (e, t) {
              return (this || _global).device.pushErrorScope("out-of-memory"), (this || _global).device.createBuffer({
                size: e,
                usage: t
              });
            }, t.setBufferData = function () {
              var e = f()(v().mark(function e(t, n, r) {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (void 0 === r && (r = !0), (this || _global).device.queue.writeBuffer(t, 0, n), !r) {
                        e.next = 5;
                        break;
                      }
                      return e.next = 5, (this || _global).device.queue.onSubmittedWorkDone();
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r) {
                return e.apply(this || _global, arguments);
              };
            }(), t.createShaderModule = function () {
              var e = f()(v().mark(function e(t) {
                var n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return n = (this || _global).device.createShaderModule({
                        code: t
                      }), e.next = 3, n.getCompilationInfo();
                    case 3:
                      if (!((r = e.sent).messages.length > 0)) {
                        e.next = 7;
                        break;
                      }
                      return y.error("[WebGPUContext]: Error compiling shader", r.messages), e.abrupt("return", {
                        err: new mt("WebGPUContext", gt.ShaderCompilationFailed, "Compilation failed: " + r.messages.join(), !0)
                      });
                    case 7:
                      return e.abrupt("return", {
                        module: n
                      });
                    case 8:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.tryGetDevice = function () {
              var e = f()(v().mark(function e(t, n) {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.prev = 0, e.next = 3, t.requestDevice(n);
                    case 3:
                    case 11:
                      return e.abrupt("return", e.sent);
                    case 6:
                      return e.prev = 6, e.t0 = e.catch(0), e.prev = 8, e.next = 11, t.requestDevice(null);
                    case 14:
                      return e.prev = 14, e.t1 = e.catch(8), e.abrupt("return", void 0);
                    case 17:
                    case "end":
                      return e.stop();
                  }
                }, e, null, [[0, 6], [8, 14]]);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), e;
          }(),
          _t = function () {
            function e(e, t, n) {
              (this || _global).canvasEl = e, (this || _global).gpuContext = t, (this || _global).onError = n, (this || _global).canvas = void 0, (this || _global).device = void 0, (this || _global).canvasContext = void 0, (this || _global).pipelines = void 0, (this || _global).device = t.device, (this || _global).pipelines = new Map();
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.prev = 0, e.next = 3, this.setCanvas((this || _global).canvasEl.transferControlToOffscreen());
                    case 3:
                      e.next = 8;
                      break;
                    case 5:
                      return e.prev = 5, e.t0 = e.catch(0), e.abrupt("return", new mt("CanvasSink", gt.CanvasCreationFailed, e.t0.message, !0));
                    case 8:
                      return e.abrupt("return", void 0);
                    case 9:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[0, 5]]);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.render = function () {
              var e = f()(v().mark(function e(t) {
                var n, r, i, o, a, s, u, c, d;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if ((this || _global).canvasContext && (this || _global).canvas) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", new mt("CanvasSink", gt.Render, "Failed to get WebGPU Canvas context", !0));
                    case 2:
                      return n = t instanceof VideoFrame, e.next = 5, this.getPipeline((this || _global).canvas.width, (this || _global).canvas.height, n);
                    case 5:
                      if (r = e.sent, i = r.pipeline, !(o = r.error) && i) {
                        e.next = 10;
                        break;
                      }
                      return e.abrupt("return", o);
                    case 10:
                      a = n ? (this || _global).device.importExternalTexture({
                        source: t
                      }) : t.createView(), s = i.getBindGroupLayout(0), u = (this || _global).device.createBindGroup({
                        layout: s,
                        entries: [{
                          binding: 0,
                          resource: (this || _global).canvasContext.getCurrentTexture().createView()
                        }, {
                          binding: 1,
                          resource: a
                        }]
                      }), (this || _global).device.pushErrorScope("validation"), c = (this || _global).device.createCommandEncoder(), (d = c.beginComputePass()).setPipeline(i), d.setBindGroup(0, u), d.dispatchWorkgroups(Math.ceil((this || _global).canvas.width / 16), Math.ceil((this || _global).canvas.height / 16), 1), d.end(), (this || _global).device.queue.submit([c.finish()]), this.checkForErrorsAsync();
                    case 22:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.setDimensions = function (e, t) {
              !(this || _global).canvas || e === (this || _global).canvas.width && t === (this || _global).canvas.height || ((this || _global).canvas.width = e, (this || _global).canvas.height = t);
            }, t.setCanvas = function () {
              var e = f()(v().mark(function e(t) {
                var n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if ((this || _global).canvas = t, (this || _global).canvasContext = t.getContext("webgpu"), (this || _global).canvasContext) {
                        e.next = 4;
                        break;
                      }
                      return e.abrupt("return", new mt("CanvasSink", gt.Render, "Failed to get WebGPU Canvas context", !0));
                    case 4:
                      return n = (this || _global).gpuContext.storageFormat, r = {
                        device: (this || _global).device,
                        format: n,
                        usage: GPUTextureUsage.STORAGE_BINDING,
                        viewFormats: [n],
                        alphaMode: "opaque"
                      }, (this || _global).device.pushErrorScope("validation"), (this || _global).canvasContext.configure(r), e.next = 10, (this || _global).device.popErrorScope();
                    case 10:
                      if (!e.sent) {
                        e.next = 13;
                        break;
                      }
                      return e.abrupt("return", new mt("CanvasSink", gt.Render, "Failed to configure Canvas context", !0));
                    case 13:
                      return e.abrupt("return", void 0);
                    case 14:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.getPipeline = function () {
              var e = f()(v().mark(function e(t, n, r) {
                var i,
                  o = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (i = r + "_" + t + "_" + n, !(this || _global).pipelines.has(i) || !(this || _global).pipelines.get(i)) {
                        e.next = 3;
                        break;
                      }
                      return e.abrupt("return", {
                        pipeline: (this || _global).pipelines.get(i),
                        error: void 0
                      });
                    case 3:
                      return e.abrupt("return", this.makePipeline(t, n, r).then(function (e) {
                        return e.pipeline && o.pipelines.set(i, e.pipeline), e;
                      }));
                    case 4:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r) {
                return e.apply(this || _global, arguments);
              };
            }(), t.makePipeline = function () {
              var e = f()(v().mark(function e(t, n, r) {
                var i, o, a, s, u, c;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return i = this.getShader(t, n, r), e.next = 3, this.createShaderModule(i);
                    case 3:
                      if (o = e.sent, a = o.module, s = o.error, a && !s) {
                        e.next = 8;
                        break;
                      }
                      return e.abrupt("return", {
                        error: s
                      });
                    case 8:
                      return (this || _global).device.pushErrorScope("validation"), u = (this || _global).device.createComputePipeline({
                        layout: "auto",
                        compute: {
                          module: a,
                          entryPoint: "main"
                        },
                        label: "canvas-sink_" + t + "_" + n + "_" + r
                      }), e.next = 12, (this || _global).device.popErrorScope();
                    case 12:
                      if (!(c = e.sent)) {
                        e.next = 15;
                        break;
                      }
                      return e.abrupt("return", {
                        error: new mt("CanvasSink", gt.PipelineCreationFailed, "" + c.message, !0)
                      });
                    case 15:
                      return e.abrupt("return", {
                        pipeline: u
                      });
                    case 16:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r) {
                return e.apply(this || _global, arguments);
              };
            }(), t.createShaderModule = function () {
              var e = f()(v().mark(function e(t) {
                var n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return n = (this || _global).device.createShaderModule({
                        code: t
                      }), e.next = 3, n.getCompilationInfo();
                    case 3:
                      if (!((r = e.sent).messages.length > 0)) {
                        e.next = 7;
                        break;
                      }
                      return y.error("[CanvasSink]: Error compiling shader", r.messages), e.abrupt("return", {
                        error: new mt("CanvasSink", gt.ShaderCompilationFailed, "Shader compilation failed: " + r.messages.join(), !0)
                      });
                    case 7:
                      return e.abrupt("return", {
                        module: n
                      });
                    case 8:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.getShader = function (e, t, n) {
              return "\n        @group(0) @binding(0) var outputTexture: texture_storage_2d<" + (this || _global).gpuContext.storageFormat + ", write>;\n        @group(0) @binding(1) var inputTexture: " + (n ? "texture_external" : "texture_2d<f32>") + ";\n\n        @compute @workgroup_size(16,16,1)\n        fn main(@builtin(global_invocation_id) global_id : vec3<u32>) {\n            if (global_id.x >= " + e + " || global_id.y >= " + t + ") {\n                return;\n            }\n            let color = " + (n ? "textureLoad(inputTexture, global_id.xy);" : "textureLoad(inputTexture, global_id.xy, 0);") + ";\n            textureStore(outputTexture, global_id.xy, color);\n        }\n        ";
            }, t.checkForErrorsAsync = function () {
              var e = this || _global;
              (this || _global).device.popErrorScope().then(function (t) {
                t && (y.warn("[CanvasSink]: WebGPU error encountered", t), e.onErrorInternal(new mt("CanvasSink", gt.Render, "Failed to render: " + t.message, !0)));
              }).catch(function (t) {
                e.onError(new mt("CanvasSink", gt.BadParameters, "Failed to popErrorScope: " + ((null == t ? void 0 : t.message) || "unknown error"), !0));
              });
            }, t.onErrorInternal = function (e) {
              this.onError(e);
            }, e;
          }(),
          bt = function () {
            function e(e) {
              (this || _global).name = e, (this || _global).frameBudgetTimeout = -1;
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", Promise.resolve(void 0));
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.transform = function () {
              var e = f()(v().mark(function e(t, n) {
                var r,
                  i = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, Promise.race([this.doTransform(t), this.frameBudgetExceededPassthrough(n)]).catch(function (e) {
                        return clearTimeout(i.frameBudgetTimeout), {
                          frame: t,
                          error: e
                        };
                      });
                    case 2:
                      return r = e.sent, clearTimeout((this || _global).frameBudgetTimeout), e.abrupt("return", r);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.doTransform = function () {
              var e = f()(v().mark(function e(t) {
                var n;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, this.transformFn(t);
                    case 2:
                      return n = e.sent, e.abrupt("return", {
                        texture: n
                      });
                    case 4:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.frameBudgetExceededPassthrough = function () {
              var e = f()(v().mark(function e(t) {
                var n = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", new Promise(function (e) {
                        return n.frameBudgetTimeout = window.setTimeout(function () {
                          e({});
                        }, t);
                      }));
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.transformFn = function () {
              var e = f()(v().mark(function e(t) {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", void 0);
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), e;
          }(),
          Ct = function (e) {
            function t() {
              return e.call(this || _global, "PassthroughTransformer") || this || _global;
            }
            return re()(t, e), t.prototype.transform = function () {
              var e = f()(v().mark(function e(t) {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", {});
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t;
          }(bt);
        function wt(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var kt = function () {
            function e(e, t, n) {
              (this || _global).config = e, (this || _global).getStats = t, (this || _global).listeners = n, (this || _global).monitorInterval = -1, (this || _global).active = !1, (this || _global).validators = [], y.log("[PerformanceMontior]: Config", (this || _global).config), (this || _global).validators.push(function (e) {
                return {
                  validate: function (t) {
                    var n = 1 - t.source_presented / t.source;
                    if (n >= e.maxDroppedFramesPct) return {
                      code: gt.PerformanceTooManyDroppedSourceFrames,
                      fatal: !0,
                      reason: "Too many dropped source frames. Dropped: " + (100 * n).toFixed(0) + "%, Max: " + 100 * e.maxDroppedFramesPct + "% Presented frames: " + t.source_presented + ", Total frames: " + t.source
                    };
                  }
                };
              }({
                maxDroppedFramesPct: e.frameRateDiffPercentage
              }), function (e) {
                return {
                  validate: function (t) {
                    var n = t.captured,
                      r = t.source_presented,
                      i = r - r * e.frameCountDiffPercentage;
                    if (n < i) return {
                      code: gt.PerformanceLowRenderFramerate,
                      fatal: !0,
                      reason: "Capture framerate is too low. Source Presented: " + r + " Min: " + i + " Captured: " + n + " Config: " + 100 * e.frameCountDiffPercentage + "%"
                    };
                  }
                };
              }({
                frameCountDiffPercentage: (this || _global).config.frameCountDiffPercentage,
                captureRateDiffPercentage: (this || _global).config.frameRateDiffPercentage
              }), function (e) {
                return {
                  validate: function (t) {
                    var n = t.source,
                      r = t.rendered,
                      i = t.received;
                    if (t.overBudget > i * e.frameCountDiffPercentage) return {
                      code: gt.PerformanceTooManyOverbudgetFrames,
                      fatal: !0,
                      reason: "Too many overbudget frames. Received: " + i + " Max: " + i * e.frameCountDiffPercentage + " Have: " + t.overBudget + " Config: " + 100 * e.frameCountDiffPercentage + "%"
                    };
                    if (t.skipped > i * e.frameCountDiffPercentage) return {
                      code: gt.PerformanceTooManySkippedFrames,
                      fatal: !0,
                      reason: "Too many skipped frames. Received: " + i + " Max: " + i * e.frameCountDiffPercentage + " Have: " + t.skipped + " Config: " + 100 * e.frameCountDiffPercentage + "%"
                    };
                    var o = n - n * e.renderFramerateDiffPercentage;
                    return r < o ? {
                      code: gt.PerformanceLowRenderFramerate,
                      fatal: !0,
                      reason: "Render framerate is too low. Source: " + n + " Min: " + o + " Rendered: " + r + " Config: " + 100 * e.renderFramerateDiffPercentage + "%"
                    } : void 0;
                  }
                };
              }({
                frameCountDiffPercentage: (this || _global).config.frameCountDiffPercentage,
                renderFramerateDiffPercentage: (this || _global).config.frameRateDiffPercentage
              }));
            }
            var t = e.prototype;
            return t.start = function () {
              var e = this || _global;
              if ((this || _global).config.enable) if (this.monitoring()) y.log("[PerformanceMonitor]: Resume called on active instance");else {
                y.log("[PerformanceMonitor]: Monitoring started");
                var t = this.getStats();
                window.clearInterval((this || _global).monitorInterval), (this || _global).monitorInterval = window.setInterval(function () {
                  var n = e.getStats(),
                    r = e.validatePerformance(t, n);
                  r && e.listeners.performanceBreach(r), t = n;
                }, (this || _global).config.monitorIntervalMs);
              }
            }, t.stop = function () {
              window.clearInterval((this || _global).monitorInterval), (this || _global).monitorInterval = -1;
            }, t.monitoring = function () {
              return (this || _global).monitorInterval > 0;
            }, t.validatePerformance = function (e, t) {
              var n = this.diffFrameStats(e.frames, t.frames);
              y.log("[PerformanceMonitor] Stats:", e, t), y.log("[PerformanceMonitor] Stats diff:", n);
              var r = (this || _global).config.monitorIntervalMs / 1000 * 20;
              if (n.source <= r) y.log("[PerformanceMonitor]: Not enough source frames to validate. Have: " + n.source + " Need: " + r);else for (var i, o = function (e, t) {
                  var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                  if (n) return (n = n.call(e)).next.bind(n);
                  if (Array.isArray(e) || (n = function (e, t) {
                    if (e) {
                      if ("string" == typeof e) return wt(e, t);
                      var n = Object.prototype.toString.call(e).slice(8, -1);
                      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? wt(e, t) : void 0;
                    }
                  }(e)) || t && e && "number" == typeof e.length) {
                    n && (e = n);
                    var r = 0;
                    return function () {
                      return r >= e.length ? {
                        done: !0
                      } : {
                        done: !1,
                        value: e[r++]
                      };
                    };
                  }
                  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }((this || _global).validators); !(i = o()).done;) {
                var a = i.value.validate(n);
                if (a) return a;
              }
            }, t.diffFrameStats = function (e, t) {
              for (var n = {
                  source: 0,
                  source_presented: 0,
                  captured: 0,
                  missed: 0,
                  blocked: 0,
                  received: 0,
                  skipped: 0,
                  transformed: 0,
                  rendered: 0,
                  failed: 0,
                  overBudget: 0
                }, r = 0, i = Object.entries(t); r < i.length; r++) {
                var o = i[r],
                  a = o[0],
                  s = o[1];
                n[a] = s - e[a];
              }
              return n;
            }, e;
          }(),
          It = function (e) {
            return e[e.External = 0] = "External", e[e.Texture = 1] = "Texture", e[e.Buffer = 2] = "Buffer", e;
          }({}),
          Pt = function (e) {
            return e[e.Default = 0] = "Default", e[e.HostToDevice = 1] = "HostToDevice", e[e.DeviceToHost = 4] = "DeviceToHost", e[e.TimingQuery = 8] = "TimingQuery", e;
          }({}),
          At = function () {
            function e(e, t, n) {
              void 0 === n && (n = Pt.Default), (this || _global).bytesize = t, (this || _global).usage = n, (this || _global).deviceBuffer = void 0, (this || _global).stagingBuffer = void 0, (this || _global).closed = !1;
              var r = GPUBufferUsage.STORAGE;
              n === Pt.HostToDevice ? r |= GPUBufferUsage.COPY_DST : n === Pt.DeviceToHost ? (r |= GPUBufferUsage.COPY_SRC, (this || _global).stagingBuffer = e.createBuffer(t, GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ)) : n === Pt.TimingQuery && (r |= GPUBufferUsage.QUERY_RESOLVE | GPUBufferUsage.COPY_DST | GPUBufferUsage.COPY_SRC, (this || _global).stagingBuffer = e.createBuffer(t, GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ)), (this || _global).deviceBuffer = e.createBuffer(t, r);
            }
            var t = e.prototype;
            return t.copyToDevice = function () {
              var e = f()(v().mark(function e(t, n) {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!(this || _global).closed) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", new mt("Buffer", gt.ResourceClosed, "Buffer has been closed", !0));
                    case 2:
                      return e.prev = 2, e.next = 5, t.setBufferData((this || _global).deviceBuffer, n, !1);
                    case 5:
                      e.next = 10;
                      break;
                    case 7:
                      return e.prev = 7, e.t0 = e.catch(2), e.abrupt("return", new mt("Buffer", gt.BadParameters, "Failed to copy to host: " + ((null == e.t0 ? void 0 : e.t0.message) || "unknown"), !0));
                    case 10:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[2, 7]]);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.copyToHost = function () {
              var e = f()(v().mark(function e(t) {
                var n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!(this || _global).closed) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", {
                        err: new mt("Buffer", gt.ResourceClosed, "Buffer has been closed", !0)
                      });
                    case 2:
                      if ((this || _global).stagingBuffer && (this || _global).usage !== Pt.DeviceToHost) {
                        e.next = 4;
                        break;
                      }
                      return e.abrupt("return", {
                        err: new mt("Buffer", gt.BadParameters, "Buffer usage is " + (this || _global).usage + ", but should be BufferUsage.DeviceToHost", !0)
                      });
                    case 4:
                      return e.prev = 4, (n = t.createCommandEncoder()).copyBufferToBuffer((this || _global).deviceBuffer, 0, (this || _global).stagingBuffer, 0, (this || _global).bytesize), t.queue.submit([n.finish()]), e.next = 10, t.queue.onSubmittedWorkDone();
                    case 10:
                      return e.next = 12, (this || _global).stagingBuffer.mapAsync(GPUMapMode.READ);
                    case 12:
                      return r = structuredClone((this || _global).stagingBuffer.getMappedRange()), (this || _global).stagingBuffer.unmap(), e.abrupt("return", {
                        buffer: r
                      });
                    case 17:
                      return e.prev = 17, e.t0 = e.catch(4), e.abrupt("return", {
                        err: new mt("Buffer", gt.BufferCopyFailed, "Failed to copy to host: " + ((null == e.t0 ? void 0 : e.t0.message) || "unknown"), !0)
                      });
                    case 20:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[4, 17]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.close = function () {
              var e;
              (this || _global).closed = !0, (this || _global).deviceBuffer.destroy(), null == (e = (this || _global).stagingBuffer) || e.destroy();
            }, e;
          }(),
          Dt = function () {
            function e(e, t, n, r, i) {
              void 0 === i && (i = Pt.Default), (this || _global).usage = i, (this || _global).stagingBuffer = void 0, (this || _global).deviceTexture = void 0, (this || _global).closed = !1;
              var o = GPUTextureUsage.STORAGE_BINDING | GPUTextureUsage.TEXTURE_BINDING;
              i === Pt.HostToDevice ? o |= GPUTextureUsage.COPY_DST : i === Pt.DeviceToHost ? (y.warn("[Buffer]: Copying texture to host buffer only supports 32bpp formats."), o |= GPUTextureUsage.COPY_SRC, (this || _global).stagingBuffer = e.createBuffer(256 * Math.ceil(4 * t / 256) * n, GPUBufferUsage.COPY_DST | GPUBufferUsage.MAP_READ)) : i === Pt.TimingQuery && y.warn("[Buffer]: BufferUsage.TimingQuery is not valid for Texture"), (this || _global).deviceTexture = e.device.createTexture({
                size: {
                  width: t,
                  height: n
                },
                format: r,
                usage: o
              });
            }
            var t = e.prototype;
            return t.copyToHost = function () {
              var e = f()(v().mark(function e(t) {
                var n, r, i;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!(this || _global).closed) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", {
                        err: new mt("Texture", gt.ResourceClosed, "Texture has been closed", !0)
                      });
                    case 2:
                      if ((this || _global).stagingBuffer && (this || _global).usage !== Pt.DeviceToHost) {
                        e.next = 4;
                        break;
                      }
                      return e.abrupt("return", {
                        err: new mt("Texture", gt.BadParameters, "Buffer usage is " + (this || _global).usage + ", but should be BufferUsage.DeviceToHost", !0)
                      });
                    case 4:
                      return y.debug("[Buffer]: copying texture", (this || _global).deviceTexture), e.prev = 5, (n = t.createCommandEncoder()).copyTextureToBuffer({
                        texture: (this || _global).deviceTexture,
                        mipLevel: 0,
                        origin: [0, 0, 0],
                        aspect: "all"
                      }, {
                        buffer: (this || _global).stagingBuffer,
                        offset: 0,
                        bytesPerRow: 256 * Math.ceil(4 * (this || _global).deviceTexture.width / 256),
                        rowsPerImage: (this || _global).deviceTexture.height
                      }, [(this || _global).deviceTexture.width, (this || _global).deviceTexture.height, 1]), t.queue.submit([n.finish()]), e.next = 11, t.queue.onSubmittedWorkDone();
                    case 11:
                      return e.next = 13, (this || _global).stagingBuffer.mapAsync(GPUMapMode.READ);
                    case 13:
                      return r = (this || _global).stagingBuffer.getMappedRange(), i = structuredClone(r), (this || _global).stagingBuffer.unmap(), e.abrupt("return", {
                        buffer: i
                      });
                    case 19:
                      return e.prev = 19, e.t0 = e.catch(5), e.abrupt("return", {
                        err: new mt("Texture", gt.BufferCopyFailed, "Failed to copy to host: " + ((null == e.t0 ? void 0 : e.t0.message) || "unknown"), !0)
                      });
                    case 22:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[5, 19]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.close = function () {
              var e;
              (this || _global).closed = !0, (this || _global).deviceTexture.destroy(), null == (e = (this || _global).stagingBuffer) || e.destroy();
            }, e;
          }(),
          Lt = function (e) {
            return e.F16 = "f16", e.F32 = "f32", e;
          }({}),
          Rt = function () {
            function e(e, t, n, r, i, o, a) {
              void 0 === i && (i = 1), void 0 === o && (o = !0), void 0 === a && (a = !1), (this || _global).inFilters = e, (this || _global).outFilters = t, (this || _global).kernelSize = n, (this || _global).scaleFactor = r, (this || _global).outPadding = i, (this || _global).convertToYuv = o, (this || _global).hostReadableOutput = a, (this || _global)._configuration = void 0, (this || _global)._activation = void 0, (this || _global)._weights = void 0, (this || _global)._biases = void 0, (this || _global)._inputs = void 0, (this || _global)._outputs = void 0, (this || _global)._pipeline = void 0, (this || _global)._outputShape = void 0, (this || _global)._sampler = void 0;
            }
            var t = e.prototype;
            return t.configure = function () {
              var e = f()(v().mark(function e(t, n) {
                var r, i, o, a, s, u, c;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return t.device.pushErrorScope("validation"), (this || _global)._outputShape = [Math.ceil(n.inputShape[0] * (this || _global).scaleFactor), Math.ceil(n.inputShape[1] * (this || _global).scaleFactor), (this || _global).outFilters], r = ((this || _global)._outputShape[0] + 2 * (this || _global).outPadding) * ((this || _global)._outputShape[1] + 2 * (this || _global).outPadding) * (this || _global).outFilters, y.debug("[Conv2dEntry_Upscale]: Creating output buffer of size", r), i = n.dataType === Lt.F32 ? 4 : 2, (this || _global)._configuration = n, (this || _global)._activation = n.activation, (this || _global)._outputs = new At(t, r * i, (this || _global).hostReadableOutput ? Pt.DeviceToHost : Pt.Default), o = this._createShader(n.expectedInputType), (this || _global)._sampler = t.device.createSampler({
                        magFilter: "linear",
                        minFilter: "linear"
                      }), e.next = 12, t.createShaderModule(o);
                    case 12:
                      if (a = e.sent, s = a.module, !(u = a.err) && s) {
                        e.next = 17;
                        break;
                      }
                      return e.abrupt("return", u || new mt("Conv2dEntry_Upscale", gt.PipelineCreationFailed, "Failed to create shader module", !0));
                    case 17:
                      return (this || _global)._pipeline = t.device.createComputePipeline({
                        layout: "auto",
                        compute: {
                          module: s,
                          entryPoint: "main"
                        },
                        label: "conv2d_entry_upscale"
                      }), e.next = 20, t.device.popErrorScope();
                    case 20:
                      if (!(c = e.sent)) {
                        e.next = 23;
                        break;
                      }
                      return e.abrupt("return", new mt("Conv2dEntry_Upscale", gt.PipelineCreationFailed, "Error creating compute pipeline: " + c.message, !0));
                    case 23:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.setWeights = function (e) {
              (this || _global)._weights = e;
            }, t.setBiases = function (e) {
              (this || _global)._biases = e;
            }, t.setInputs = function (e) {
              (this || _global)._inputs = e;
            }, t.getOutputs = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", (this || _global)._outputs);
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.close = function () {
              var e;
              (this || _global)._weights.close(), null == (e = (this || _global)._biases) || e.close(), (this || _global)._outputs.close();
            }, t.createFinalizedPass = function (e, t, n) {
              try {
                var r,
                  i = {
                    label: "conv2d_entry_upscale"
                  },
                  o = (this || _global)._pipeline.getBindGroupLayout(0);
                if ((this || _global)._inputs instanceof GPUTexture) r = (this || _global)._inputs.createView();else if ((this || _global)._inputs instanceof VideoFrame) r = e.device.importExternalTexture({
                  source: (this || _global)._inputs
                });else {
                  if (!((this || _global)._inputs instanceof GPUExternalTexture)) return y.error("Conv2d_entry_upscale invalid input type"), {
                    err: new mt("Conv2d_Entry_Upscale", gt.BadParameters, "Input type is not one of GPUTexture, GPUExternalTexture, VideoFrame", !0)
                  };
                  r = (this || _global)._inputs;
                }
                var a = [{
                  binding: 0,
                  resource: {
                    buffer: (this || _global)._outputs.deviceBuffer
                  }
                }, {
                  binding: 1,
                  resource: r
                }, {
                  binding: 2,
                  resource: (this || _global)._sampler
                }, {
                  binding: 3,
                  resource: {
                    buffer: (this || _global)._weights.deviceBuffer
                  }
                }];
                (this || _global)._biases && a.push({
                  binding: 4,
                  resource: {
                    buffer: (this || _global)._biases.deviceBuffer
                  }
                });
                var s = e.device.createBindGroup({
                  layout: o,
                  entries: a
                });
                n && (i.timestampWrites = {
                  querySet: n,
                  beginningOfPassWriteIndex: 0,
                  endOfPassWriteIndex: 1
                });
                var u = t.beginComputePass(i);
                return u.setPipeline((this || _global)._pipeline), u.setBindGroup(0, s), u.dispatchWorkgroups(Math.ceil((this || _global)._outputShape[1] / 12), Math.ceil((this || _global)._outputShape[0] / 12), 1), u.end(), {
                  pass: u
                };
              } catch (e) {
                return {
                  err: new mt("Conv2d_Entry_Upscale", gt.InferenceFailed, "Failed to create finalized pass: " + ((null == e ? void 0 : e.message) || "unknown"), !0)
                };
              }
            }, t._createShader = function (e) {
              var t = e === It.External ? "texture_external" : "texture_2d<fT>",
                n = (this || _global)._configuration.dataType,
                r = "sum;";
              (this || _global)._activation && (r = (this || _global)._activation.getWGSL("x", n) + ";");
              var i = 4,
                o = "";
              return (this || _global)._biases && (o = "@group(0) @binding(" + i + ") var<storage, read> biases: array<fT, M * N>;", i++), "\n        " + ((this || _global)._configuration.dataType === Lt.F16 ? "enable f16;" : "") + "\n        const GROUP_SIDE: u32 = 12;\n        const GROUP_LIMIT: u32 = 14;\n        const GROUP_THREADS: u32 = GROUP_SIDE * GROUP_SIDE;\n        const WARP_SIZE = 32;\n        const IN_FILTERS: u32 = " + (this || _global).inFilters + ";\n        const OUT_FILTERS: u32 = " + (this || _global).outFilters + ";\n        const OUT_PADDING: u32 = " + (this || _global).outPadding + ";\n        const IN_PADDING: u32 = 1;\n\n        const TOTAL_FILTERS = IN_FILTERS * OUT_FILTERS;\n\n        const TILE_OFFSET: u32 = (GROUP_LIMIT - GROUP_SIDE) / 2;\n        const KERNEL_SIZE: u32 = 3;\n        const OUT_WIDTH: u32 = " + (this || _global)._outputShape[1] + ";\n        const OUT_HEIGHT: u32 = " + (this || _global)._outputShape[0] + ";\n        const Y_COEF = vec3<fT>(0.299, 0.587, 0.114);\n\n        alias fT = " + (this || _global)._configuration.dataType + ";\n\n        @group(0) @binding(0) var<storage, read_write> outputBuffer: array<fT, (OUT_HEIGHT + OUT_PADDING * 2) * (OUT_WIDTH + OUT_PADDING * 2) * OUT_FILTERS>;\n        @group(0) @binding(1) var inputTexture: " + t + ";\n        @group(0) @binding(2) var inputSampler: sampler;\n        @group(0) @binding(3) var<storage, read> weightsBuffer: array<fT, KERNEL_SIZE * KERNEL_SIZE * TOTAL_FILTERS>;\n\n        " + o + "\n\n        var<workgroup> weights: array<fT, KERNEL_SIZE * KERNEL_SIZE * TOTAL_FILTERS>;\n        var<workgroup> scratch1: array<fT, GROUP_LIMIT*GROUP_LIMIT>; // Handles input to convolution\n\n        fn activate(x: fT) -> fT {\n            return " + r + ";\n        }\n\n        @compute @workgroup_size(GROUP_SIDE,GROUP_SIDE,1)\n        fn main(@builtin(global_invocation_id) global_id: vec3<u32>,\n                @builtin(local_invocation_index) tid: u32,\n                @builtin(local_invocation_id) thread_id: vec3<u32>,\n                @builtin(workgroup_id) group_id: vec3<u32>) {\n            let texSize = vec2<f32>(f32(OUT_WIDTH), f32(OUT_HEIGHT));\n            let texelSize = 1.0 / texSize;\n            let cRow = group_id.y * GROUP_SIDE;\n            let cCol = group_id.x * GROUP_SIDE ;\n\n            // 1. load weights\n            for (var i: u32 = 0 ; i < (TOTAL_FILTERS*KERNEL_SIZE*KERNEL_SIZE+GROUP_THREADS-1)/GROUP_THREADS; i++) {\n                let idx: u32 = i * GROUP_THREADS + tid;\n                if (idx < TOTAL_FILTERS*KERNEL_SIZE*KERNEL_SIZE) {\n                    weights[idx] = weightsBuffer[idx];\n                }\n            }\n\n            // 2. load pixels from input texture into shared scratch\n            if (thread_id.x * 2 < GROUP_LIMIT && thread_id.y * 2 < GROUP_LIMIT) {\n                let sRow = i32(cRow) - i32(TILE_OFFSET);\n                let sCol = i32(cCol) - i32(TILE_OFFSET);\n                let lRow = i32(thread_id.y * 2) + sRow;\n                let lCol = i32(thread_id.x * 2) + sCol;\n                var s: array<vec3<fT>, 4>;\n                let curPos = vec2<f32>(f32(lCol), f32(lRow)) * texelSize;\n                let cInc = vec2<f32>(texelSize.x, 0.0);\n                let rInc = vec2<f32>(0.0, texelSize.y);\n\n                // Collect the pixels this thread should collect, storing in registers\n                s[0] = vec3<fT>(textureSampleBaseClampToEdge(inputTexture, inputSampler, curPos).rgb);\n                s[1] = vec3<fT>(textureSampleBaseClampToEdge(inputTexture, inputSampler, curPos+cInc).rgb);\n                s[2] = vec3<fT>(textureSampleBaseClampToEdge(inputTexture, inputSampler, curPos+rInc).rgb);\n                s[3] = vec3<fT>(textureSampleBaseClampToEdge(inputTexture, inputSampler, curPos+texelSize).rgb);\n\n                // Do YUV conversion and store in workgroup memory.\n                // Doing the YUV conversion here instead of when storing to registers seems to be more performant (on M2 macbook anyway)\n                //\n                let row = thread_id.y * 2;\n                let col = thread_id.x * 2;\n\n                // Convert RGB to YUV and compress from full range to video range [16-236]. Not doing this will result in artifacts.\n                scratch1[row * GROUP_LIMIT + col] = dot(s[0] * 0.8627 + 0.0627, Y_COEF);\n                if (col+1 < GROUP_LIMIT) {\n                    scratch1[row * GROUP_LIMIT + col + 1] = dot(s[1] * 0.8627 + 0.0627, Y_COEF);\n                }\n                if (row+1 < GROUP_LIMIT) {\n                    scratch1[(row+1) * GROUP_LIMIT + col] = dot(s[2] * 0.8627 + 0.0627, Y_COEF);\n                    if (col+1 < GROUP_LIMIT) {\n                        scratch1[(row+1) * GROUP_LIMIT + col + 1] = dot(s[3] * 0.8627 + 0.0627, Y_COEF);\n                    }\n                }\n            }\n            workgroupBarrier();\n\n            // Each thread will perform OUT_FILTERS convolutions\n            var centers: array<vec3<u32>, OUT_FILTERS>;\n            var results: array<fT, OUT_FILTERS>;\n            for (var i: u32 = 0; i < OUT_FILTERS; i++) {\n                let z = thread_id.z + i;\n                let y = thread_id.y;\n                let x = thread_id.x;\n                centers[i] = vec3<u32>(x,y,z);\n            }\n            for (var i: u32 = 0; i < OUT_FILTERS; i++) {\n                // Load weights\n                var w: array<fT, 9>;\n                let off = centers[i].z * KERNEL_SIZE * KERNEL_SIZE;\n                for (var j: u32 = 0; j < KERNEL_SIZE * KERNEL_SIZE; j++) {\n                    w[j] = weights[off + j];\n                }\n                let row = centers[i].y + 1;\n                let col = centers[i].x + 1;\n\n                // Load values. There will probably be bank conflicts here that we can optimize in the future.\n                // TODO: Batch this into array<fT,9*4>;\n                var v: array<fT, 9>;\n                v[0] = scratch1[(row-1) * GROUP_LIMIT + (col-1)];\n                v[3] = scratch1[(row) * GROUP_LIMIT + (col-1)];\n                v[6] = scratch1[(row+1) * GROUP_LIMIT + (col-1)];\n                v[1] = scratch1[(row-1) * GROUP_LIMIT + (col)];\n                v[4] = scratch1[(row) * GROUP_LIMIT + (col)];\n                v[7] = scratch1[(row+1) * GROUP_LIMIT + (col)];\n                v[2] = scratch1[(row-1) * GROUP_LIMIT + (col+1)];\n                v[5] = scratch1[(row) * GROUP_LIMIT + (col+1)];\n                v[8] = scratch1[(row+1) * GROUP_LIMIT + (col+1)];\n\n                // Do dots\n                var sum: fT = 0.0;\n                sum += v[0] * w[0];\n                sum += v[1] * w[1];\n                sum += v[2] * w[2];\n                sum += v[3] * w[3];\n                sum += v[4] * w[4];\n                sum += v[5] * w[5];\n                sum += v[6] * w[6];\n                sum += v[7] * w[7];\n                sum += v[8] * w[8];\n                results[i] = activate(sum);\n            }\n            // write results\n            for (var i: u32 = 0; i < OUT_FILTERS; i++) {\n                let x = centers[i].x + cCol;\n                let y = centers[i].y + cRow;\n                let z = centers[i].z;\n                // reliniarize\n                let idx = (y+OUT_PADDING) * (OUT_WIDTH + OUT_PADDING * 2) * OUT_FILTERS + x * OUT_FILTERS + z;\n                outputBuffer[idx] = results[i];\n            }\n        }\n        ";
            }, e;
          }(),
          xt = function () {
            function e(e, t, n) {
              void 0 === n && (n = !1), (this || _global).inFilters = e, (this || _global).outFilters = t, (this || _global).hostReadableOutput = n, (this || _global)._configuration = void 0, (this || _global)._activation = void 0, (this || _global)._weights = void 0, (this || _global)._biases = void 0, (this || _global)._inputs = void 0, (this || _global)._outputs = void 0, (this || _global)._pipeline = void 0, (this || _global)._inputShape = void 0, (this || _global)._outputShape = void 0;
            }
            var t = e.prototype;
            return t.configure = function () {
              var e = f()(v().mark(function e(t, n) {
                var r, i, o, a, s, u, c, d;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.prev = 0, t.device.pushErrorScope("validation"), r = Math.floor(1), (this || _global)._outputShape = [n.inputShape[0] - r + 1, n.inputShape[1] - r + 1, (this || _global).outFilters], (this || _global)._inputShape = n.inputShape, i = ((this || _global)._outputShape[0] + 2) * ((this || _global)._outputShape[1] + 2) * (this || _global).outFilters, y.debug("GPURenderPipeline hidden output shape: " + (this || _global)._outputShape + ", size: " + i + " hostReadable " + (this || _global).hostReadableOutput), o = n.dataType === Lt.F32 ? 4 : 2, (this || _global)._configuration = n, (this || _global)._activation = n.activation, (this || _global)._outputs = new At(t, i * o, (this || _global).hostReadableOutput ? Pt.DeviceToHost : Pt.Default), a = this.createShader(), e.next = 14, t.createShaderModule(a);
                    case 14:
                      if (s = e.sent, u = s.module, !(c = s.err) && u) {
                        e.next = 19;
                        break;
                      }
                      return e.abrupt("return", new mt("Conv2d_3x3s1p1", gt.PipelineCreationFailed, "Pipeline creation failed: " + (null == c ? void 0 : c.message), !0));
                    case 19:
                      return (this || _global)._pipeline = t.device.createComputePipeline({
                        layout: "auto",
                        compute: {
                          module: u,
                          entryPoint: "main"
                        },
                        label: "conv2d_entry_upscale"
                      }), e.next = 22, t.device.popErrorScope();
                    case 22:
                      if (!(d = e.sent)) {
                        e.next = 25;
                        break;
                      }
                      return e.abrupt("return", new mt("Conv2d_3x3s1p1", gt.PipelineCreationFailed, "Pipeline creation failed: " + (null == d ? void 0 : d.message), !0));
                    case 25:
                      e.next = 30;
                      break;
                    case 27:
                      return e.prev = 27, e.t0 = e.catch(0), e.abrupt("return", new mt("Conv2d_3x3s1p1", gt.PipelineCreationFailed, "Pipeline creation failed: " + (null == e.t0 ? void 0 : e.t0.message), !0));
                    case 30:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[0, 27]]);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.close = function () {
              var e;
              (this || _global)._weights.close(), null == (e = (this || _global)._biases) || e.close(), (this || _global)._outputs.close();
            }, t.setWeights = function (e) {
              (this || _global)._weights = e;
            }, t.setBiases = function (e) {
              (this || _global)._biases = e;
            }, t.setInputs = function (e) {
              (this || _global)._inputs = e;
            }, t.getOutputs = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", (this || _global)._outputs);
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.createFinalizedPass = function (e, t, n) {
              if (!((this || _global)._inputs instanceof At)) return {
                err: new mt("Conv2d_3x3s1p1", gt.BadParameters, "ModelLayerInput is not a Buffer", !0)
              };
              try {
                var r = {
                    label: "conv2d_mid_basic"
                  },
                  i = (this || _global)._pipeline.getBindGroupLayout(0),
                  o = [{
                    binding: 0,
                    resource: {
                      buffer: (this || _global)._outputs.deviceBuffer
                    }
                  }, {
                    binding: 1,
                    resource: {
                      buffer: (this || _global)._inputs.deviceBuffer
                    }
                  }, {
                    binding: 2,
                    resource: {
                      buffer: (this || _global)._weights.deviceBuffer
                    }
                  }];
                (this || _global)._biases && o.push({
                  binding: 3,
                  resource: {
                    buffer: (this || _global)._biases.deviceBuffer
                  }
                });
                var a = e.device.createBindGroup({
                  layout: i,
                  entries: o
                });
                n && (r.timestampWrites = {
                  querySet: n,
                  beginningOfPassWriteIndex: 0,
                  endOfPassWriteIndex: 1
                });
                var s = t.beginComputePass(r);
                return s.setPipeline((this || _global)._pipeline), s.setBindGroup(0, a), s.dispatchWorkgroups(Math.ceil((this || _global)._outputShape[1] / 12), Math.ceil((this || _global)._outputShape[0] / 8), (this || _global)._outputShape[2] / 8), s.end(), {
                  pass: s
                };
              } catch (e) {
                return {
                  err: new mt("Conv2d_3x3s1p1", gt.InferenceFailed, "Layer pass failed: " + ((null == e ? void 0 : e.message) || "unknown"), !0)
                };
              }
            }, t.createShader = function () {
              var e = (this || _global)._configuration.dataType,
                t = "sum;";
              (this || _global)._activation && (t = (this || _global)._activation.getWGSL("x", e) + ";");
              var n = "";
              return (this || _global)._biases && (n = "@group(0) @binding(3) var<storage, read> biases: array<fT, M * N>;"), "\n            " + ((this || _global)._configuration.dataType === Lt.F16 ? "enable f16;" : "") + "\n            const IN_FILTERS: u32 = " + (this || _global).inFilters + ";\n            const OUT_FILTERS: u32 = " + (this || _global).outFilters + ";\n            const TOTAL_FILTERS: u32 = IN_FILTERS * OUT_FILTERS;\n            const OUT_WIDTH: u32 = " + (this || _global)._outputShape[1] + ";\n            const OUT_HEIGHT: u32 = " + (this || _global)._outputShape[0] + ";\n            const IN_WIDTH: u32 = " + (this || _global)._inputShape[1] + ";\n            const IN_HEIGHT: u32 = " + (this || _global)._inputShape[0] + ";\n            const PADDING: u32 = 1;\n            const KERNEL_SIZE: u32 = 3;\n            const GROUP_SIDE_W: u32 = 12;\n            const GROUP_SIDE_H: u32 = 8;\n            const GROUP_DEPTH: u32 = 8;\n            const THREAD_DEPTH: u32 = 8;\n            const GROUP_LIMIT_W: u32 = GROUP_SIDE_W + PADDING * 2;\n            const GROUP_LIMIT_H: u32 = GROUP_SIDE_H + PADDING * 2;\n            const GROUP_THREADS: u32 = GROUP_SIDE_W * GROUP_SIDE_H;\n\n            const WARP_SIZE: u32 = 32;\n            alias fT = " + (this || _global)._configuration.dataType + ";\n            @group(0) @binding(0) var<storage, read_write> outputBuffer: array<fT, (OUT_HEIGHT + PADDING * 2) * (OUT_WIDTH + PADDING * 2) * OUT_FILTERS>;\n            @group(0) @binding(1) var<storage, read> inputBuffer: array<fT, (IN_HEIGHT + PADDING * 2) * (IN_WIDTH + PADDING * 2) * IN_FILTERS>;\n            @group(0) @binding(2) var<storage, read> weightsBuffer: array<fT, TOTAL_FILTERS * KERNEL_SIZE * KERNEL_SIZE>;\n            " + n + "\n            var<workgroup> weights: array<fT, KERNEL_SIZE * KERNEL_SIZE * TOTAL_FILTERS>;\n            var<workgroup> inputs: array<fT, GROUP_LIMIT_W * GROUP_LIMIT_H * IN_FILTERS>;\n\n            fn activate(x: fT) -> fT {\n                return " + t + ";\n            }\n\n            @compute @workgroup_size(GROUP_SIDE_W, GROUP_SIDE_H, GROUP_DEPTH/THREAD_DEPTH)\n            fn main(@builtin(global_invocation_id) global_id: vec3<u32>,\n                    @builtin(local_invocation_index) tid: u32,\n                    @builtin(local_invocation_id) thread_id: vec3<u32>,\n                    @builtin(workgroup_id) group_id: vec3<u32>) {\n\n                let tileCol = group_id.x * GROUP_SIDE_W ;\n                let tileRow = group_id.y * GROUP_SIDE_H ;\n\n                // Load weights\n                for (var i: u32 = 0 ; i < ((TOTAL_FILTERS*KERNEL_SIZE*KERNEL_SIZE+GROUP_THREADS-1)/GROUP_THREADS); i++) {\n                    let idx: u32 = i * GROUP_THREADS + tid;\n                    if (idx < TOTAL_FILTERS*KERNEL_SIZE*KERNEL_SIZE) {\n                        weights[idx] = weightsBuffer[idx];\n                    }\n                }\n\n                // Load activations. This will be GROUP_LIMIT*GROUP_LIMIT*IN_FILTERS in size.\n                // Buffers are in (H,W,C) format\n\n                if (thread_id.x * 2 < GROUP_LIMIT_W && thread_id.y * 2 < GROUP_LIMIT_H) {\n                    for (var c: u32 = 0; c < IN_FILTERS; c++) {\n                        for (var n: u32 = 0; n < 2; n++) {\n                            for (var m: u32 = 0; m < 2; m++) {\n                                let sCol: u32 = (thread_id.x*2+m) * IN_FILTERS + c;\n                                let sRow: u32 = (thread_id.y*2+n) * IN_FILTERS * GROUP_LIMIT_W;\n                                let gIdx: u32 = (tileRow + thread_id.y*2 + n) * IN_FILTERS * (IN_WIDTH + PADDING * 2) + (tileCol + thread_id.x*2 + m) * IN_FILTERS + c;\n                                inputs[sRow + sCol] = inputBuffer[gIdx];\n                            }\n                        }\n                    }\n                }\n                workgroupBarrier();\n                var centers: array<vec3<u32>, THREAD_DEPTH>;\n                var results: array<fT, THREAD_DEPTH>;\n                for (var i: u32 = 0; i < THREAD_DEPTH; i++) {\n                    let z = group_id.z * GROUP_DEPTH + thread_id.z * THREAD_DEPTH + i;\n                    let y = thread_id.y;\n                    let x = thread_id.x;\n                    centers[i] = vec3<u32>(x,y,z);\n                    results[i] = 0.0;\n                }\n                for (var z: u32 = 0; z < IN_FILTERS; z++) {\n                    let row = thread_id.y + PADDING;\n                    let col = thread_id.x + PADDING;\n                    let c: u32 = (tid + z) % IN_FILTERS;\n                    // Load values. There will probably be bank conflicts here that we can optimize in the future.\n                    var v: array<fT, 9>;\n                    v[0] = inputs[(row-1) * GROUP_LIMIT_W * IN_FILTERS + (col-1) * IN_FILTERS + c];\n                    v[3] = inputs[(row) * GROUP_LIMIT_W * IN_FILTERS + (col-1) * IN_FILTERS + c];\n                    v[6] = inputs[(row+1) * GROUP_LIMIT_W * IN_FILTERS + (col-1) * IN_FILTERS + c];\n                    v[1] = inputs[(row-1) * GROUP_LIMIT_W * IN_FILTERS + (col) * IN_FILTERS + c];\n                    v[4] = inputs[(row) * GROUP_LIMIT_W * IN_FILTERS + (col) * IN_FILTERS + c];\n                    v[7] = inputs[(row+1) * GROUP_LIMIT_W * IN_FILTERS + (col) * IN_FILTERS + c];\n                    v[2] = inputs[(row-1) * GROUP_LIMIT_W * IN_FILTERS + (col+1) * IN_FILTERS + c];\n                    v[5] = inputs[(row) * GROUP_LIMIT_W * IN_FILTERS + (col+1) * IN_FILTERS + c];\n                    v[8] = inputs[(row+1) * GROUP_LIMIT_W * IN_FILTERS + (col+1) * IN_FILTERS + c];\n\n                    // Do dots\n                    for (var i: u32 = 0; i < THREAD_DEPTH; i++) {\n                        let weightBase = centers[i].z * IN_FILTERS * KERNEL_SIZE * KERNEL_SIZE ;\n                        var w: array<fT, 9>;\n                        let off = weightBase + c * KERNEL_SIZE * KERNEL_SIZE;\n                        for (var j: u32 = 0; j < KERNEL_SIZE * KERNEL_SIZE; j++) {\n                            w[j] = weights[off + j];\n                        }\n\n                        var sum: fT = 0.0;\n                        sum += v[0] * w[0];\n                        sum += v[1] * w[1];\n                        sum += v[2] * w[2];\n                        sum += v[3] * w[3];\n                        sum += v[4] * w[4];\n                        sum += v[5] * w[5];\n                        sum += v[6] * w[6];\n                        sum += v[7] * w[7];\n                        sum += v[8] * w[8];\n                        results[i] += sum;\n                    }\n                }\n\n                // write results\n                for (var i: u32 = 0; i < GROUP_DEPTH; i++) {\n                    let x = centers[i].x + PADDING;\n                    let y = centers[i].y + PADDING;\n                    let z = centers[i].z;\n\n                    let outIdx = (tileRow + y) * (OUT_WIDTH + PADDING * 2) * OUT_FILTERS + (tileCol + x) * OUT_FILTERS + z ;\n                    if (tileRow + y < (OUT_HEIGHT - PADDING) && tileCol + x < (OUT_WIDTH - PADDING)) {\n                        outputBuffer[outIdx] = activate(results[i]);\n                    }\n                }\n            };\n        ";
            }, e;
          }(),
          Mt = function () {
            function e(e, t, n) {
              void 0 === n && (n = !1), (this || _global).inChannels = e, (this || _global).outChannels = t, (this || _global).hostReadableOutput = n, (this || _global)._configuration = void 0, (this || _global)._activation = void 0, (this || _global)._weights = void 0, (this || _global)._biases = void 0, (this || _global)._inputs = void 0, (this || _global)._outputs = void 0, (this || _global)._pipeline = void 0, (this || _global)._inputShape = void 0, (this || _global)._outputShape = void 0;
            }
            var t = e.prototype;
            return t.configure = function () {
              var e = f()(v().mark(function e(t, n) {
                var r, i, o, a, s, u, c;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return t.device.pushErrorScope("validation"), (this || _global)._outputShape = [n.inputShape[0] - 1 + 1, n.inputShape[1] - 1 + 1, (this || _global).outChannels], (this || _global)._inputShape = n.inputShape, r = ((this || _global)._outputShape[0] + 2) * ((this || _global)._outputShape[1] + 2) * (this || _global).outChannels, y.debug("[Conv2d_igemm_f16_Nx3x3x8]: Hidden output shape: " + (this || _global)._outputShape + ", size: " + r + " hostReadable " + (this || _global).hostReadableOutput), i = n.dataType === Lt.F32 ? 4 : 2, (this || _global)._configuration = n, (this || _global)._activation = n.activation, (this || _global)._outputs = new At(t, r * i, (this || _global).hostReadableOutput ? Pt.DeviceToHost : Pt.Default), o = this._createShader(), y.debug("[Conv2d_igemm_f16_Nx3x3x8]: Shader", o), e.next = 14, t.createShaderModule(o);
                    case 14:
                      if (a = e.sent, s = a.module, !(u = a.err) && s) {
                        e.next = 19;
                        break;
                      }
                      return e.abrupt("return", u || new mt("Conv2d_igemm_f16_Nx3x3x8", gt.PipelineCreationFailed, "Failed to create shader module", !0));
                    case 19:
                      return (this || _global)._pipeline = t.device.createComputePipeline({
                        layout: "auto",
                        compute: {
                          module: s,
                          entryPoint: "main"
                        },
                        label: "conv2d_igemm_f16_Nx3x3x8"
                      }), e.next = 22, t.device.popErrorScope();
                    case 22:
                      if (!(c = e.sent)) {
                        e.next = 25;
                        break;
                      }
                      return e.abrupt("return", new mt("conv2d_igemm_f16_Nx3x3x8", gt.PipelineCreationFailed, "Failed to create compute pipeline: " + c.message, !0));
                    case 25:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.setWeights = function (e) {
              (this || _global)._weights = e;
            }, t.setBiases = function (e) {
              (this || _global)._biases = e;
            }, t.setInputs = function (e) {
              (this || _global)._inputs = e;
            }, t.getOutputs = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", (this || _global)._outputs);
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.close = function () {
              var e;
              (this || _global)._weights.close(), null == (e = (this || _global)._biases) || e.close(), (this || _global)._outputs.close();
            }, t.createFinalizedPass = function (e, t, n) {
              if (!((this || _global)._inputs instanceof At)) return {
                err: new mt("Conv2d_igemm_f16_Nx3x3x8", gt.BadParameters, "ModelLayerInput is not a Buffer", !0)
              };
              try {
                var r = {
                    label: "conv2d_mid_basic"
                  },
                  i = (this || _global)._pipeline.getBindGroupLayout(0),
                  o = [{
                    binding: 0,
                    resource: {
                      buffer: (this || _global)._outputs.deviceBuffer
                    }
                  }, {
                    binding: 1,
                    resource: {
                      buffer: (this || _global)._inputs.deviceBuffer
                    }
                  }, {
                    binding: 2,
                    resource: {
                      buffer: (this || _global)._weights.deviceBuffer
                    }
                  }];
                (this || _global)._biases && o.push({
                  binding: 3,
                  resource: {
                    buffer: (this || _global)._biases.deviceBuffer
                  }
                });
                var a = e.device.createBindGroup({
                  layout: i,
                  entries: o
                });
                n && (r.timestampWrites = {
                  querySet: n,
                  beginningOfPassWriteIndex: 0,
                  endOfPassWriteIndex: 1
                });
                var s = t.beginComputePass(r);
                return s.setPipeline((this || _global)._pipeline), s.setBindGroup(0, a), s.dispatchWorkgroups(Math.ceil((this || _global)._outputShape[1] / 8), Math.ceil((this || _global)._outputShape[0] / 32), 1), s.end(), {
                  pass: s
                };
              } catch (e) {
                return {
                  err: new mt("Conv2d_igemm_f16_Nx3x3x8", gt.InferenceFailed, "Finalized pass failed: " + ((null == e ? void 0 : e.message) || "unknown"), !0)
                };
              }
            }, t._createShader = function () {
              var e = (this || _global)._configuration.dataType,
                t = "sum;";
              (this || _global)._activation && (t = (this || _global)._activation.getWGSL("x", e) + ";");
              var n = "";
              return (this || _global)._biases && (n = "@group(0) @binding(3) var<storage, read> biases: array<fT, M * N>;"), "\n            " + ((this || _global)._configuration.dataType === Lt.F16 ? "enable f16;" : "") + "\n            const IN_CHANNELS: i32 = " + (this || _global).inChannels + ";\n            const OUT_CHANNELS: i32 = " + (this || _global).outChannels + ";\n            const PACKED_IN_CHANNELS: i32 = IN_CHANNELS/2;\n            const PACKED_OUT_CHANNELS: i32 = OUT_CHANNELS/2;\n            const KERNEL_SIZE: i32 = 3;\n\n            const TILE_IN_W: i32 = 10;\n            const TILE_IN_H: i32 = 34;\n            const TILE_OUT_W: i32 = 8;\n            const TILE_OUT_H: i32 = 32;\n            const TILE_OUT_DEPTH: i32 = OUT_CHANNELS;\n            const PACKED_TILE_OUT_DEPTH: i32 = PACKED_OUT_CHANNELS;\n\n            const IN_PADDING: i32 = 1;\n            const OUT_PADDING: i32 = 1;\n\n            const IN_WIDTH: i32 = " + (this || _global)._inputShape[1] + ";\n            const IN_HEIGHT: i32 = " + (this || _global)._inputShape[0] + ";\n            const OUT_WIDTH: i32 = " + (this || _global)._outputShape[1] + ";\n            const OUT_HEIGHT: i32 = " + (this || _global)._outputShape[0] + ";\n\n            const WARP_SIZE: i32 = 32;\n            const GROUP_THREADS: i32 = 256;\n            const K: i32 = IN_CHANNELS * 3 * 3;\n\n            alias fT = " + (this || _global)._configuration.dataType + ";\n            @group(0) @binding(0) var<storage, read_write> outputBuffer: array<vec2<fT>, (OUT_HEIGHT + OUT_PADDING * 2) * (OUT_WIDTH + OUT_PADDING * 2) * PACKED_OUT_CHANNELS>;\n            @group(0) @binding(1) var<storage, read> inputBuffer: array<fT, (IN_HEIGHT + IN_PADDING * 2) * (IN_WIDTH + IN_PADDING * 2) * IN_CHANNELS>;\n            @group(0) @binding(2) var<storage, read> weightsBuffer: array<fT, IN_CHANNELS * OUT_CHANNELS * KERNEL_SIZE * KERNEL_SIZE>;\n            " + n + "\n\n            var<workgroup> S_WEIGHTS: array<fT, KERNEL_SIZE * KERNEL_SIZE * IN_CHANNELS * OUT_CHANNELS>;\n            var<workgroup> S_ACTIVATIONS: array<fT, TILE_IN_W * TILE_IN_H * IN_CHANNELS>;\n\n            fn activate(x: fT) -> fT {\n                return " + t + ";\n            }\n\n            @compute @workgroup_size(GROUP_THREADS,1,1)\n            fn main(@builtin(global_invocation_id) global_id: vec3<u32>,\n                    @builtin(local_invocation_index) tid: u32,\n                    @builtin(local_invocation_id) thread_id: vec3<u32>,\n                    @builtin(workgroup_id) group_id: vec3<u32>) {\n\n                let tileCol: i32 = i32(group_id.x) * TILE_OUT_W;\n                let tileRow: i32 = i32(group_id.y) * TILE_OUT_H;\n                let wid: i32 = i32(tid) / WARP_SIZE;\n                let wtid: i32 = i32(tid) % WARP_SIZE;\n\n                // Load weights from VRAM to Threadgroup Memory.\n                // Currently they are in CoCiKK, but we need them in CoKKCi for this.\n                if (i32(tid) >= GROUP_THREADS - (IN_CHANNELS*OUT_CHANNELS))\n                {\n                    let ttid = i32(tid) - (GROUP_THREADS - (IN_CHANNELS*OUT_CHANNELS));\n\n                    var reg: array<fT, 9>;\n                    for (var i: i32 = 0; i < 9; i++) {\n                        reg[i] = weightsBuffer[(i * (IN_CHANNELS*OUT_CHANNELS)) + ttid];\n                    }\n\n                    // Reshape and store in threadgroup memory\n                    for (var i: i32 = 0; i < 9; i++) {\n                        let inIdx: i32 = (i * (IN_CHANNELS*OUT_CHANNELS)) + ttid;\n                        let co = inIdx / (IN_CHANNELS * 3 * 3);\n                        let ci = (inIdx - co * IN_CHANNELS * 3 * 3) / (3 * 3);\n                        let ky = inIdx / 3 % 3;\n                        let kx = inIdx % 3;\n                        let remapped = co * IN_CHANNELS * 3 * 3 + ky * IN_CHANNELS * 3 + kx * IN_CHANNELS + ci;\n                        S_WEIGHTS[remapped] = reg[i];\n                    }\n                }\n\n                // Load activations from VRAM to Threadgroup Memory\n                // TODO: Reshape into HCW from HWC\n                if (i32(tid) < TILE_IN_W * IN_CHANNELS)\n                {\n                    let x: i32 = i32(group_id.x) * TILE_OUT_W;\n                    let y: i32 = i32(group_id.y) * TILE_OUT_H;\n                    var reg: array<fT, TILE_IN_H / 2>;\n                    for (var i: i32 = 0; i < 2; i++) {\n                        for (var j: i32 = 0; j < TILE_IN_H / 2; j++) {\n                            let src = ((y + (i * TILE_IN_H / 2) + j) * (IN_PADDING * 2 + IN_WIDTH) * IN_CHANNELS) + x * IN_CHANNELS + i32(tid);\n                            reg[j] = inputBuffer[src];\n                        }\n                        for (var j: i32 = 0; j < TILE_IN_H / 2; j++) {\n                            let dst = (i * TILE_IN_H / 2 + j) * TILE_IN_W * IN_CHANNELS + i32(tid);\n                            S_ACTIVATIONS[dst] = reg[j];\n                        }\n                    }\n                }\n                // Wait for memory operations to complete\n                workgroupBarrier();\n\n                // Exit if this thread is out of bounds.\n                if (tileRow + OUT_PADDING + wtid >= OUT_HEIGHT - OUT_PADDING ||\n                    tileCol + OUT_PADDING + wid >= OUT_WIDTH - OUT_PADDING\n                ) {\n                    return;\n                }\n\n                // We are doing an implicit matmul of the shape\n                // M=ThreadOutWidth*ThreadOutHeight=1, K=IN_CHANNELS*KernelSize*KernelSize, N=OUT_CHANNELS\n                // We will iterate along K 4 values at a time\n\n                var results: array<vec2<fT>, PACKED_OUT_CHANNELS>;\n                for (var k: i32 = 0; k < K; k += 4) {\n                    var weights: array<array<vec2<fT>,2>, OUT_CHANNELS>;\n                    var activations: array<vec2<fT>,2>;\n\n                    // Load activations into registers. In HWC.\n                    {\n                        let currentXOff: i32 = (k / IN_CHANNELS) % 3;\n                        let currentYOff: i32 = (k / IN_CHANNELS) / 3;\n                        let currentCOff: i32 = k % IN_CHANNELS;\n                        {\n                            let c: i32 = 0;\n                            let idx: i32 = (currentYOff + wtid) * TILE_IN_W * IN_CHANNELS + (wid + currentXOff) * IN_CHANNELS + currentCOff;\n                            activations[c].x = S_ACTIVATIONS[idx + c * 2];\n                            activations[c].y = S_ACTIVATIONS[idx + c * 2 + 1];\n                        }\n                        {\n                            let c: i32 = 1;\n                            let idx: i32 = (currentYOff + wtid) * TILE_IN_W * IN_CHANNELS + (wid + currentXOff) * IN_CHANNELS + currentCOff;\n                            activations[c].x = S_ACTIVATIONS[idx + c * 2];\n                            activations[c].y = S_ACTIVATIONS[idx + c * 2 + 1];\n                        }\n                    }\n\n                    // Load weights into registers. In CoKKCi.\n                    for (var co: i32 = 0; co < OUT_CHANNELS; co++) {\n                        let idx: i32 = co * KERNEL_SIZE * KERNEL_SIZE * IN_CHANNELS;\n                        {\n                            let n: i32 = 0;\n                            weights[co][n].x = S_WEIGHTS[idx + k + n * 2];\n                            weights[co][n].y = S_WEIGHTS[idx + k + n * 2 + 1];\n                        }\n                        {\n                            let n: i32 = 1;\n                            weights[co][n].x = S_WEIGHTS[idx + k + n * 2];\n                            weights[co][n].y = S_WEIGHTS[idx + k + n * 2 + 1];\n                        }\n                    }\n\n                    // Do the [1,4]x[4,4] matmul. Chrome doesn't seem to properly unroll loops so excuse the\n                    // shenanigans here.\n                    {\n                        let pco: i32 = 0;\n                        let co = pco * 2;\n                        {\n                            let k_i: i32 = 0;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                        {\n                            let k_i: i32 = 1;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                    }\n                    {\n                        let pco: i32 = 1;\n                        let co = pco * 2;\n                        {\n                            let k_i: i32 = 0;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                        {\n                            let k_i: i32 = 1;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                    }\n                    {\n                        let pco: i32 = 2;\n                        let co = pco * 2;\n                        {\n                            let k_i: i32 = 0;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                        {\n                            let k_i: i32 = 1;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                    }\n                    {\n                        let pco: i32 = 3;\n                        let co = pco * 2;\n                        {\n                            let k_i: i32 = 0;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                        {\n                            let k_i: i32 = 1;\n                            results[pco].x += activations[k_i].x * weights[co][k_i].x;\n                            results[pco].x += activations[k_i].y * weights[co][k_i].y;\n                            results[pco].y += activations[k_i].x * weights[co + 1][k_i].x;\n                            results[pco].y += activations[k_i].y * weights[co + 1][k_i].y;\n                        }\n                    }\n                }\n                // OK we now have all of our output channels for this pixel. Write to VRAM.\n                {\n                    let c: i32 = 0;\n                    let idx: i32 = (tileRow + OUT_PADDING + wtid) * (OUT_WIDTH + OUT_PADDING * 2) * PACKED_OUT_CHANNELS + (tileCol + OUT_PADDING + wid) * PACKED_OUT_CHANNELS + c ;\n                    outputBuffer[idx] = vec2<fT>(activate(results[c].x), activate(results[c].y));\n                }\n                {\n                    let c: i32 = 1;\n                    let idx: i32 = (tileRow + OUT_PADDING + wtid) * (OUT_WIDTH + OUT_PADDING * 2) * PACKED_OUT_CHANNELS + (tileCol + OUT_PADDING + wid) * PACKED_OUT_CHANNELS + c ;\n                    outputBuffer[idx] = vec2<fT>(activate(results[c].x), activate(results[c].y));\n                }\n                {\n                    let c: i32 = 2;\n                    let idx: i32 = (tileRow + OUT_PADDING + wtid) * (OUT_WIDTH + OUT_PADDING * 2) * PACKED_OUT_CHANNELS + (tileCol + OUT_PADDING + wid) * PACKED_OUT_CHANNELS + c ;\n                    outputBuffer[idx] = vec2<fT>(activate(results[c].x), activate(results[c].y));\n                }\n                {\n                    let c: i32 = 3;\n                    let idx: i32 = (tileRow + OUT_PADDING + wtid) * (OUT_WIDTH + OUT_PADDING * 2) * PACKED_OUT_CHANNELS + (tileCol + OUT_PADDING + wid) * PACKED_OUT_CHANNELS + c ;\n                    outputBuffer[idx] = vec2<fT>(activate(results[c].x), activate(results[c].y));\n                }\n            };\n        ";
            }, e;
          }(),
          Nt = function () {
            function e(e, t, n, r, i) {
              void 0 === i && (i = !1), (this || _global).inFeatures = e, (this || _global).outFeatures = t, (this || _global).kernelSize = n, (this || _global).inPadding = r, (this || _global).hostReadableOutput = i, (this || _global)._configuration = void 0, (this || _global)._activation = void 0, (this || _global)._weights = void 0, (this || _global)._biases = void 0, (this || _global)._inputs = void 0, (this || _global)._lrImage = void 0, (this || _global)._outputs = void 0, (this || _global)._pipeline = void 0, (this || _global)._inputShape = void 0, (this || _global)._outputShape = void 0, (this || _global)._sampler = void 0, (this || _global)._storageFormat = void 0;
            }
            var t = e.prototype;
            return t.configure = function () {
              var e = f()(v().mark(function e(t, n) {
                var r, i, o, a, s, u;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return t.device.pushErrorScope("validation"), r = Math.floor(((this || _global).kernelSize - 1) / 2), (this || _global)._outputShape = [n.inputShape[0] - r + (this || _global).inPadding, n.inputShape[1] - r + (this || _global).inPadding, (this || _global).outFeatures], (this || _global)._storageFormat = t.storageFormat, (this || _global)._inputShape = n.inputShape, (this || _global)._configuration = n, (this || _global)._activation = n.activation, (this || _global)._outputs = new Dt(t, (this || _global)._outputShape[1], (this || _global)._outputShape[0], (this || _global)._storageFormat, (this || _global).hostReadableOutput ? Pt.DeviceToHost : Pt.Default), i = this._createShader(n.expectedInputType), (this || _global)._sampler = t.device.createSampler({
                        magFilter: "linear",
                        minFilter: "linear"
                      }), e.next = 12, t.createShaderModule(i);
                    case 12:
                      if (o = e.sent, a = o.module, !(s = o.err) && a) {
                        e.next = 17;
                        break;
                      }
                      return e.abrupt("return", s || new mt("Conv2d_Exit_ChromaCombine", gt.ShaderCompilationFailed, "Failed to create shader module", !0));
                    case 17:
                      return (this || _global)._pipeline = t.device.createComputePipeline({
                        layout: "auto",
                        compute: {
                          module: a,
                          entryPoint: "main"
                        },
                        label: "conv2d_entry_upscale"
                      }), e.next = 20, t.device.popErrorScope();
                    case 20:
                      (u = e.sent) && new mt("Conv2d_Exit_ChromaCombine", gt.PipelineCreationFailed, "Failed to create compute pipeline: " + u.message, !0);
                    case 22:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.setWeights = function (e) {
              (this || _global)._weights = e;
            }, t.setBiases = function (e) {
              (this || _global)._biases = e;
            }, t.setInputs = function (e) {
              (this || _global)._inputs = e;
            }, t.getOutputs = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.abrupt("return", (this || _global)._outputs);
                    case 1:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.setLowResTexture = function (e) {
              (this || _global)._lrImage = e;
            }, t.close = function () {
              var e;
              (this || _global)._weights.close(), null == (e = (this || _global)._biases) || e.close(), (this || _global)._outputs.close();
            }, t.createFinalizedPass = function (e, t, n) {
              if (!((this || _global)._inputs instanceof At)) return {
                err: new mt("Conv2d_Exit_ChromaCombine", gt.BadParameters, "ModelLayerInput is not a Buffer", !0)
              };
              try {
                var r,
                  i = {
                    label: "conv2d_exit"
                  };
                if ((this || _global)._lrImage instanceof GPUTexture) r = (this || _global)._lrImage.createView();else if ((this || _global)._lrImage instanceof VideoFrame) r = e.device.importExternalTexture({
                  source: (this || _global)._lrImage
                });else {
                  if (!((this || _global)._lrImage instanceof GPUExternalTexture)) return {
                    err: new mt("Conv2d_Exit_ChromaCombine", gt.BadParameters, "Input is not one of GPUTexture, VideoFrame, GPUExternalTexture", !0)
                  };
                  r = (this || _global)._lrImage;
                }
                var o = (this || _global)._pipeline.getBindGroupLayout(0),
                  a = [{
                    binding: 0,
                    resource: (this || _global)._outputs.deviceTexture.createView()
                  }, {
                    binding: 1,
                    resource: {
                      buffer: (this || _global)._inputs.deviceBuffer
                    }
                  }, {
                    binding: 2,
                    resource: {
                      buffer: (this || _global)._weights.deviceBuffer
                    }
                  }, {
                    binding: 3,
                    resource: r
                  }, {
                    binding: 4,
                    resource: (this || _global)._sampler
                  }];
                (this || _global)._biases && a.push({
                  binding: 3,
                  resource: {
                    buffer: (this || _global)._biases.deviceBuffer
                  }
                });
                var s = e.device.createBindGroup({
                  layout: o,
                  entries: a
                });
                n && (i.timestampWrites = {
                  querySet: n,
                  beginningOfPassWriteIndex: 0,
                  endOfPassWriteIndex: 1
                });
                var u = t.beginComputePass(i);
                return u.setPipeline((this || _global)._pipeline), u.setBindGroup(0, s), u.dispatchWorkgroups(Math.ceil((this || _global)._outputShape[1] / 16), Math.ceil((this || _global)._outputShape[0] / 16), 1), u.end(), {
                  pass: u
                };
              } catch (e) {
                return {
                  err: new mt("Conv2d_Exit_ChromaCombine", gt.InferenceFailed, "Failed to create finalized pass: " + ((null == e ? void 0 : e.message) || "unknown"), !0)
                };
              }
            }, t._createShader = function (e) {
              var t = e === It.External ? "texture_external" : "texture_2d<fT>",
                n = (this || _global)._configuration.dataType;
              (this || _global)._activation && (this || _global)._activation.getWGSL("sum", n);
              var r = "";
              return (this || _global)._biases && (r = "@group(0) @binding(5) var<storage, read> biases: array<fT, M * N>;"), "\n            " + ((this || _global)._configuration.dataType === Lt.F16 ? "enable f16;" : "") + "\n\n            const OUT_FEATURES: u32 = " + (this || _global).outFeatures + ";\n            const OUT_WIDTH: u32 = " + (this || _global)._outputShape[1] + ";\n            const OUT_HEIGHT: u32 = " + (this || _global)._outputShape[0] + ";\n            const IN_WIDTH: u32 = " + (this || _global)._inputShape[1] + ";\n            const IN_HEIGHT: u32 = " + (this || _global)._inputShape[0] + ";\n            const IN_FEATURES: u32 = " + (this || _global).inFeatures + ";\n            const IN_PADDING: u32 = " + (this || _global).inPadding + ";\n            const KERNEL_SIZE: u32 = " + (this || _global).kernelSize + ";\n            const GROUP_SIDE: u32 = 16;\n            const GROUP_THREADS: u32 = GROUP_SIDE * GROUP_SIDE;\n            \n            alias fT = " + (this || _global)._configuration.dataType + ";\n            @group(0) @binding(0) var outputTexture: texture_storage_2d<" + (this || _global)._storageFormat + ", write>;\n            @group(0) @binding(1) var<storage, read> inputBuffer: array<fT, (IN_HEIGHT + IN_PADDING * 2) * (IN_WIDTH + IN_PADDING * 2) * IN_FEATURES>;\n            @group(0) @binding(2) var<storage, read> weightsBuffer: array<fT, OUT_FEATURES * IN_FEATURES * KERNEL_SIZE * KERNEL_SIZE>;\n            @group(0) @binding(3) var lrTexture: " + t + ";\n            @group(0) @binding(4) var inputSampler: sampler;\n            " + r + "\n            const Y_COEF = vec3<fT>(0.299, 0.587, 0.114);\n            fn rgbToYuv(x: vec3<f32>) -> vec3<f32> {\n                let y = dot(x, vec3<f32>(Y_COEF));\n                return vec3<f32>(\n                    y, 0.493*(x.b-y), 0.877*(x.r-y)\n                );\n            }\n\n            fn yuvToRgb(x: vec3<f32>) -> vec3<f32> {\n                return vec3<f32>(\n                    x.x + 1.0 / 0.877 * x.z,\n                    x.x - 0.39393 * x.y - 0.58081 * x.z,\n                    x.x + 1.0 / 0.493 * x.y\n                );\n            }\n\n            @compute @workgroup_size(GROUP_THREADS,1,1) \n            fn main(@builtin(global_invocation_id) global_id: vec3<u32>,\n                    @builtin(local_invocation_index) tid: u32,\n                    @builtin(workgroup_id) group_id: vec3<u32>) {\n                let cRow = group_id.y * GROUP_SIDE + tid / GROUP_SIDE;\n                let cCol = group_id.x * GROUP_SIDE + (tid % GROUP_SIDE);\n\n                // TODO: Optimize. First, load these into workgroup memory.\n                // assuming symmetric odd-numbered kernel size\n                var inputs: array<fT, KERNEL_SIZE * KERNEL_SIZE * IN_FEATURES>;\n                let off: u32 = (KERNEL_SIZE-1)/2;\n            \n                for (var m: u32 = 0; m < KERNEL_SIZE; m++) {\n                    for (var n: u32 = 0; n < KERNEL_SIZE; n++) {\n                        for (var c: u32 = 0; c < IN_FEATURES; c++) {\n                            let in_idx = (cRow + n - off + IN_PADDING) * (IN_WIDTH + IN_PADDING * 2) * IN_FEATURES + (cCol + m - off + IN_PADDING) * IN_FEATURES + c;\n                            inputs[n * KERNEL_SIZE * IN_FEATURES + m * IN_FEATURES + c] = inputBuffer[in_idx];\n                        }\n                    }\n                }\n\n                // Should probably change the order of these loops to better map to channel ordering\n                // Also move weights loading into workgroup memory...\n                var color = vec4<f32>(0.0, 0.0, 0.0, 1.0);\n                for (var z: u32 = 0; z < OUT_FEATURES; z++) {\n                    var weights_off = z * IN_FEATURES * KERNEL_SIZE * KERNEL_SIZE;\n                    var sum: fT = 0.0;\n                    for (var j: u32 = 0; j < IN_FEATURES; j++) {\n                        var weights: array<fT, KERNEL_SIZE * KERNEL_SIZE>;\n                        for (var m: u32 = 0; m < KERNEL_SIZE; m++) {\n                            for (var n: u32 = 0; n < KERNEL_SIZE; n++) {\n                                weights[m * KERNEL_SIZE + n] = weightsBuffer[weights_off];\n                                weights_off ++ ;\n                            }\n                        }\n                        {\n                            {\n                                sum += inputs[0 * KERNEL_SIZE * IN_FEATURES + 0 * IN_FEATURES + j] * weights[0 * KERNEL_SIZE + 0];\n                                sum += inputs[0 * KERNEL_SIZE * IN_FEATURES + 1 * IN_FEATURES + j] * weights[0 * KERNEL_SIZE + 1];\n                                sum += inputs[0 * KERNEL_SIZE * IN_FEATURES + 2 * IN_FEATURES + j] * weights[0 * KERNEL_SIZE + 2];\n                            }\n                            {\n                                sum += inputs[1 * KERNEL_SIZE * IN_FEATURES + 0 * IN_FEATURES + j] * weights[1 * KERNEL_SIZE + 0];\n                                sum += inputs[1 * KERNEL_SIZE * IN_FEATURES + 1 * IN_FEATURES + j] * weights[1 * KERNEL_SIZE + 1];\n                                sum += inputs[1 * KERNEL_SIZE * IN_FEATURES + 2 * IN_FEATURES + j] * weights[1 * KERNEL_SIZE + 2];\n                            }\n                            {\n                                sum += inputs[2 * KERNEL_SIZE * IN_FEATURES + 0 * IN_FEATURES + j] * weights[2 * KERNEL_SIZE + 0];\n                                sum += inputs[2 * KERNEL_SIZE * IN_FEATURES + 1 * IN_FEATURES + j] * weights[2 * KERNEL_SIZE + 1];\n                                sum += inputs[2 * KERNEL_SIZE * IN_FEATURES + 2 * IN_FEATURES + j] * weights[2 * KERNEL_SIZE + 2];\n                            }\n                        }\n                    }\n                    color[z] = clamp(f32(sum), 0.0627, 1.0-0.0627);\n                }\n\n                let texSize = vec2<f32>(f32(OUT_WIDTH), f32(OUT_HEIGHT));\n                let texelSize = 1.0 / texSize;\n                let inPos = vec2<f32>(f32(cCol+1), f32(cRow)) * texelSize;\n                let lr = rgbToYuv(textureSampleBaseClampToEdge(lrTexture, inputSampler, inPos).rgb * 0.8627 + 0.0627);\n                let mixval: f32 = f32(cCol > 3) * f32(cRow > 3) * f32(cCol < OUT_WIDTH - 3) * f32(cRow < OUT_HEIGHT - 3);\n                color.x = mix(lr.x, color.x, mixval);\n                color = vec4((yuvToRgb(vec3<f32>(color.x, lr.y, lr.z)) * 1.1591) - 0.0627, 1.0);\n                textureStore(outputTexture, vec2<u32>(cCol, cRow), color);\n            };\n        ";
            }, e;
          }(),
          Ot = function () {
            function e(e) {
              (this || _global).a = e;
            }
            var t = e.prototype;
            return t.activationsPerFeature = function () {
              return 1;
            }, t.getWGSL = function (e) {
              return (this || _global).a + " * " + e + " + (1 - " + (this || _global).a + ") * max(0, " + e + ")";
            }, e;
          }(),
          Ut = {
            "init_feat.0": {
              weight: {
                offset: 0,
                bits: 16,
                count: 144
              }
            },
            "bottleneck.0": {
              weight: {
                offset: 288,
                bits: 16,
                count: 1152
              }
            },
            "bottleneck.2": {
              weight: {
                offset: 2592,
                bits: 16,
                count: 576
              }
            },
            "bottleneck.4": {
              weight: {
                offset: 3744,
                bits: 16,
                count: 576
              }
            },
            "bottleneck.6": {
              weight: {
                offset: 4896,
                bits: 16,
                count: 576
              }
            },
            reconstruct: {
              weight: {
                offset: 6048,
                bits: 16,
                count: 72
              }
            }
          },
          Ft = function () {
            try {
              for (var e = atob("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"), t = new Uint8Array(e.length), n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
              return {
                buffer: t.buffer
              };
            } catch (e) {
              return {
                err: new mt("Model", gt.ModelInitFailed, "Failed to read weights binary string: " + ((null == e ? void 0 : e.message) || "unknown"), !0)
              };
            }
          };
        function Ht(e, t) {
          var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (n) return (n = n.call(e)).next.bind(n);
          if (Array.isArray(e) || (n = function (e, t) {
            if (e) {
              if ("string" == typeof e) return Vt(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Vt(e, t) : void 0;
            }
          }(e)) || t && e && "number" == typeof e.length) {
            n && (e = n);
            var r = 0;
            return function () {
              return r >= e.length ? {
                done: !0
              } : {
                done: !1,
                value: e[r++]
              };
            };
          }
          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }
        function Vt(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        var Gt = function () {
            function e(e, t, n) {
              (this || _global).config = e, (this || _global).gpuContext = t, (this || _global).onError = n, (this || _global).entry = void 0, (this || _global).exit = void 0, (this || _global).hidden = [], (this || _global).timingInfoEntry = void 0, (this || _global).timingInfoExit = void 0, (this || _global).timingQueryEntry = void 0, (this || _global).timingQueryExit = void 0, (this || _global).weightsMap = void 0, (this || _global).weightsBinary = void 0, (this || _global).width = 0, (this || _global).height = 0, (this || _global).frameNum = 0, (this || _global).initialized = !1, (this || _global).initializing = !1, (this || _global).MIN_AREA = void 0, (this || _global).MAX_AREA = void 0, (this || _global).SCALE_FACTOR = void 0, (this || _global).MIN_AREA = (this || _global).config.inputResolutionAreaBand[0], (this || _global).MAX_AREA = (this || _global).config.inputResolutionAreaBand[1], (this || _global).SCALE_FACTOR = (this || _global).config.scaleFactor, y.info("[ModelIVSEN]: Config", (this || _global).config);
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e() {
                var t, n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (y.info("[ModelIVSEN]: Initializing"), (this || _global).initialized = !1, (this || _global).initializing = !1, (this || _global).entry = void 0, (this || _global).exit = void 0, (this || _global).width = 0, (this || _global).height = 0, (this || _global).frameNum = 0, e.prev = 8, (this || _global).weightsMap = Ut, t = Ft(), n = t.buffer, !(r = t.err)) {
                        e.next = 14;
                        break;
                      }
                      return y.error("Model init failed", r), e.abrupt("return", r);
                    case 14:
                      (this || _global).weightsBinary = n, e.next = 21;
                      break;
                    case 17:
                      return e.prev = 17, e.t0 = e.catch(8), y.error("Model init failed", e.t0), e.abrupt("return", new mt("Model", gt.ModelInitFailed, "Failed to init the model: " + ((null == e.t0 ? void 0 : e.t0.message) || "unknown"), !0));
                    case 21:
                      return y.info("[ModelIVSEN]: Init complete"), e.abrupt("return", void 0);
                    case 23:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[8, 17]]);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.infer = function () {
              var e = f()(v().mark(function e(t) {
                var n,
                  r,
                  i,
                  o,
                  a,
                  s,
                  u,
                  c,
                  d,
                  l,
                  f,
                  h,
                  p,
                  m,
                  g,
                  E,
                  T,
                  S,
                  _,
                  b,
                  C = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!(this || _global).initializing) {
                        e.next = 2;
                        break;
                      }
                      return e.abrupt("return", void 0);
                    case 2:
                      if (n = t instanceof VideoFrame ? t.displayWidth : t.width, r = t instanceof VideoFrame ? t.displayHeight : t.height, !((i = n * r) < (this || _global).MIN_AREA || i > (this || _global).MAX_AREA)) {
                        e.next = 9;
                        break;
                      }
                      return (this || _global).initialized = !1, (this || _global).initializing = !1, e.abrupt("return");
                    case 9:
                      if (n === (this || _global).width && r === (this || _global).height || ((this || _global).initialized = !1), (this || _global).initialized) {
                        e.next = 14;
                        break;
                      }
                      return e.next = 13, this.reinit(n, r);
                    case 13:
                      return e.abrupt("return", void 0);
                    case 14:
                      for (performance.now(), (this || _global).gpuContext.device.pushErrorScope("validation"), o = (this || _global).gpuContext.device.createCommandEncoder(), (this || _global).entry && ((this || _global).entry.setInputs(t), (this || _global).entry.createFinalizedPass((this || _global).gpuContext, o, (this || _global).timingQueryEntry), (this || _global).timingInfoEntry && (this || _global).timingQueryEntry && o.resolveQuerySet((this || _global).timingQueryEntry, 0, 2, (this || _global).timingInfoEntry.deviceBuffer, 0)), a = Ht((this || _global).hidden); !(s = a()).done;) (u = s.value).layer && u.layer.createFinalizedPass((this || _global).gpuContext, o, u.timingQuery), u.timingQuery && u.timingInfo && o.resolveQuerySet(u.timingQuery, 0, 2, u.timingInfo.deviceBuffer, 0);
                      return (this || _global).exit && ((this || _global).exit.setLowResTexture(t), (this || _global).exit.createFinalizedPass((this || _global).gpuContext, o, (this || _global).timingQueryExit), (this || _global).timingInfoExit && (this || _global).timingQueryExit && o.resolveQuerySet((this || _global).timingQueryExit, 0, 2, (this || _global).timingInfoExit.deviceBuffer, 0)), (this || _global).gpuContext.queue.submit([o.finish()]), (this || _global).frameNum++, (this || _global).frameNum, e.next = 25, (this || _global).gpuContext.queue.onSubmittedWorkDone();
                    case 25:
                      if (!(this || _global).timingInfoEntry) {
                        e.next = 35;
                        break;
                      }
                      return e.next = 28, (this || _global).timingInfoEntry.copyToHost((this || _global).gpuContext.device);
                    case 28:
                      if (c = e.sent, d = c.err, l = c.buffer, !d) {
                        e.next = 34;
                        break;
                      }
                      return this.onError(d), e.abrupt("return");
                    case 34:
                      y.debug("[ModelIVSEN]: entry timing=" + Bt(l));
                    case 35:
                      f = Ht((this || _global).hidden);
                    case 36:
                      if ((h = f()).done) {
                        e.next = 50;
                        break;
                      }
                      if (!(p = h.value).timingInfo) {
                        e.next = 48;
                        break;
                      }
                      return e.next = 41, p.timingInfo.copyToHost((this || _global).gpuContext.device);
                    case 41:
                      if (m = e.sent, g = m.err, E = m.buffer, !g) {
                        e.next = 47;
                        break;
                      }
                      return this.onError(g), e.abrupt("return");
                    case 47:
                      y.debug("[ModelIVSEN]: hidden[" + p.idx + "] timing=" + Bt(E));
                    case 48:
                      e.next = 36;
                      break;
                    case 50:
                      if (!(this || _global).timingInfoExit) {
                        e.next = 60;
                        break;
                      }
                      return e.next = 53, (this || _global).timingInfoExit.copyToHost((this || _global).gpuContext.device);
                    case 53:
                      if (T = e.sent, S = T.err, _ = T.buffer, !S) {
                        e.next = 59;
                        break;
                      }
                      return this.onError(S), e.abrupt("return");
                    case 59:
                      y.debug("[ModelIVSEN]: exit timing=" + Bt(_));
                    case 60:
                      if ((this || _global).gpuContext.device.popErrorScope().then(function (e) {
                        var t;
                        e && C.onError(new mt("ModelIVSEN", gt.InferenceFailed, null != (t = null == e ? void 0 : e.message) ? t : "Unknown error", !0));
                      }).catch(function (e) {
                        var t;
                        C.onError(new mt("ModelIVSEN", gt.InferenceFailed, null != (t = null == e ? void 0 : e.message) ? t : "Unknown error", !0));
                      }), (this || _global).exit) {
                        e.next = 64;
                        break;
                      }
                      return y.warn(["ModelIVSEN: Exit layer does not exist, cant return texture"]), e.abrupt("return", void 0);
                    case 64:
                      return e.next = 66, (this || _global).exit.getOutputs();
                    case 66:
                      if ((b = e.sent) instanceof Dt) {
                        e.next = 71;
                        break;
                      }
                      return (this || _global).initialized = !1, y.warn(["ModelIVSEN: Exit layer did not return a texture"]), e.abrupt("return", void 0);
                    case 71:
                      return e.abrupt("return", b.deviceTexture);
                    case 72:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t.reinit = function () {
              var e = f()(v().mark(function e(t, n) {
                var r, i, o, a, s, u, c, d, l, f, h, p, m, g, y, E, T;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (r = (this || _global).weightsBinary, i = (this || _global).weightsMap, r && i) {
                        e.next = 4;
                        break;
                      }
                      return e.abrupt("return", new mt("Model", gt.ModelInitFailed, "Model was not initialized before infer was called", !0));
                    case 4:
                      return (this || _global).initializing = !0, this.cleanup(), e.next = 8, this.configureEntrypoint(t, n, (this || _global).SCALE_FACTOR, 1, 16, r, i);
                    case 8:
                      if (o = e.sent, a = o.err, s = o.entry, !a && s) {
                        e.next = 14;
                        break;
                      }
                      return this.handleError(a || new mt("Model", gt.PipelineCreationFailed, "Failed to create entry layer", !0)), e.abrupt("return");
                    case 14:
                      (this || _global).entry = s, (this || _global).hidden = [], u = 0;
                    case 17:
                      if (!(u < 4)) {
                        e.next = 42;
                        break;
                      }
                      if (c = void 0, d = 8, 0 !== u) {
                        e.next = 27;
                        break;
                      }
                      return e.next = 23, (this || _global).entry.getOutputs();
                    case 23:
                      c = e.sent, d = 16, e.next = 30;
                      break;
                    case 27:
                      return e.next = 29, (this || _global).hidden[u - 1].layer.getOutputs();
                    case 29:
                      c = e.sent;
                    case 30:
                      return e.next = 32, this.configureMid(Math.ceil(t * (this || _global).SCALE_FACTOR), Math.ceil(n * (this || _global).SCALE_FACTOR), d, 8, r, i, c, 2 * u);
                    case 32:
                      if (l = e.sent, f = l.err, h = l.layer) {
                        e.next = 38;
                        break;
                      }
                      return this.handleError(f || new mt("Model", gt.PipelineCreationFailed, "Failed to create midlayer", !0)), e.abrupt("return");
                    case 38:
                      (this || _global).hidden.push({
                        layer: h,
                        timingInfo: null,
                        timingQuery: null,
                        idx: u
                      });
                    case 39:
                      u++, e.next = 17;
                      break;
                    case 42:
                      return e.next = 44, this.configureExit(Math.ceil(t * (this || _global).SCALE_FACTOR), Math.ceil(n * (this || _global).SCALE_FACTOR), 8, 1, r, i);
                    case 44:
                      if (p = e.sent, m = p.err, g = p.exit, !m && g) {
                        e.next = 50;
                        break;
                      }
                      return this.handleError(m || new mt("Model", gt.PipelineCreationFailed, "Failed to create exit layer", !0)), e.abrupt("return");
                    case 50:
                      if ((this || _global).exit = g, (this || _global).gpuContext.timingInfoEnabled) {
                        for ((this || _global).timingInfoEntry = new At((this || _global).gpuContext, 16, Pt.TimingQuery), y = Ht((this || _global).hidden); !(E = y()).done;) (T = E.value).timingInfo = new At((this || _global).gpuContext, 16, Pt.TimingQuery), T.timingQuery = (this || _global).gpuContext.device.createQuerySet({
                          type: "timestamp",
                          count: 2
                        });
                        (this || _global).timingInfoExit = new At((this || _global).gpuContext, 16, Pt.TimingQuery), (this || _global).timingQueryEntry = (this || _global).gpuContext.device.createQuerySet({
                          type: "timestamp",
                          count: 2
                        }), (this || _global).timingQueryExit = (this || _global).gpuContext.device.createQuerySet({
                          type: "timestamp",
                          count: 2
                        });
                      }
                      (this || _global).width = t, (this || _global).height = n, (this || _global).initializing = !1, (this || _global).initialized = !0;
                    case 56:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n) {
                return e.apply(this || _global, arguments);
              };
            }(), t.cleanup = function () {
              var e, t, n, r;
              null == (e = (this || _global).exit) || e.close();
              for (var i, o = Ht((this || _global).hidden); !(i = o()).done;) i.value.layer.close();
              null == (t = (this || _global).entry) || t.close(), null == (n = (this || _global).timingInfoEntry) || n.close(), null == (r = (this || _global).timingInfoExit) || r.close();
            }, t.configureEntrypoint = function () {
              var e = f()(v().mark(function e(t, n, r, i, o, a, s) {
                var u, c, d, l, f, h, p;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return u = new Rt(i, o, 3, r, 1, !0, !1), c = s["init_feat.0"].weight, d = c.bits / 8, l = a.slice(c.offset, c.offset + c.count * d), f = {
                        inputShape: [n, t, i],
                        weightShape: [3, 3, o * i],
                        bias: !1,
                        dataType: 4 === d ? Lt.F32 : Lt.F16,
                        expectedInputType: It.External,
                        activation: new Ot(0.1)
                      }, h = new At((this || _global).gpuContext, 9 * i * o * d, Pt.HostToDevice), e.next = 8, h.copyToDevice((this || _global).gpuContext, l);
                    case 8:
                      return u.setWeights(h), e.next = 11, u.configure((this || _global).gpuContext, f);
                    case 11:
                      if (!(p = e.sent)) {
                        e.next = 14;
                        break;
                      }
                      return e.abrupt("return", {
                        err: p
                      });
                    case 14:
                      return e.abrupt("return", {
                        entry: u
                      });
                    case 15:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r, i, o, a, s) {
                return e.apply(this || _global, arguments);
              };
            }(), t.configureMid = function () {
              var e = f()(v().mark(function e(t, n, r, i, o, a, s, u) {
                var c, d, l, f, h, p, m;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return c = a["bottleneck." + u].weight, d = c.bits / 8, l = o.slice(c.offset, c.offset + c.count * d), f = 4 === d ? new xt(r, i, !1) : new Mt(r, i, !1), h = {
                        inputShape: [n, t, r],
                        weightShape: [3, 3, i * r],
                        bias: !1,
                        dataType: 4 === d ? Lt.F32 : Lt.F16,
                        expectedInputType: It.Buffer,
                        activation: new Ot(0.1)
                      }, p = new At((this || _global).gpuContext, 9 * r * i * d, Pt.HostToDevice), e.next = 8, p.copyToDevice((this || _global).gpuContext, l);
                    case 8:
                      return f.setInputs(s), f.setWeights(p), e.next = 12, f.configure((this || _global).gpuContext, h);
                    case 12:
                      if (!(m = e.sent)) {
                        e.next = 15;
                        break;
                      }
                      return e.abrupt("return", {
                        err: m
                      });
                    case 15:
                      return e.abrupt("return", {
                        layer: f
                      });
                    case 16:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r, i, o, a, s, u) {
                return e.apply(this || _global, arguments);
              };
            }(), t.configureExit = function () {
              var e = f()(v().mark(function e(t, n, r, i, o, a) {
                var s,
                  u,
                  c,
                  d,
                  l,
                  f,
                  h,
                  p = this || _global;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return s = new Nt(r, i, 3, 1, !1), u = a.reconstruct.weight, c = u.bits / 8, d = o.slice(u.offset, u.offset + u.count * c), l = {
                        inputShape: [n, t, r],
                        weightShape: [3, 3, i * r],
                        bias: !1,
                        dataType: 4 === c ? Lt.F32 : Lt.F16,
                        expectedInputType: It.External,
                        activation: new Ot(0.1)
                      }, f = new At((this || _global).gpuContext, 9 * r * i * c, Pt.HostToDevice), e.next = 8, f.copyToDevice((this || _global).gpuContext, d);
                    case 8:
                      return (this || _global).hidden[(this || _global).hidden.length - 1].layer.getOutputs().then(function (e) {
                        return s.setInputs(e);
                      }).catch(function (e) {
                        var t;
                        p.onError(new mt("Model", gt.BadParameters, null != (t = null == e ? void 0 : e.message) ? t : "Failed to access hidden layer", !0));
                      }), s.setWeights(f), e.next = 12, s.configure((this || _global).gpuContext, l);
                    case 12:
                      if (!(h = e.sent)) {
                        e.next = 15;
                        break;
                      }
                      return e.abrupt("return", {
                        err: h
                      });
                    case 15:
                      return e.abrupt("return", {
                        exit: s
                      });
                    case 16:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function (t, n, r, i, o, a) {
                return e.apply(this || _global, arguments);
              };
            }(), t.handleError = function (e) {
              (this || _global).initializing = !1, (this || _global).initialized = !1, this.onError(e);
            }, e;
          }(),
          Bt = function (e) {
            if (!e) return y.warn("[ModelIVSEN]: timingInfo buffer is undefined"), 0;
            var t = 0;
            try {
              var n = new BigInt64Array(e);
              t = Number(n[1] - n[0]) / 1000000000;
            } catch (e) {
              y.warn("[ModelIVSEN': Failed to get seconds from timingInfo");
            }
            return t;
          },
          Wt = function (e) {
            function t(t, n, r) {
              var i;
              return (i = e.call(this || _global, "SuperResolutionTransformer") || this || _global).onError = r, i.model = void 0, i.model = new Gt(t, n, r), i;
            }
            re()(t, e);
            var n = t.prototype;
            return n.init = function () {
              var e = f()(v().mark(function e() {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (this || _global).model.init();
                    case 2:
                      return e.abrupt("return", e.sent);
                    case 3:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), n.transformFn = function () {
              var e = f()(v().mark(function e(t) {
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.prev = 0, e.next = 3, (this || _global).model.infer(t);
                    case 3:
                      return e.abrupt("return", e.sent);
                    case 6:
                      return e.prev = 6, e.t0 = e.catch(0), this.onError(new mt("SuperResolutionTransformer", gt.InferenceFailed, "Unhandled exception " + (null == e.t0 ? void 0 : e.t0.message), !0)), e.abrupt("return", void 0);
                    case 10:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[0, 6]]);
              }));
              return function (t) {
                return e.apply(this || _global, arguments);
              };
            }(), t;
          }(bt),
          jt = function () {
            function e(e, t, n) {
              (this || _global).windowContext = e, (this || _global).listeners = n, (this || _global).canvas = void 0, (this || _global).sourceVideo = void 0, (this || _global).pipeline = void 0, (this || _global).frameStream = void 0, (this || _global).gpuContext = void 0, (this || _global).performanceMonitor = void 0, (this || _global).config = void 0, (this || _global).config = dt({
                pipeline: {
                  minimumFramerate: 60,
                  includeReceiveDelay: !0
                },
                capture: {
                  maxQueueSize: 2
                },
                monitor: {
                  enable: !0,
                  monitorIntervalMs: 5000,
                  frameRateDiffPercentage: 0.25,
                  frameCountDiffPercentage: 0.25
                },
                model: {
                  enable: !1,
                  inputResolutionAreaBand: [0, 921600],
                  scaleFactor: 1.5
                }
              }, t), y.info("[VideoTransformer]: Parsed config", (this || _global).config), (this || _global).canvas = e.document.createElement("canvas");
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e() {
                var t, n, r, i, o, a, s, u, c, d, l, f, h;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return t = performance.now(), y.log("[VideoTransformer]: Init start"), n = (this || _global).onErrorInternal.bind(this || _global), e.prev = 3, r = (this || _global).gpuContext = new St((this || _global).windowContext, {
                        timingInfoEnabled: !1
                      }), e.next = 7, r.init();
                    case 7:
                      if (!(i = e.sent)) {
                        e.next = 10;
                        break;
                      }
                      return e.abrupt("return", {
                        err: i
                      });
                    case 10:
                      return o = new _t((this || _global).canvas, r, n), e.next = 13, o.init();
                    case 13:
                      if (!(a = e.sent)) {
                        e.next = 16;
                        break;
                      }
                      return e.abrupt("return", {
                        err: a
                      });
                    case 16:
                      if (s = new Tt((this || _global).config.capture, n), !(u = s.init())) {
                        e.next = 20;
                        break;
                      }
                      return e.abrupt("return", {
                        err: u
                      });
                    case 20:
                      if (c = new Et(s.getStream(), o, n, (this || _global).config.pipeline), !(this || _global).config.model.enable) {
                        e.next = 31;
                        break;
                      }
                      return l = new Wt((this || _global).config.model, r, n), e.next = 25, l.init();
                    case 25:
                      if (!(f = e.sent)) {
                        e.next = 28;
                        break;
                      }
                      return e.abrupt("return", {
                        err: f
                      });
                    case 28:
                      d = l, e.next = 32;
                      break;
                    case 31:
                      d = new Ct();
                    case 32:
                      return e.next = 34, c.init(d);
                    case 34:
                      if (!(h = e.sent)) {
                        e.next = 37;
                        break;
                      }
                      return e.abrupt("return", {
                        err: h
                      });
                    case 37:
                      return (this || _global).performanceMonitor = new kt((this || _global).config.monitor, (this || _global).stats.bind(this || _global), {
                        performanceBreach: (this || _global).onPerformanceBreach.bind(this || _global)
                      }), (this || _global).frameStream = s, (this || _global).pipeline = c, y.log("[VideoTransformer]: Init complete in " + (performance.now() - t).toFixed(3) + "ms"), e.abrupt("return", {
                        info: {
                          timeMs: performance.now() - t,
                          gpuProperties: r.properties()
                        }
                      });
                    case 44:
                      return e.prev = 44, e.t0 = e.catch(3), y.warn("[VideoTransformer]: Failed to init", e.t0), e.abrupt("return", {
                        err: new mt("VideoTransformer", gt.Init, e.t0.message, !0)
                      });
                    case 48:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[3, 44]]);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.start = function (e) {
              var t, n;
              this.ready() ? this.active() ? y.warn("[VideoTransformer]: Start called on active instance") : ((this || _global).sourceVideo = e, null == (t = (this || _global).frameStream) || t.start(e), null == (n = (this || _global).performanceMonitor) || n.start(), y.log("[VideoTransformer]: Pipeline started")) : y.log("[VideoTransformer]: Start called before init");
            }, t.stop = function () {
              var e, t;
              y.log("[VideoTransformer]: Stopping render pipeline"), null == (e = (this || _global).frameStream) || e.stop(), null == (t = (this || _global).performanceMonitor) || t.stop();
            }, t.active = function () {
              var e, t;
              return null != (e = null == (t = (this || _global).frameStream) ? void 0 : t.active) && e;
            }, t.stats = function () {
              var e, t, n, r, i, o;
              if (!(this || _global).pipeline || !(this || _global).frameStream) return {
                timestamp: performance.now(),
                frames: {
                  source: 0,
                  source_presented: 0,
                  captured: 0,
                  received: 0,
                  transformed: 0,
                  rendered: 0,
                  missed: 0,
                  blocked: 0,
                  skipped: 0,
                  failed: 0,
                  overBudget: 0
                },
                timings: {
                  captureDelay: 0,
                  receiveDelay: 0,
                  transformTime: 0,
                  renderTime: 0,
                  endToEnd: 0
                },
                resolution: {
                  sourceHeight: 0,
                  sourceWidth: 0,
                  renderHeight: 0,
                  renderWidth: 0
                }
              };
              var a = (this || _global).pipeline.stats(),
                s = a.received,
                u = a.transformTime,
                c = a.skipped,
                d = a.transformed,
                l = a.failed,
                f = a.overBudget,
                h = a.rendered,
                v = a.renderTime,
                p = a.receiveDelay,
                m = a.endToEnd,
                g = (this || _global).frameStream.stats(),
                y = g.captured,
                E = g.blocked,
                T = g.missed,
                S = g.rVFCDelay,
                _ = null != (e = null == (t = (this || _global).sourceVideo) ? void 0 : t.getVideoPlaybackQuality()) ? e : {
                  totalVideoFrames: 0,
                  droppedVideoFrames: 0
                },
                b = _.totalVideoFrames,
                C = _.droppedVideoFrames;
              return {
                timestamp: performance.now(),
                frames: {
                  source: b,
                  source_presented: b - C,
                  captured: y,
                  received: s,
                  transformed: d,
                  rendered: h,
                  missed: T,
                  blocked: E,
                  skipped: c,
                  failed: l,
                  overBudget: f
                },
                timings: {
                  captureDelay: S,
                  receiveDelay: p,
                  transformTime: u,
                  renderTime: v,
                  endToEnd: m
                },
                resolution: {
                  sourceHeight: null != (n = null == (r = (this || _global).sourceVideo) ? void 0 : r.videoHeight) ? n : 0,
                  sourceWidth: null != (i = null == (o = (this || _global).sourceVideo) ? void 0 : o.videoWidth) ? i : 0,
                  renderHeight: (this || _global).canvas.height,
                  renderWidth: (this || _global).canvas.width
                }
              };
            }, t.renderSurface = function () {
              return (this || _global).canvas;
            }, t.gpuProperties = function () {
              var e;
              return null == (e = (this || _global).gpuContext) ? void 0 : e.properties();
            }, t.reset = function () {
              var e, t, n;
              y.info("[VideoTransformer]: Resetting instance"), null == (e = (this || _global).frameStream) || e.resetStats(), null == (t = (this || _global).pipeline) || t.resetStats(), null != (n = (this || _global).performanceMonitor) && n.monitoring() && ((this || _global).performanceMonitor.stop(), (this || _global).performanceMonitor.start());
            }, t.destroy = function () {
              y.info("[VideoTransformer]: Destroying instance"), this.stop(), (this || _global).gpuContext = void 0, (this || _global).frameStream = void 0, (this || _global).pipeline = void 0, (this || _global).performanceMonitor = void 0;
            }, t.ready = function () {
              return !!((this || _global).frameStream && (this || _global).pipeline && (this || _global).performanceMonitor && (this || _global).gpuContext);
            }, t.onPerformanceBreach = function (e) {
              this.onErrorInternal(new mt("PerformanceMonitor", e.code, e.reason, e.fatal));
            }, t.onErrorInternal = function (e) {
              this.stop(), this.reset(), (this || _global).listeners.error(e);
            }, e;
          }(),
          Kt = function (e) {
            return e.setAttribute("playsinline", ""), {
              element: function () {
                return e;
              },
              displayDimensions: function () {
                return {
                  width: e.clientWidth,
                  height: e.clientHeight
                };
              },
              videoDimensions: function () {
                return {
                  width: e.videoWidth,
                  height: e.videoHeight
                };
              },
              stats: function () {
                return {
                  timestamp: performance.now(),
                  droppedFrames: (0, ue.ld)(e),
                  decodedFrames: (0, ue.xB)(e)
                };
              },
              visible: function () {
                return (0, Ue.j)(e);
              }
            };
          },
          zt = ["nvidia"],
          qt = ["ampere", "lovelace"],
          Qt = function () {
            function e(e, t) {
              var n;
              (this || _global).initialConfig = e, (this || _global).listeners = t, (this || _global).videoTransformer = void 0, (this || _global).surface = void 0, (this || _global).statusInterval = void 0, (this || _global).scoutModeTimeout = void 0, (this || _global).config = void 0, (this || _global).disabled = !1, (this || _global).scouted = !1, (this || _global).resumeOnVisible = !1;
              var r = {
                statusIntervalMs: 5000,
                scoutPeriodMs: 5500,
                logLevel: p.$.WARN,
                gpuAllowlist: {
                  vendors: [],
                  architectures: []
                },
                transformer: {}
              };
              (this || _global).config = dt(r, e.module);
              var i = null == (n = (this || _global).config.transformer.monitor) ? void 0 : n.monitorIntervalMs;
              void 0 === e.module.scoutPeriodMs && i && ((this || _global).config.scoutPeriodMs = i + 500), y.setConfig({
                enabled: !0,
                level: (this || _global).config.logLevel
              });
            }
            var t = e.prototype;
            return t.init = function () {
              var e = f()(v().mark(function e() {
                var t, n, r;
                return v().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      if (!(this || _global).videoTransformer) {
                        e.next = 3;
                        break;
                      }
                      return y.debug("[VideoTransformerModule]: Init called on setup instance"), e.abrupt("return", void 0);
                    case 3:
                      if (!(this || _global).disabled) {
                        e.next = 6;
                        break;
                      }
                      return y.warn("[VideoTransformerModule]: Init called, but the module is disabled"), e.abrupt("return", void 0);
                    case 6:
                      return e.prev = 6, t = new jt(window, (this || _global).config.transformer, {
                        error: (this || _global).onTransformerError.bind(this || _global)
                      }), e.next = 10, t.init();
                    case 10:
                      if (!(n = e.sent).err) {
                        e.next = 14;
                        break;
                      }
                      return this.onTransformerError(n.err), e.abrupt("return", void 0);
                    case 14:
                      if ((this || _global).videoTransformer = t, r = this.gpuAllowed(), this.logInitEvent(n, r), r) {
                        e.next = 20;
                        break;
                      }
                      return this.disable(), e.abrupt("return", void 0);
                    case 20:
                      return (this || _global).surface = this.createWebGpuCanvasSurface(t.renderSurface()), e.abrupt("return", (this || _global).surface);
                    case 24:
                      return e.prev = 24, e.t0 = e.catch(6), y.error("[VideoTransformerModule]: Unhandled error encountered during init", e.t0), this.onTransformerError(new mt("VideoTransformerModule", gt.Init, "Unhandled error during init: " + ((null == e.t0 ? void 0 : e.t0.message) || "unknown"), !0)), e.abrupt("return", void 0);
                    case 29:
                    case "end":
                      return e.stop();
                  }
                }, e, this || _global, [[6, 24]]);
              }));
              return function () {
                return e.apply(this || _global, arguments);
              };
            }(), t.start = function (e) {
              if ((this || _global).disabled) y.log("[VideoTransformerModule]: Video transformer not starting: module is disabled");else if ((this || _global).videoTransformer) {
                if ((this || _global).videoTransformer.active()) y.log("[VideoTransformerModule]: Start called, but transformer is already active");else {
                  if (Xt()) return y.log("[VideoTransformerModule]: Start called, but page is hidden. Resuming on visible"), void ((this || _global).resumeOnVisible = !0);
                  y.log("[VideoTransformerModule]: Starting"), (this || _global).videoTransformer.start(e), (this || _global).videoTransformer.active() ? (this.startLogStatusEvents((this || _global).config.statusIntervalMs), this.scout((this || _global).config.scoutPeriodMs)) : (y.log("[VideoTransformerModule]: Failed to start"), this.onTransformerError(new mt("VideoTransformerModule", gt.BadParameters, "Transformer failed to start", !0)));
                }
              } else y.log("[VideoTransformerModule]: Video transformer not starting: start called before transformer init");
            }, t.stats = function () {
              var e,
                t,
                n = 0,
                r = 0,
                i = performance.now(),
                o = null == (e = (this || _global).videoTransformer) ? void 0 : e.stats().frames;
              return o ? (n = null != (t = o.rendered) ? t : 0, {
                timestamp: i,
                droppedFrames: r = o.missed + o.skipped + o.failed,
                decodedFrames: n
              }) : {
                timestamp: i,
                decodedFrames: n,
                droppedFrames: r
              };
            }, t.swapVideoSource = function (e) {
              var t;
              null != (t = (this || _global).videoTransformer) && t.active() && ((this || _global).videoTransformer.stop(), (this || _global).videoTransformer.start(e));
            }, t.stop = function () {
              var e;
              null == (e = (this || _global).videoTransformer) || e.stop(), (this || _global).resumeOnVisible = !1, clearInterval((this || _global).statusInterval), clearInterval((this || _global).scoutModeTimeout);
            }, t.reset = function () {
              var e;
              null == (e = (this || _global).videoTransformer) || e.reset();
            }, t.destroy = function () {
              this.stop(), (this || _global).videoTransformer = void 0, (this || _global).listeners.inactive();
            }, t.disable = function () {
              (this || _global).disabled = !0, this.destroy();
            }, t.onPageVisibilityChanged = function (e, t) {
              if (e) {
                var n,
                  r,
                  i = null != (n = null == (r = (this || _global).videoTransformer) ? void 0 : r.active()) && n;
                this.stop(), y.log("[VideoTransformerModule]: Page hidden. Was active: " + i), (this || _global).resumeOnVisible = i;
              } else y.log("[VideoTransformerModule]: Page visible, resumeOnVisible: " + (this || _global).resumeOnVisible), (this || _global).resumeOnVisible && this.start(t), (this || _global).resumeOnVisible = !1;
            }, t.scout = function (e) {
              var t = this || _global;
              window.clearTimeout((this || _global).scoutModeTimeout), (this || _global).scouted ? y.log("[VideoTransformerModule]: Already scouted") : (y.log("[VideoTransformerModule]: Starting " + e + "ms scout mode before ready"), (this || _global).scoutModeTimeout = window.setTimeout(function () {
                var e;
                t.scouted = !0, null != (e = t.videoTransformer) && e.active() ? (y.log("[VideoTransformerModule]: Scout mode complete"), t.listeners.active()) : y.log("[VideoTransformerModule]: Scout mode complete, but video transformer is no longer active");
              }, e));
            }, t.gpuAllowed = function () {
              var e,
                t = null == (e = (this || _global).videoTransformer) ? void 0 : e.gpuProperties();
              if (!t) return y.info("[VideoTransformerModule]: GPU not allowed: gpu properties not found"), !1;
              var n,
                r,
                i,
                o,
                a,
                s = (n = (this || _global).config.gpuAllowlist, o = [].concat(zt, null != (r = null == n ? void 0 : n.vendors) ? r : []), a = [].concat(qt, null != (i = null == n ? void 0 : n.architectures) ? i : []), {
                  allowed: function (e) {
                    var t = {
                      allowed: !0,
                      reason: ""
                    };
                    return o.includes(e.vendor) || o.includes("*") || (t = {
                      allowed: !1,
                      reason: "GPU Vendor not allowed. Have: " + e.vendor + " Need: " + o.join(",")
                    }), a.includes(e.architecture) || a.includes("*") || (t = {
                      allowed: !1,
                      reason: "GPU Architecture not allowed. Have: " + e.architecture + " Need: " + a.join(",")
                    }), t;
                  }
                }),
                u = s.allowed(t);
              return !!u.allowed || (y.info("[VideoTransformerModule]: GPU not allowed: " + u.reason), !1);
            }, t.createWebGpuCanvasSurface = function (e) {
              var t = function (e) {
                return e.style.objectFit = "contain", e.style.overflowClipMargin = "content-box", e.style.overflow = "clip", {
                  element: function () {
                    return e;
                  },
                  displayDimensions: function () {
                    return {
                      width: e.clientWidth,
                      height: e.clientHeight
                    };
                  },
                  videoDimensions: function () {
                    return {
                      width: e.clientWidth,
                      height: e.clientHeight
                    };
                  },
                  stats: function () {
                    return {
                      timestamp: performance.now(),
                      droppedFrames: 0,
                      decodedFrames: 0
                    };
                  },
                  visible: function () {
                    return (0, Ue.j)(e);
                  }
                };
              }(e);
              return t.stats = (this || _global).stats.bind(this || _global), t;
            }, t.startLogStatusEvents = function (e) {
              var t,
                n,
                r = this || _global,
                i = null != (t = null == (n = (this || _global).videoTransformer) ? void 0 : n.stats()) ? t : Zt();
              clearInterval((this || _global).statusInterval), (this || _global).statusInterval = window.setInterval(function () {
                var t, n;
                if (r.videoTransformer) {
                  var a = r.videoTransformer.stats(),
                    s = Yt(i, a),
                    u = s.frames,
                    c = s.timings,
                    d = s.timestamp,
                    l = s.resolution,
                    f = 0,
                    h = 0,
                    v = 0,
                    p = 0,
                    m = (a.timestamp - i.timestamp) / 1000;
                  m > 0 && (f = s.frames.source / m, h = s.frames.source_presented / m, v = s.frames.captured / m, p = s.frames.rendered / m), r.printStats(s, f, h, v, p);
                  var g = o()({
                    status_timestamp: d,
                    status_interval: e,
                    surface_visible: null != (t = null == (n = r.surface) ? void 0 : n.visible()) && t,
                    source_height: l.sourceHeight,
                    source_width: l.sourceWidth,
                    render_height: l.renderHeight,
                    render_width: l.renderWidth,
                    frames_source: u.source,
                    frames_source_presented: u.source_presented,
                    frames_captured: u.captured,
                    frames_missed: u.missed,
                    frames_blocked: u.blocked,
                    frames_skipped: u.skipped,
                    frames_transformed: u.transformed,
                    frames_rendered: u.rendered,
                    frames_overbudget: u.overBudget,
                    frames_failed: u.failed,
                    framerate_source: f,
                    framerate_source_presented: h,
                    framerate_capture: v,
                    framerate_render: p,
                    time_capture_delay: c.captureDelay,
                    time_receive_delay: c.receiveDelay,
                    time_transform: c.transformTime,
                    time_render: c.renderTime,
                    time_end_to_end: c.endToEnd
                  }, r.gpuAnalyticsProperties());
                  i = a, r.listeners.analytics({
                    name: "onGpuStatus",
                    data: g
                  });
                } else window.clearInterval(r.statusInterval);
              }, e);
            }, t.logInitEvent = function (e, t) {
              if (e.info) {
                var n = e.info,
                  r = n.timeMs,
                  i = n.gpuProperties,
                  a = o()({
                    gpu_time_init: r,
                    gpu_adapter_features: i.adapterFeatures,
                    gpu_device_features: i.deviceFeatures,
                    gpu_wgsl_features: i.wgslFeatures,
                    gpu_transformer_config: JSON.stringify((this || _global).initialConfig),
                    gpu_allowed: t
                  }, this.gpuAnalyticsProperties());
                (this || _global).listeners.analytics({
                  name: "onGpuInit",
                  data: a
                });
              }
            }, t.onTransformerError = function (e) {
              var t, n;
              this.stop();
              var r = o()({
                code: e.code,
                source: e.source,
                message: e.message,
                fatal: !0,
                surface_visible: null != (t = null == (n = (this || _global).surface) ? void 0 : n.visible()) && t
              }, this.gpuAnalyticsProperties());
              y.warn("[VideoTransformerModule]: Error, disabling module", e), (this || _global).disabled = !0, (this || _global).listeners.error(r), (this || _global).listeners.analytics({
                name: "onGpuError",
                data: r
              });
            }, t.gpuAnalyticsProperties = function () {
              var e,
                t,
                n,
                r,
                i,
                o = null == (e = (this || _global).videoTransformer) ? void 0 : e.gpuProperties();
              return {
                gpu_architecture: null != (t = null == o ? void 0 : o.architecture) ? t : "",
                gpu_description: null != (n = null == o ? void 0 : o.description) ? n : "",
                gpu_device: null != (r = null == o ? void 0 : o.device) ? r : "",
                gpu_vendor: null != (i = null == o ? void 0 : o.vendor) ? i : ""
              };
            }, t.printStats = function (e, t, n, r, i) {
              var o,
                a,
                s = e.frames,
                u = s.source,
                c = s.source_presented,
                d = s.captured,
                l = s.received,
                f = s.transformed,
                h = s.rendered,
                v = s.missed,
                p = s.blocked,
                m = s.skipped,
                g = s.failed,
                E = s.overBudget,
                T = e.timings,
                S = T.captureDelay,
                _ = T.receiveDelay,
                b = T.transformTime / f,
                C = T.renderTime / h,
                w = _ / d,
                k = T.endToEnd / h,
                I = S / d,
                P = "Stats:\nStats Interval:                        " + (this || _global).config.statusIntervalMs + "ms\nDocument visible:                      " + !document.hidden + "\nSurface visible:                       " + (null != (o = null == (a = (this || _global).surface) ? void 0 : a.visible()) && o) + "\nSource Resolution                      " + e.resolution.sourceWidth + "x" + e.resolution.sourceHeight + "\nRender Resolution                      " + e.resolution.renderWidth + "x" + e.resolution.renderHeight + "\nSource Total Framerate:                " + t.toFixed(1) + "\nSource Presented Framerate:            " + n.toFixed(1) + "\nCapture Framerate:                     " + r.toFixed(1) + "\nRender Framerate:                      " + i.toFixed(1) + "\nSource Total frames:                   " + u + "\nSource Presented frames:               " + c + "\nSource Dropped frames:                 " + (u - c) + "\nCaptured frames:                       " + d + "\nReceived frames:                       " + l + "\nTransformed frames:                    " + f + "\nRendered frames:                       " + h + "\nMissed frames:                         " + v + "\nBlocked frames:                        " + p + "\nSkipped frames:                        " + m + "\nOverbudget frames:                     " + E + "\nFailed frames:                         " + g + "\nAverage rVFC capture delay:            " + I.toFixed(3) + "ms\nAverage frame receive delay:           " + w.toFixed(3) + "ms\nAverage frame transform time:          " + b.toFixed(3) + "ms\nAverage frame render time:             " + C.toFixed(3) + "ms\nAverage frame end-to-end time:         " + k.toFixed(3) + "ms\n";
              y.log("[VideoTransformerModule]: " + P);
            }, e;
          }(),
          Yt = function (e, t) {
            var n = {
              timestamp: t.timestamp,
              resolution: o()({}, t.resolution),
              frames: {
                source: 0,
                source_presented: 0,
                captured: 0,
                received: 0,
                transformed: 0,
                rendered: 0,
                missed: 0,
                blocked: 0,
                skipped: 0,
                failed: 0,
                overBudget: 0
              },
              timings: {
                captureDelay: 0,
                receiveDelay: 0,
                transformTime: 0,
                renderTime: 0,
                endToEnd: 0
              }
            };
            return ["frames", "timings"].forEach(function (r) {
              for (var i = 0, o = Object.entries(t[r]); i < o.length; i++) {
                var a = o[i],
                  s = a[0],
                  u = a[1];
                n[r][s] = u - e[r][s];
              }
            }), n;
          },
          Zt = function () {
            return {
              timestamp: performance.now(),
              frames: {
                source: 0,
                source_presented: 0,
                captured: 0,
                received: 0,
                transformed: 0,
                rendered: 0,
                missed: 0,
                blocked: 0,
                skipped: 0,
                failed: 0,
                overBudget: 0
              },
              timings: {
                captureDelay: 0,
                receiveDelay: 0,
                transformTime: 0,
                renderTime: 0,
                endToEnd: 0
              },
              resolution: {
                sourceHeight: 0,
                sourceWidth: 0,
                renderHeight: 0,
                renderWidth: 0
              }
            };
          },
          Xt = function () {
            var e = (0, Ue.sQ)(document).hidden;
            return document[e];
          },
          Jt = function (e, t) {
            var n = e,
              r = t,
              i = 0;
            return {
              update: function (e, t) {
                t !== r && (i = (e - n) / (t - r) * 1000, n = e, r = t);
              },
              framerate: function () {
                return i;
              }
            };
          },
          $t = function (e) {
            return e.video = "video", e.canvas = "canvas", e.debug_both = "debug_both", e;
          }({}),
          en = function () {
            function e(e) {
              (this || _global).context = e, (this || _global).video = void 0, (this || _global).canvas = void 0, (this || _global).surfaceContainer = void 0, (this || _global).framerateTracker = void 0, (this || _global).surfaceContainer = e.createElement("div");
              var t = e.createElement("video");
              (this || _global).video = Kt(t), this.moveVideoToRenderSurface();
              var n = (this || _global).video.stats();
              (this || _global).framerateTracker = Jt(n.decodedFrames, n.timestamp);
            }
            var t = e.prototype;
            return t.setVideo = function (e) {
              if ((this || _global).video.element() !== e) {
                this.activeSurface() !== $t.video && this.hideSurface(e);
                var t = Kt(e),
                  n = t.stats();
                (this || _global).framerateTracker = Jt(n.decodedFrames, n.timestamp), (this || _global).video = t;
              }
            }, t.moveVideoToRenderSurface = function () {
              this.replaceElement($t.video, (this || _global).video.element());
            }, t.setCanvas = function (e) {
              (this || _global).canvas !== e && (this.activeSurface() !== $t.canvas && this.hideSurface(e.element()), this.replaceElement($t.canvas, e.element()), (this || _global).canvas = e);
            }, t.setActiveSurface = function (e) {
              if (e !== this.activeSurface()) if (e === $t.canvas) {
                if (!(this || _global).canvas) return void console.warn("[RenderSurface]: Tried to set canvas surface to active, but the canvas surface is undefiend.");
                this.hideSurface((this || _global).video.element()), this.showSurface((this || _global).canvas.element());
              } else if (e === $t.video) {
                var t;
                this.hideSurface(null == (t = (this || _global).canvas) ? void 0 : t.element()), this.showSurface((this || _global).video.element());
              } else if (e === $t.debug_both) {
                var n;
                this.showSurface(null == (n = (this || _global).canvas) ? void 0 : n.element()), this.showSurface((this || _global).video.element());
              }
            }, t.surface = function () {
              return (this || _global).surfaceContainer;
            }, t.videoElement = function () {
              return (this || _global).video.element();
            }, t.displayDimensions = function () {
              return (this || _global).video.displayDimensions();
            }, t.videoDimensions = function () {
              return (this || _global).video.videoDimensions();
            }, t.stats = function () {
              var e = (this || _global).video.stats();
              return (this || _global).framerateTracker.update(e.decodedFrames, e.timestamp), e;
            }, t.framerate = function () {
              return (this || _global).framerateTracker.framerate();
            }, t.activeSurface = function () {
              var e;
              return null != (e = (this || _global).canvas) && e.visible() ? $t.canvas : $t.video;
            }, t.safeAppendSurface = function (e) {
              try {
                (this || _global).surfaceContainer.appendChild(e);
              } catch (e) {
                console.warn("[RenderSurface]: Failed to append surface to container", e);
              }
            }, t.safeRemoveSurface = function (e) {
              try {
                var t = (this || _global).surfaceContainer.querySelector(e);
                t && (this || _global).surfaceContainer.removeChild(t);
              } catch (e) {
                console.warn("[RenderSurface]: Failed to remove surface from container", e);
              }
            }, t.replaceElement = function (e, t) {
              this.safeRemoveSurface(e), this.safeAppendSurface(t);
            }, t.hideSurface = function (e) {
              e && (e.style.visibility = "hidden", e.style.position = "absolute", e.style.inset = "0");
            }, t.showSurface = function (e) {
              e && (e.style.visibility = "inherit", e.style.position = "inherit", e.style.inset = "inherit");
            }, e;
          }(),
          tn = function () {
            function e() {
              (this || _global).emitter = new ot.TypedEmitter({}), (this || _global).queue = new Array();
            }
            e.getInstance = function () {
              return e.gInstance || (e.gInstance = new e()), e.gInstance;
            };
            var t = e.prototype;
            return t.registerMetricsCallback = function (e) {
              (this || _global).emitter.on("newMetrics", e);
            }, t.unregisterMetricsCallback = function (e) {
              (this || _global).emitter.off("newMetrics", e);
            }, t.enqueue = function (e) {
              (this || _global).queue.push(e), (this || _global).emitter.emit("newMetrics");
            }, t.dequeueAll = function () {
              var e = (this || _global).queue;
              return (this || _global).queue = new Array(), e;
            }, e;
          }();
        function nn(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
          return r;
        }
        tn.gInstance = void 0;
        var rn = function () {
          function e(t, n) {
            var i,
              s,
              u = this || _global;
            (this || _global).worker = void 0, (this || _global).id = void 0, (this || _global).emitter = new Se(), (this || _global).seekTime = null, (this || _global).paused = !0, (this || _global).isLoaded = !1, (this || _global).autoPlayOptions = null, (this || _global).mediaSinkManager = void 0, (this || _global).experiments = {}, (this || _global).adjustments = void 0, (this || _global).enableRemoteSearch = void 0, (this || _global).isQualitySupported = void 0, (this || _global).onvisibilitychange = void 0, (this || _global).onmessage = function (e) {
              return u.onWorkerMessage(e);
            }, (this || _global).onOnline = function () {
              return u.postMessage("onOnline");
            }, (this || _global).onOffline = function () {
              return u.postMessage("onOffline");
            }, (this || _global).pauseHiddenSilentTab = void 0, (this || _global).state = void 0, (this || _global).workerMessageProcessors = [c], (this || _global).configManager = void 0, (this || _global).deviceConfigMetricsHelper = tn.getInstance(), (this || _global).deviceConfigEmitMetricsBound = (this || _global).emitDeviceConfigManagerMetrics.bind(this || _global), (this || _global).deviceConfigPropertyHolder = void 0, (this || _global).daterangeTagAssembler = void 0, (this || _global).videoTransformerModule = void 0, (this || _global).renderSurface = new en(document), (this || _global).startCapture = void 0, (this || _global).stopCapture = void 0, (this || _global).requestCaptureAnalytics = void 0, e.instanceCount += 1, (this || _global).worker = n, (this || _global).id = e.instanceId++, (this || _global).isQualitySupported = t.isQualitySupported || Ue.h3, (this || _global).onvisibilitychange = function () {
              return u.onVisibilityChange();
            }, (this || _global).enableRemoteSearch = t.enableRemoteSearch || !1;
            var l,
              h = (0, r.cp)();
            if ((this || _global).pauseHiddenSilentTab = h.chrome && 63 === h.major || h.opera, (this || _global).adjustments = (l = null != (i = null == (s = t.webviewHost) ? void 0 : s.adjustments) ? i : {}, o()({}, tt, l)), (this || _global).mediaSinkManager = new Xe(this || _global, (this || _global).enableRemoteSearch, (this || _global).adjustments, (this || _global).renderSurface.videoElement()), d.isSupported()) {
              var p = new d();
              (this || _global).workerMessageProcessors.push(p.processor);
            }
            var m,
              g,
              S,
              _,
              b = (m = {
                architecture: "",
                description: "",
                device: "",
                vendor: ""
              }, g = !1, S = null, {
                init: function () {
                  return f()(v().mark(function e() {
                    var t;
                    return v().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (g = !1, S = E.gpu_pending, e.prev = 2, navigator.gpu) {
                            e.next = 7;
                            break;
                          }
                          return y.warn(E.gpu_unavailable), S = E.gpu_unavailable, e.abrupt("return");
                        case 7:
                          return e.next = 9, navigator.gpu.requestAdapter();
                        case 9:
                          if (t = e.sent) {
                            e.next = 14;
                            break;
                          }
                          return y.warn(E.gpu_adapter_unavailable), S = E.gpu_adapter_unavailable, e.abrupt("return");
                        case 14:
                          return e.next = 16, t.requestAdapterInfo();
                        case 16:
                          m = e.sent, S = null, g = !0, e.next = 25;
                          break;
                        case 21:
                          e.prev = 21, e.t0 = e.catch(2), y.warn(E.gpu_error, e.t0), S = E.gpu_error + " " + ((null == e.t0 ? void 0 : e.t0.message) || "unknown");
                        case 25:
                        case "end":
                          return e.stop();
                      }
                    }, e, null, [[2, 21]]);
                  }))();
                },
                process: function (e) {
                  if (!e) return e;
                  var t = e.type,
                    n = e.arg,
                    r = t === a.a.ANALYTICS_EVENT,
                    i = n && ("video-play" === n.name || "minute-watched" === n.name);
                  return r && i ? (n.properties.gpu_supported = g, n.properties.gpu_unsupported_reason = S, n.properties.gpu_architecture = m.architecture, n.properties.gpu_description = m.description, n.properties.gpu_device = m.device, n.properties.gpu_vendor = m.vendor, e) : e;
                }
              });
            b.init(), (this || _global).workerMessageProcessors.push(b.process.bind(b)), void 0 !== t.serviceWorker && ("serviceWorker" in navigator || (xe.warn("Service workers are not supported."), 0)) && (function (e) {
              Re = Oe(e);
            }(t.serviceWorker), null == (_ = Me()) || _.registerAndActivate()), (this || _global).state = {
              averageBitrate: 0,
              bandwidthEstimate: 0,
              looping: !1,
              autoQualityMode: !0,
              volume: 1,
              liveLatency: 0,
              liveLowLatencyEnabled: !0,
              liveLowLatency: !1,
              statistics: {}
            }, this.resetState(), this.attachHandlers(), this.checkDebugCaptureEnabled();
            var C = [];
            (0, T.bz)() && C.push("hevc"), (0, T.dq)() && C.push("av01"), (this || _global).configManager = new lt({}, (this || _global).onConfigChanged.bind(this || _global)), (this || _global).configManager.initDeviceConfigManager({
              canRefreshNow: e.canDeviceConfigManagerRefreshNowCallback,
              emitMetrics: e.emitDeviceConfigManagerMetricsCallback,
              emitAnalytics: function (e, t) {
                u.sendConfigManagerDeviceConfigAnalytics(e, t);
              }
            }), this.onConfigChanged(), this.postMessage("create", [{
              mseSupported: (0, T.aP)(),
              keySystem: void 0 !== t.keySystem ? t.keySystem : O(h),
              browserContext: o()({}, h, {
                webviewHost: t.webviewHost
              }),
              codecs: C,
              testOnly: t.testOnly,
              playerFramework: t.playerFramework,
              buildDistId: "npm"
            }, (this || _global).configManager.getConfigSnapshot()]);
            var w = (0, Ue.sQ)(document).hidden;
            this.postMessage("setVisible", [!document[w]]), (this || _global).deviceConfigMetricsHelper.registerMetricsCallback((this || _global).deviceConfigEmitMetricsBound), this.emitDeviceConfigManagerMetrics();
          }
          var t = e.prototype;
          return t.delete = function () {
            var t,
              n,
              r = this || _global;
            null == (t = Me()) || t.destroy();
            var i = (0, Ue.sQ)(document).visibilityChange;
            document.removeEventListener(i, (this || _global).onvisibilitychange), window.removeEventListener("online", (this || _global).onOnline), window.removeEventListener("offline", (this || _global).onOffline), (this || _global).emitter.removeAllListeners(), (this || _global).emitter.on(et.DESTROY, function () {
              r.mediaSinkManager.destroy(), r.emitter.removeAllListeners(), r.worker.removeEventListener("message", r.onmessage);
            }), (this || _global).configManager.delete(), null == (n = (this || _global).videoTransformerModule) || n.destroy(), (this || _global).videoTransformerModule = void 0, this.postMessage("delete"), e.instanceCount > 0 && (e.instanceCount -= 1), (this || _global).deviceConfigMetricsHelper.unregisterMetricsCallback((this || _global).deviceConfigEmitMetricsBound);
          }, t.attachHTMLVideoElement = function (e) {
            var t, n;
            null == (t = (this || _global).mediaSinkManager) || t.destroy(), (this || _global).mediaSinkManager = new Xe(this || _global, (this || _global).enableRemoteSearch, (this || _global).adjustments, e), this.processVideoElementAttributes(e), (this || _global).renderSurface.setVideo(e), null == (n = (this || _global).videoTransformerModule) || n.swapVideoSource(e), (this || _global).configManager.getConfigSnapshot().features.gpu.flags.enable_render_surface && (this || _global).renderSurface.moveVideoToRenderSurface();
          }, t.getHTMLVideoElement = function () {
            return (this || _global).renderSurface.videoElement();
          }, t.getVideoRenderSurface = function () {
            if ((this || _global).configManager.getConfigSnapshot().features.gpu.flags.enable_render_surface) return (this || _global).renderSurface.surface();
          }, t.load = function (e, t) {
            var n;
            void 0 === t && (t = ""), null == (n = Me()) || n.configure(), this.trySetupVideoTransformer(), this.postMessage("load", [e, t]), (this || _global).autoPlayOptions && this.postMessage("playIntent");
            var r = this.getDeviceConfigPropertyHolder();
            r && r.getJsonValue("sr_model_f16");
          }, t.play = function () {
            this.postMessage("playIntent"), (this || _global).mediaSinkManager.captureGesture(), (this || _global).paused = !1, this.attemptPlay();
          }, t.setAutoplay = function (e) {
            (this || _global).autoPlayOptions = e ? {
              attemptMutedRetry: !0
            } : null;
          }, t.setAutoPlayOptions = function (e) {
            (this || _global).autoPlayOptions = e;
          }, t.getExperiments = function () {
            return (this || _global).experiments;
          }, t.setExperiment = function (e, t) {
            this.setExperimentData({
              id: e,
              assignment: t,
              version: 0,
              type: ""
            });
          }, t.setExperimentData = function (e) {
            (this || _global).configManager.setExperiment(e.id, e.assignment), this.postMessage("setExperiment", [e]);
          }, t.pause = function () {
            (this || _global).paused = !0, this.postMessage("pause");
          }, t.isPaused = function () {
            return (this || _global).paused;
          }, t.seekTo = function (e) {
            (this || _global).seekTime = e, this.postMessage("seekTo", [e]);
          }, t.isSeeking = function () {
            return null !== (this || _global).seekTime;
          }, t.isAutoplay = function () {
            return !!(this || _global).autoPlayOptions;
          }, t.getDuration = function () {
            return (this || _global).state.duration;
          }, t.getStartOffset = function () {
            return (this || _global).state.startOffset || 0;
          }, t.getPosition = function () {
            return null === (this || _global).seekTime ? (this || _global).mediaSinkManager.getCurrentSink().getCurrentTime() : (this || _global).seekTime;
          }, t.getSyncTime = function () {
            return (this || _global).state.syncTime;
          }, t.getBuffered = function () {
            return (this || _global).mediaSinkManager.getCurrentSink().buffered();
          }, t.getBufferedRanges = function () {
            return this.postMessage("updateBufferedRanges", []), (this || _global).state.trackBufferedRanges;
          }, t.getSinkBufferedRanges = function () {
            var e = (this || _global).mediaSinkManager.getCurrentSink();
            return {
              audio: e.getBufferedRanges("audio"),
              video: e.getBufferedRanges("video")
            };
          }, t.getBufferDuration = function () {
            return (this || _global).state.bufferedPosition - this.getPosition();
          }, t.getState = function () {
            return (this || _global).state.state;
          }, t.getVideoWidth = function () {
            return this.getHTMLVideoElement().videoWidth;
          }, t.getVideoHeight = function () {
            return this.getHTMLVideoElement().videoHeight;
          }, t.getVideoFrameRate = function () {
            return (this || _global).state.statistics.framerate;
          }, t.getVideoBitRate = function () {
            return (this || _global).state.statistics.bitrate;
          }, t.getAverageBitrate = function () {
            return (this || _global).state.averageBitrate;
          }, t.getBandwidthEstimate = function () {
            return (this || _global).state.bandwidthEstimate;
          }, t.getPath = function () {
            return (this || _global).state.path;
          }, t.getProtocol = function () {
            return (this || _global).state.protocol;
          }, t.getVersion = function () {
            return "1.32.1";
          }, t.isLiveLowLatency = function () {
            return (this || _global).state.liveLowLatencyEnabled && (this || _global).state.liveLowLatency;
          }, t.isLooping = function () {
            return (this || _global).state.looping;
          }, t.setLogLevel = function (e) {
            !function (e) {
              var t = {
                  debug: !1,
                  log: !1,
                  info: !1,
                  warn: !1,
                  error: !1
                },
                n = function (e, n) {
                  for (var r, i = function (e, t) {
                      var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                      if (n) return (n = n.call(e)).next.bind(n);
                      if (Array.isArray(e) || (n = function (e, t) {
                        if (e) {
                          if ("string" == typeof e) return we(e, t);
                          var n = Object.prototype.toString.call(e).slice(8, -1);
                          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? we(e, t) : void 0;
                        }
                      }(e)) || t && e && "number" == typeof e.length) {
                        n && (e = n);
                        var r = 0;
                        return function () {
                          return r >= e.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: e[r++]
                          };
                        };
                      }
                      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }(e); !(r = i()).done;) {
                    var o = r.value;
                    t[o] = n;
                  }
                };
              switch (e.level) {
                case "debug":
                  n(["debug", "log", "info", "warn", "error"], !0);
                  break;
                case "log":
                  n(["log", "info", "warn", "error"], !0);
                  break;
                case "info":
                  n(["info", "warn", "error"], !0);
                  break;
                case "warn":
                  n(["warn", "error"], !0);
                  break;
                case "error":
                  n(["error"], !0);
              }
              !function (e) {
                ke.enabled = e.enabled, ke.levels = o()({}, e.levels), Ie.emit("logConfigUpdated", e);
              }({
                enabled: e.enabled,
                levels: t
              });
            }({
              enabled: !0,
              level: e
            }), this.postMessage("setLogLevel", [e]);
          }, t.setLooping = function (e) {
            (this || _global).state.looping = e, this.postMessage("setLooping", [e]);
          }, t.isMuted = function () {
            return (this || _global).mediaSinkManager.getCurrentSink().isMuted();
          }, t.setMuted = function (e) {
            (this || _global).mediaSinkManager.getCurrentSink().setMuted(e);
          }, t.setVolume = function (e) {
            (this || _global).state.volume = e, this.postMessage("setVolume", [(this || _global).state.volume]);
          }, t.getVolume = function () {
            return (this || _global).state.volume;
          }, t.getQuality = function () {
            return (this || _global).state.quality;
          }, t.setQuality = function (e, t) {
            void 0 === t && (t = !1), this.getHTMLVideoElement().controls || (this.postMessage("setQuality", [e, t]), (this || _global).state.autoQualityMode = !1);
          }, t.getQualities = function () {
            return (this || _global).state.qualities;
          }, t.setAuthToken = function (e) {
            this.postMessage("setAuthToken", [e]);
          }, t.isAutoQualityMode = function () {
            return (this || _global).state.autoQualityMode;
          }, t.setAutoQualityMode = function (e) {
            (this || _global).state.autoQualityMode = e, this.postMessage("setAutoQualityMode", [e]);
          }, t.setAutoInitialBitrate = function (e) {
            this.postMessage("setAutoInitialBitrate", [e]);
          }, t.setAutoMaxQuality = function (e) {
            this.postMessage("setAutoMaxQuality", [e]);
          }, t.setAutoMaxBitrate = function (e) {
            this.postMessage("setAutoMaxBitrate", [e]);
          }, t.setAutoMaxVideoSize = function (e, t) {
            this.postMessage("setAutoMaxVideoSize", [e, t]);
          }, t.setAutoViewportSize = function (e, t) {
            this.postMessage("setAutoViewportSize", [e, t]);
          }, t.getPlaybackRate = function () {
            return (this || _global).mediaSinkManager.getCurrentSink().getPlaybackRate();
          }, t.setPlaybackRate = function (e) {
            return (this || _global).mediaSinkManager.getCurrentSink().setPlaybackRate(e);
          }, t.setClientId = function (e) {
            this.postMessage("setClientId", [e]);
          }, t.setDeviceId = function (e) {
            this.postMessage("setDeviceId", [e]);
          }, t.setLiveSpeedUpRate = function (e) {
            this.postMessage("setLiveSpeedUpRate", [e]);
          }, t.setPlayerType = function (e) {
            this.postMessage("setPlayerType", [e]);
          }, t.setLiveMaxLatency = function (e) {
            this.postMessage("setLiveMaxLatency", [e]);
          }, t.setLiveLowLatencyEnabled = function (e) {
            (this || _global).state.liveLowLatencyEnabled = e, this.postMessage("setLiveLowLatencyEnabled", [e]);
          }, t.setRebufferToLive = function (e) {
            var t;
            null != (t = Me()) && null != (t = t.getDriftDetectionConfig()) && t.enabled || this.postMessage("setRebufferToLive", [e]);
          }, t.setVisible = function (e) {
            this.postMessage("setVisible", [e]);
          }, t.setInitialBufferDuration = function (e) {
            this.postMessage("setInitialBufferDuration", [e]);
          }, t.addEventListener = function (e, t) {
            (this || _global).emitter.on(e, t);
          }, t.removeEventListener = function (e, t) {
            (this || _global).emitter.removeListener(e, t);
          }, t.getDroppedFrames = function () {
            return (this || _global).state.statistics.droppedFrames;
          }, t.getDecodedFrames = function () {
            return (this || _global).state.statistics.decodedFrames;
          }, t.getDisplayWidth = function () {
            return (this || _global).renderSurface.displayDimensions().width;
          }, t.getDisplayHeight = function () {
            return (this || _global).renderSurface.displayDimensions().height;
          }, t.getSessionId = function () {
            return (this || _global).state.sessionId;
          }, t.getChannelMetadata = function () {
            return (this || _global).state.channelMetadata;
          }, t.getSessionData = function () {
            return (this || _global).state.sessionData;
          }, t.getLiveLatency = function () {
            return (this || _global).state.liveLatency;
          }, t.isProtected = function () {
            return (this || _global).mediaSinkManager.isProtected();
          }, t.startRemotePlayback = function () {
            this.postMessage("startRemotePlayback");
          }, t.endRemotePlayback = function () {
            this.postMessage("endRemotePlayback");
          }, t.setPlatformName = function (e) {
            this.postMessage("setPlatformName", [e]);
          }, t.setRequestCredentials = function (e) {
            this.postMessage("setRequestCredentials", [e]);
          }, t.setSinkType = function (e) {
            this.postMessage("setSinkType", [e]);
          }, t.onSinkTimeUpdate = function () {
            if (null === (this || _global).seekTime) {
              var e = (this || _global).mediaSinkManager.getCurrentSink(),
                t = (this || _global).renderSurface.stats(),
                n = t.droppedFrames,
                r = t.decodedFrames,
                i = (this || _global).renderSurface.displayDimensions(),
                o = i.height,
                s = i.width;
              this.postMessage("onClientSinkUpdate", [{
                currentTime: e.getCurrentTime(),
                decodedFrames: r,
                droppedFrames: n,
                framerate: (this || _global).renderSurface.framerate(),
                bufferDuration: e.bufferDuration(),
                displayHeight: o,
                displayWidth: s
              }]), this.setAutoViewportSize(s * window.devicePixelRatio, o * window.devicePixelRatio), (this || _global).emitter.emit(a.a.TIME_UPDATE, e.getCurrentTime());
            }
          }, t.onSinkBufferUpdate = function () {
            (this || _global).emitter.emit(a.a.BUFFER_UPDATE);
          }, t.onSinkDurationChanged = function (e) {
            this.postMessage("onClientSinkDurationChanged", [e]);
          }, t.onSinkEnded = function () {
            this.postMessage("onClientSinkEnded");
          }, t.onSinkIdle = function () {
            this.postMessage("onClientSinkIdle");
          }, t.onSinkPlaying = function (e) {
            this.postMessage("onClientSinkPlaying"), e && this.play();
          }, t.onSinkStop = function (e) {
            var t,
              n,
              r = (0, Ue.sQ)(document).hidden;
            if (document[r]) this.postMessage("pause");else if (e) {
              if (!this.isMuted() && (null == (t = null == (n = (this || _global).autoPlayOptions) ? void 0 : n.attemptMutedRetry) || t)) return this.setMuted(!0), (this || _global).mediaSinkManager.getCurrentSink().play(), void (this || _global).emitter.emit(a.a.AUDIO_BLOCKED);
              this.pause(), (this || _global).emitter.emit(a.a.PLAYBACK_BLOCKED);
            } else this.pause();
          }, t.onSinkReset = function () {
            this.postMessage("onClientSinkReset");
          }, t.onSinkError = function (e) {
            var t = e.value,
              n = e.code,
              r = e.message;
            this.postMessage("onClientSinkError", [t, n, r]);
          }, t.onSinkRecoverableError = function (e) {
            var t = e.value,
              n = e.code,
              r = e.message;
            this.postMessage("onClientSinkRecoverableError", [t, n, r]);
          }, t.onSinkVolumeChanged = function (e, t) {
            this.getHTMLVideoElement().controls && t && this.setVolume(e), (this || _global).emitter.emit(a.a.VOLUME_CHANGED, (this || _global).state.volume);
          }, t.onSinkMutedChanged = function (e) {
            this.postMessage("setMuted", [e]), (this || _global).emitter.emit(a.a.MUTED_CHANGED);
          }, t.onSinkPlaybackRateChanged = function (e) {
            this.postMessage("setPlaybackRate", [e]);
          }, t.onPassthroughSinkDataCue = function (e) {
            var t;
            null == (t = (this || _global).daterangeTagAssembler) || t.addCue(e);
          }, t.onPassthroughSinkMetadata = function (e, t, n, r, i) {
            (this || _global).emitter.emit(a.a.TEXT_METADATA_CUE, {
              description: r,
              endTime: t,
              startTime: e,
              text: n,
              owner: i,
              type: "TextMetadataCue"
            });
          }, t.onPassthroughSinkPropertyChanged = function (e, t) {
            this.postMessage("onClientSinkPassthroughPropertyChanged", [e, t]);
          }, t.onSinkControlsChanged = function (e) {
            this.postMessage("setControls", [e]);
          }, t.onSinkGapJump = function (e) {
            this.postMessage("onClientSinkGapJump", [e]);
          }, t.onRemoteDevice = function (e) {
            (this || _global).emitter.emit(e ? Q.G.AVAILABLE : Q.G.UNAVAILABLE);
          }, t.onRemoteReconnect = function () {
            this.startRemotePlayback();
          }, t.onSessionError = function () {
            this.postMessage("onClientSinkError", [S.pn, 0, "Chromecast session error"]);
          }, t.onLoadMediaError = function () {
            this.postMessage("onClientSinkError", [S.pn, 0, "Chromecast load media failed"]);
          }, t.onUserCancel = function () {
            this.endRemotePlayback(), (this || _global).emitter.emit(Q.G.SESSION_ENDED);
          }, t.onSegmentDiscontinuity = function () {
            (this || _global).mediaSinkManager.onSegmentDiscontinuity();
          }, t.onSessionStop = function () {
            this.endRemotePlayback(), (this || _global).emitter.emit(Q.G.SESSION_ENDED);
          }, t.onSessionStarted = function (e) {
            (this || _global).emitter.emit(Q.G.SESSION_STARTED, e);
          }, e.canDeviceConfigManagerRefreshNowCallback = function () {
            return e.instanceCount > 0;
          }, e.emitDeviceConfigManagerMetricsCallback = function (e) {
            tn.getInstance().enqueue(e);
          }, t.emitDeviceConfigManagerMetrics = function () {
            for (var e, t = this || _global, n = function (e, t) {
                var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (n) return (n = n.call(e)).next.bind(n);
                if (Array.isArray(e) || (n = function (e, t) {
                  if (e) {
                    if ("string" == typeof e) return nn(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? nn(e, t) : void 0;
                  }
                }(e)) || t && e && "number" == typeof e.length) {
                  n && (e = n);
                  var r = 0;
                  return function () {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }((this || _global).deviceConfigMetricsHelper.dequeueAll()); !(e = n()).done;) r = e.value, function (e, n) {
              t.sendConfigManagerDeviceConfigAnalytics(e, n);
            }("ivs_devconf_ops_metrics", o()({
              env: at,
              client_sdk: st
            }, r));
            var r;
          }, t.sendConfigManagerDeviceConfigAnalytics = function (e, t) {
            var n = (0, Ue.dl)(t);
            n && this.postMessage("onDeviceConfigAnalytics", [e, n]);
          }, t.attemptPlay = function () {
            var e = (0, Ue.sQ)(document).hidden;
            !document[e] && (this || _global).isLoaded && this.postMessage("play");
          }, t.postMessage = function (e, t, n) {
            void 0 === n && (n = []), (this || _global).worker.postMessage({
              id: (this || _global).id,
              funcName: e,
              args: t
            }, n);
          }, t.resetState = function () {
            Object.assign((this || _global).state, {
              state: Y.p.IDLE,
              quality: {
                name: "",
                group: "",
                codecs: "",
                bitrate: 0,
                width: 0,
                height: 0,
                framerate: 0
              },
              qualities: [],
              duration: 0,
              startOffset: 0,
              sessionData: {},
              volume: 1,
              statistics: {
                bitrate: 0,
                framerate: 0,
                droppedFrames: 0,
                decodeFrames: 0,
                renderedFrames: 0
              },
              trackBufferedRanges: {
                audio: [],
                video: []
              },
              channelMetadata: []
            }), (this || _global).emitter.emit(a.a.DURATION_CHANGED, 0), (this || _global).seekTime = null, (this || _global).isLoaded = !1;
          }, t.attachHandlers = function () {
            var e = this || _global;
            (this || _global).worker.addEventListener("message", (this || _global).onmessage);
            var t = (0, Ue.sQ)(document).visibilityChange;
            document.addEventListener(t, (this || _global).onvisibilitychange), window.addEventListener("online", (this || _global).onOnline), window.addEventListener("offline", (this || _global).onOffline);
            var n = (this || _global).emitter;
            n.on(a.a.VOLUME_CHANGED, function () {
              return e.onVolumeChanged();
            }), n.on(a.a.MUTED_CHANGED, function () {
              return e.onMutedChanged();
            }), n.on(a.a.SEEK_COMPLETED, function () {
              return e.onSeekCompleted();
            }), n.on(a.a.ERROR, function () {
              return e.onError();
            }), n.on(a.a.SESSION_DATA, function (t) {
              return e.onSessionData(t);
            }), n.on(a.a.SEGMENT_DISCONTINUITY, function () {
              return e.onSegmentDiscontinuity();
            }), n.on(et.STATE_CHANGED, function (t) {
              return e.onStateChanged(t);
            }), n.on(et.MEDIA_SINK_RPC, function (t) {
              return e.mediaSinkManager.applyRPC(t);
            }), n.on(et.CONFIGURE, function (t) {
              e.mediaSinkManager.configure(t), e.setSinkType(t.mode);
            }), n.on(et.RESET, function () {
              var t, n;
              null == (t = e.videoTransformerModule) || t.stop(), null == (n = e.videoTransformerModule) || n.reset(), e.mediaSinkManager.reset();
            }), n.on(q.C.ID3, function (t) {
              return e.onID3(t);
            }), n.on(et.GET_EXPERIMENTS, function (t) {
              e.experiments = t;
            }), n.on(et.PROPERTY_CHANGED, function (t) {
              var n = t.key,
                r = t.value;
              e.state[n] = function (e, t) {
                return "syncTime" === e && (t *= 1000), t;
              }(n, r);
            }), n.on(et.SYNC_TIME_CHANGED, function (t) {
              e.emitter.emit(a.a.SYNC_TIME_UPDATE, 1000 * t);
            }), n.on(et.BUFFERED_RANGES, function (t) {
              e.state.trackBufferedRanges = t;
            }), n.on(et.LOG_MESSAGE, function (e) {
              var t = e.level,
                n = e.message;
              return console[t](n);
            });
          }, t.onVolumeChanged = function () {
            var e = (0, Ue.sQ)(document).hidden;
            (this || _global).pauseHiddenSilentTab && document[e] && 0 === this.getVolume() && this.postMessage("pause");
          }, t.onMutedChanged = function () {
            var e = (0, Ue.sQ)(document).hidden;
            (this || _global).pauseHiddenSilentTab && document[e] && this.isMuted() && this.postMessage("pause");
          }, t.onSeekCompleted = function () {
            (this || _global).seekTime = null;
          }, t.onError = function () {
            (this || _global).paused = !0;
          }, t.onStateChanged = function (e) {
            var t = this || _global;
            switch (e) {
              case Y.p.READY:
                var n = (this || _global).isQualitySupported;
                if ((this || _global).adjustments.abrTranscodesOnly && (this || _global).state.qualities.length > 1) {
                  var r = (this || _global).state.qualities.slice().sort(function (e, t) {
                    return t.bitrate - e.bitrate;
                  });
                  "chunked" !== r[0].group ? n = function (e) {
                    return "chunked" !== e.group && t.isQualitySupported(e);
                  } : this.setAutoMaxQuality(r[1]);
                }
                var i = (0, Ue.YH)((this || _global).state.qualities, n);
                (this || _global).state.qualities = i.supported, i.unsupported.forEach(function (e) {
                  return t.postMessage("removeQuality", [e]);
                }), (this || _global).isLoaded = !0, (this || _global).autoPlayOptions && this.play(), (this || _global).paused || this.attemptPlay();
                break;
              case Y.p.IDLE:
                var o;
                null == (o = (this || _global).videoTransformerModule) || o.stop();
                break;
              case Y.p.PLAYING:
                this.tryStartVideoTransformer();
                break;
              case Y.p.ENDED:
                (this || _global).paused = !0;
            }
            (this || _global).emitter.emit(a.a.STATE_CHANGED, e), (this || _global).emitter.emit(e);
          }, t.onID3 = function (e) {
            var t = this || _global;
            e.forEach(function (e) {
              if ("TXXX" === e.id && "segmentmetadata" === e.desc && e.info.length) {
                var n = (0, Ue.N8)(e.info[0]);
                if (Object.prototype.hasOwnProperty.call(n, "stream_offset")) {
                  var r = Number(n.stream_offset);
                  isNaN(r) || (t.state.startOffset = r - t.getPosition());
                }
              }
            });
          }, t.onVisibilityChange = function () {
            var e,
              t = (0, Ue.sQ)(document).hidden,
              n = document[t];
            (this || _global).paused || document[t] || this.attemptPlay(), (this || _global).pauseHiddenSilentTab && !(this || _global).paused && n && (this.isMuted() || 0 === this.getVolume()) && this.postMessage("pause"), null == (e = (this || _global).videoTransformerModule) || e.onPageVisibilityChanged(n, this.getHTMLVideoElement()), (0, r.cp)().firefox || this.postMessage("setVisible", [!n]);
          }, t.onSessionData = function (e) {
            Object.assign((this || _global).state, e);
          }, t.onConfigChanged = function () {
            var e,
              t = (this || _global).configManager.getConfigSnapshot();
            t.features.gpu.flags.enable_render_surface && (this || _global).renderSurface.moveVideoToRenderSurface(), this.setupDaterangeTagAssembler(null != (e = t.features.passthroughDaterangeTags) && e), this.postMessage("updatePlayerConfiguration", [t]);
          }, t.setupDaterangeTagAssembler = function (e) {
            var t,
              n,
              r,
              i,
              s = this || _global;
            e ? (this || _global).daterangeTagAssembler || ((this || _global).daterangeTagAssembler = (t = function (e) {
              var t = e.attributes["X-TV-TWITCH-STREAM-SOURCE"];
              void 0 !== t && s.emitter.emit(a.a.STREAM_SOURCE_CUE, {
                type: "StreamSourceCue",
                streamSource: t
              }), s.emitter.emit(a.a.METADATA, {
                type: "text/json",
                data: (0, Ue.dl)(o()({
                  ID: e.ID,
                  CLASS: e.CLASS
                }, e.attributes))
              });
            }, n = new Map(), r = function (e, t) {
              return Array.from(e.attributes).every(function (e) {
                return void 0 !== t.attributes[e];
              });
            }, i = function (e, n, i, o) {
              for (var a = 0; a < n.length; ++a) {
                var s = n[a];
                if (s.CLASS === e.CLASS && void 0 === s.attributes[i]) return s.attributes[i] = o, r(e, s) && (n.splice(a, 1), t(s)), !0;
              }
              return !1;
            }, {
              addCue: function (e) {
                var o,
                  a,
                  s = null == (o = e.value) ? void 0 : o.key,
                  u = null == (a = e.value) ? void 0 : a.data;
                if (void 0 !== s && void 0 !== u) for (var c = 0; c < $e.length; ++c) {
                  var d = $e[c];
                  if (d.attributes.has(s)) {
                    var l = e.startTime + "-" + e.endTime,
                      f = n.get(l);
                    if (f || (f = [], n.set(l, f)), !i(d, f, s, u)) {
                      var h,
                        v = {
                          ID: "com.apple.quicktime.FAKE-HLS-" + Je++,
                          CLASS: d.CLASS,
                          attributes: (h = {}, h[s] = u, h.DURATION = "" + (e.endTime - e.startTime), h["START-DATE"] = new Date().toISOString(), h)
                        };
                      r(d, v) ? t(v) : f.push(v);
                    }
                  }
                }
              }
            })) : (this || _global).daterangeTagAssembler = void 0;
          }, t.trySetupVideoTransformer = function () {
            var e = this || _global;
            if (!(this || _global).videoTransformerModule) {
              var t = (this || _global).configManager.getConfigSnapshot().features.gpu;
              if (t.flags.init_transformer || t.flags.run_transformer) {
                var n = function (t) {
                    e.renderSurface.setActiveSurface($t.video), y.warn("[MediaPlayer]: Video Transformer error, switching render surface to video", t);
                  },
                  r = function (t) {
                    y.debug("[MediaPlayer]: Sending analytics event", t), e.postMessage(t.name, [t.data]);
                  };
                (this || _global).videoTransformerModule = new Qt(t, {
                  error: n,
                  analytics: r,
                  active: function () {
                    var n,
                      r = $t.video;
                    t.flags.allow_canvas_visible && (r = $t.canvas, null != (n = t.render) && n.debug && (r = $t.debug_both)), e.renderSurface.setActiveSurface(r);
                  },
                  inactive: function () {
                    e.renderSurface.setActiveSurface($t.video);
                  }
                }), (this || _global).videoTransformerModule.init().then(function (n) {
                  n && e.videoTransformerModule && (t.flags.add_canvas_to_surface && (y.debug("[MediaPlayer]: Adding canvas to render surface"), e.renderSurface.setCanvas(n)), e.getState() === Y.p.PLAYING && e.tryStartVideoTransformer());
                }).catch(function (t) {
                  var i;
                  null == (i = e.videoTransformerModule) || i.disable(), y.warn("[MediaPlayer]: Unhanled error initializing the Video Transformer");
                  var o = {
                    source: "MediaPlayer",
                    code: gt.Init,
                    message: "Unhandled error initializing the Video Transformer: " + ((null == t ? void 0 : t.message) || "unknown"),
                    fatal: !0,
                    gpu_architecture: "",
                    gpu_description: "",
                    gpu_device: "",
                    gpu_vendor: "",
                    surface_visible: !1
                  };
                  n(), r({
                    name: "onGpuError",
                    data: o
                  });
                });
              }
            }
          }, t.tryStartVideoTransformer = function () {
            (this || _global).videoTransformerModule && (this || _global).configManager.getConfigSnapshot().features.gpu.flags.run_transformer && (this || _global).videoTransformerModule.start(this.getHTMLVideoElement());
          }, t.onWorkerMessage = function (e) {
            var t = e.data;
            if (t && t.id === (this || _global).id) {
              var n = (this || _global).workerMessageProcessors.reduce(function (e, t) {
                  return t(e);
                }, t),
                r = n.type,
                i = n.arg;
              void 0 !== t.arg ? (this || _global).emitter.emit(r, i) : (this || _global).emitter.emit(r);
            }
          }, t.processVideoElementAttributes = function (e) {
            if (e.hasAttribute("autoplay") && (e.removeAttribute("autoplay"), this.setAutoplay(!0)), e.hasAttribute("playbackRate")) {
              var t,
                n = parseFloat(null != (t = e.getAttribute("playbackRate")) ? t : "1.0");
              if (!isNaN(n)) {
                var r = (0, Ue.qE)(n, 0.25, 2);
                this.setPlaybackRate(r);
              }
              e.removeAttribute("playbackRate");
            }
            if (e.hasAttribute("src")) {
              var i = e.src;
              (0, Ue.Pr)(e), this.load(i);
            }
            if (e.hasAttribute("loop") && (e.removeAttribute("loop"), this.setLooping(!0)), e.hasAttribute("muted") && (e.removeAttribute("muted"), this.setMuted(!0)), e.hasAttribute("volume")) {
              var o,
                a = parseFloat(null != (o = e.getAttribute("volume")) ? o : "1.0");
              isNaN(a) || this.setVolume((0, Ue.qE)(a, 0, 1)), e.removeAttribute("volume");
            }
          }, t.checkDebugCaptureEnabled = function () {}, t.getDeviceConfigPropertyHolder = function () {
            return (this || _global).deviceConfigPropertyHolder || ((this || _global).deviceConfigPropertyHolder = (this || _global).configManager.getDeviceConfigPropertyHolder()), (this || _global).deviceConfigPropertyHolder;
          }, e;
        }();
        rn.instanceCount = 0, rn.instanceId = 0;
        var on = n(787),
          an = function () {
            function e(e) {
              var t = this || _global;
              (this || _global).workerPort = void 0, (this || _global).emitter = void 0, (this || _global).messageQueue = void 0, (this || _global).workerPort = {
                postMessage: (this || _global).postMessageFromWorker.bind(this || _global),
                onmessage: function () {}
              }, (this || _global).emitter = new Te.EventEmitter(), (this || _global).messageQueue = new on.o(), this.loadScript(e, function (e) {
                return t.applyWorkerEnv(e);
              });
            }
            var t = e.prototype;
            return t.postMessage = function (e) {
              (this || _global).messageQueue ? (this || _global).messageQueue.push(e) : this.postMessageToWorker(e);
            }, t.addEventListener = function (e, t) {
              (this || _global).emitter.on(e, t);
            }, t.removeEventListener = function (e, t) {
              (this || _global).emitter.off(e, t);
            }, t.onmessage = function () {}, t.onmessageerror = function () {}, t.onerror = function () {}, t.terminate = function () {}, t.dispatchEvent = function () {
              return !0;
            }, t.loadScript = function (e, t) {
              var n = this || _global,
                r = new XMLHttpRequest();
              r.open("GET", e), r.addEventListener("load", function () {
                r.status >= 200 && r.status < 400 ? t(r.response) : n.emitter.emit("error", new Error(r.statusText));
              }), r.addEventListener("error", function (e) {
                n.emitter.emit("error", e);
              }), r.send();
            }, t.applyWorkerEnv = function (e) {
              if ((this || _global).messageQueue) {
                try {
                  Function("self", "messageHandler", e)(window, (this || _global).workerPort);
                } catch (e) {
                  return void (this || _global).emitter.emit("error", e);
                }
                for (; !(this || _global).messageQueue.empty();) this.postMessageToWorker((this || _global).messageQueue.pop());
                (this || _global).messageQueue = null;
              }
            }, t.postMessageFromWorker = function (e) {
              var t = this || _global;
              setTimeout(function () {
                t.emitter.emit("message", {
                  data: e
                });
              }, 0);
            }, t.postMessageToWorker = function (e) {
              var t = this || _global;
              setTimeout(function () {
                t.workerPort.onmessage({
                  data: e
                });
              }, 0);
            }, e;
          }();
        function sn(e, t, n) {
          var i;
          return void 0 === n && (n = !1), (i = (0, r.cp)().msIE ? new an(e) : (0, Ue.J6)(e) ? new Worker(e) : new Worker(URL.createObjectURL(new Blob(["importScripts('" + e + "')"])))).postMessage({
            wasmBinaryUrl: t,
            showWorkerLogs: n
          }), i;
        }
        var un = "undefined" != typeof window && "object" == typeof window.WebAssembly && "function" == typeof window.WebAssembly.instantiate,
          cn = un;
        function dn(e) {
          var t = e.asmWorker,
            n = e.wasmWorker,
            r = e.wasmBinary;
          if (!cn && !t) throw new Error("WebAssembly is not supported by the browser. This is required for playback.");
          var i = sn(cn ? n : t, r, e.showWorkerLog);
          return new fn(e, i);
        }
        function ln() {
          return "1.32.1";
        }
        var fn = function () {
          function e(e, t) {
            (this || _global).core = void 0, (this || _global).startCapture = void 0, (this || _global).stopCapture = void 0, (this || _global).requestCaptureAnalytics = void 0, (this || _global).core = new rn(e, t);
          }
          var t = e.prototype;
          return t.addEventListener = function (e, t) {
            var n;
            null == (n = this.checkCore()) || n.addEventListener(e, t);
          }, t.attachHTMLVideoElement = function (e) {
            var t;
            null == (t = this.checkCore()) || t.attachHTMLVideoElement(e);
          }, t.delete = function () {
            var e;
            null == (e = this.checkCore()) || e.delete(), (this || _global).core = null;
          }, t.endRemotePlayback = function () {
            var e;
            null == (e = this.checkCore()) || e.endRemotePlayback();
          }, t.isAutoplay = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isAutoplay();
          }, t.isAutoQualityMode = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isAutoQualityMode();
          }, t.getAverageBitrate = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getAverageBitrate();
          }, t.getBandwidthEstimate = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getBandwidthEstimate();
          }, t.getBufferDuration = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getBufferDuration();
          }, t.getBuffered = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getBuffered();
          }, t.getBufferedRanges = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getBufferedRanges();
          }, t.getSinkBufferedRanges = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getSinkBufferedRanges();
          }, t.getDecodedFrames = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getDecodedFrames();
          }, t.getDisplayHeight = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getDisplayHeight();
          }, t.getDisplayWidth = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getDisplayWidth();
          }, t.getDroppedFrames = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getDroppedFrames();
          }, t.getDuration = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getDuration();
          }, t.getExperiments = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getExperiments();
          }, t.getHTMLVideoElement = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getHTMLVideoElement();
          }, t.getVideoRenderSurface = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVideoRenderSurface();
          }, t.getLiveLatency = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getLiveLatency();
          }, t.getPath = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getPath();
          }, t.getProtocol = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getProtocol();
          }, t.getPlaybackRate = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getPlaybackRate();
          }, t.getPosition = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getPosition();
          }, t.getSyncTime = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getSyncTime();
          }, t.getQualities = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getQualities();
          }, t.getQuality = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getQuality();
          }, t.getSessionData = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getSessionData();
          }, t.getSessionId = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getSessionId();
          }, t.getChannelMetadata = function () {
            var e, t;
            return null != (e = null == (t = this.checkCore()) ? void 0 : t.getChannelMetadata()) ? e : [];
          }, t.getStartOffset = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getStartOffset();
          }, t.getState = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getState();
          }, t.getVersion = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVersion();
          }, t.getVideoBitRate = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVideoBitRate();
          }, t.getVideoFrameRate = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVideoFrameRate();
          }, t.getVideoHeight = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVideoHeight();
          }, t.getVideoWidth = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVideoWidth();
          }, t.getVolume = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.getVolume();
          }, t.isLiveLowLatency = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isLiveLowLatency();
          }, t.isLooping = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isLooping();
          }, t.isMuted = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isMuted();
          }, t.isPaused = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isPaused();
          }, t.isProtected = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isProtected();
          }, t.isSeeking = function () {
            var e;
            return null == (e = this.checkCore()) ? void 0 : e.isSeeking();
          }, t.load = function (e, t) {
            var n;
            return void 0 === t && (t = ""), null == (n = this.checkCore()) ? void 0 : n.load(e, t);
          }, t.pause = function () {
            var e;
            null == (e = this.checkCore()) || e.pause();
          }, t.play = function () {
            var e;
            null == (e = this.checkCore()) || e.play();
          }, t.removeEventListener = function (e, t) {
            var n;
            null == (n = this.checkCore()) || n.removeEventListener(e, t);
          }, t.seekTo = function (e) {
            var t;
            null == (t = this.checkCore()) || t.seekTo(e);
          }, t.setAuthToken = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAuthToken(e);
          }, t.setAutoInitialBitrate = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAutoInitialBitrate(e);
          }, t.setAutoMaxQuality = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAutoMaxQuality(e);
          }, t.setAutoMaxBitrate = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAutoMaxBitrate(e);
          }, t.setAutoMaxVideoSize = function (e, t) {
            var n;
            null == (n = this.checkCore()) || n.setAutoMaxVideoSize(e, t);
          }, t.setAutoplay = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAutoplay(e);
          }, t.setAutoPlayOptions = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAutoPlayOptions(e);
          }, t.setAutoQualityMode = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setAutoQualityMode(e);
          }, t.setAutoViewportSize = function (e, t) {
            var n;
            null == (n = this.checkCore()) || n.setAutoViewportSize(e, t);
          }, t.setClientId = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setClientId(e);
          }, t.setDeviceId = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setDeviceId(e);
          }, t.setExperiment = function (e, t) {
            var n;
            null == (n = this.checkCore()) || n.setExperiment(e, t);
          }, t.setExperimentData = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setExperimentData(e);
          }, t.setInitialBufferDuration = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setInitialBufferDuration(e);
          }, t.setLiveLowLatencyEnabled = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setLiveLowLatencyEnabled(e);
          }, t.setLiveMaxLatency = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setLiveMaxLatency(e);
          }, t.setLiveSpeedUpRate = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setLiveSpeedUpRate(e);
          }, t.setLogLevel = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setLogLevel(e);
          }, t.setLooping = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setLooping(e);
          }, t.setMuted = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setMuted(e);
          }, t.setPlaybackRate = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setPlaybackRate(e);
          }, t.setPlayerType = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setPlayerType(e);
          }, t.setQuality = function (e, t) {
            var n;
            void 0 === t && (t = !1), null == (n = this.checkCore()) || n.setQuality(e, t);
          }, t.setRebufferToLive = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setRebufferToLive(e);
          }, t.setVisible = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setVisible(e);
          }, t.setVolume = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setVolume(e);
          }, t.startRemotePlayback = function () {
            var e;
            null == (e = this.checkCore()) || e.startRemotePlayback();
          }, t.setPlatformName = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setPlatformName(e);
          }, t.setRequestCredentials = function (e) {
            var t;
            null == (t = this.checkCore()) || t.setRequestCredentials(e);
          }, t.checkCore = function () {
            return (this || _global).core || console.warn("Method called on deleted player instance."), (this || _global).core;
          }, e;
        }();
      },
      787: function (e, t, n) {
        "use strict";

        n.d(t, {
          o: function () {
            return r;
          }
        });
        var r = function () {
          function e() {
            (this || _global).buffer = void 0, (this || _global).head = void 0, (this || _global).tail = void 0, (this || _global).buffer = [], (this || _global).head = 0, (this || _global).tail = 0;
          }
          var t = e.prototype;
          return t.push = function (e) {
            (this || _global).tail === (this || _global).buffer.length ? (this || _global).buffer.push(e) : (this || _global).buffer[(this || _global).tail] = e, (this || _global).tail++;
          }, t.pop = function () {
            var e,
              t = null != (e = (this || _global).buffer[(this || _global).head]) ? e : null;
            return (this || _global).buffer[(this || _global).head] = null, (this || _global).head++, this.empty() && ((this || _global).head = 0, (this || _global).tail = 0), t;
          }, t.size = function () {
            return (this || _global).tail - (this || _global).head;
          }, t.empty = function () {
            return (this || _global).head >= (this || _global).tail;
          }, e;
        }();
      },
      904: function (e, t, n) {
        "use strict";

        n.d(t, {
          $1: function () {
            return c;
          },
          $_: function () {
            return h;
          },
          Ec: function () {
            return f;
          },
          Pt: function () {
            return i;
          },
          Ri: function () {
            return d;
          },
          a1: function () {
            return r;
          },
          lU: function () {
            return u;
          },
          ok: function () {
            return o;
          },
          pn: function () {
            return a;
          },
          xA: function () {
            return l;
          },
          yY: function () {
            return s;
          }
        });
        var r = 2,
          i = 4,
          o = 3,
          a = 1,
          s = 101,
          u = 102,
          c = 201,
          d = 202,
          l = 203,
          f = 204,
          h = 404;
      },
      446: function (e, t, n) {
        "use strict";

        n.d(t, {
          Z: function () {
            return l;
          }
        });
        var r = n(898),
          i = n.n(r),
          o = n(904),
          a = n(787),
          s = n(477);
        function u(e) {
          var t = (e || "").match(/codecs="([^.]+)\./);
          return t && t[1] ? t[1] : "";
        }
        var c = function () {
            function e(e, t, n, r, i) {
              (this || _global).rawCodec = t, (this || _global).group = n, (this || _global).isProtected = r, (this || _global).onError = i, (this || _global).pending = void 0, (this || _global).unsubscribers = [], (this || _global).srcBuf = void 0, (this || _global).blocked = !1, (this || _global).srcBuf = e, (this || _global).pending = new a.o(), (this || _global).unsubscribers.push((0, s.B1)(e, "updateend", (this || _global).process.bind(this || _global)));
            }
            var t = e.prototype;
            return t.getBufferedRanges = function () {
              try {
                var e = [];
                if ((this || _global).srcBuf) for (var t = (this || _global).srcBuf.buffered, n = 0; n < t.length; n++) e.push({
                  start: t.start(n),
                  end: t.end(n)
                });
                return e;
              } catch (e) {
                return [];
              }
            }, t.abort = function () {
              this.schedule(function (e) {
                e.abort();
              });
            }, t.changeType = function (e) {
              (this || _global).rawCodec = function (e) {
                var t = (e || "").match(/codecs=".+"/);
                return t && t[0] ? t[0] : "codecs=\"\"";
              }(e), this.schedule(function (t) {
                t.changeType(e);
              });
            }, t.appendBuffer = function (e) {
              this.schedule(function (t) {
                try {
                  t.appendBuffer(e);
                } catch (e) {
                  if ("QuotaExceededError" !== e.name) throw e;
                  var n = t.buffered,
                    r = n.start(0),
                    i = n.end(n.length - 1),
                    o = (r + i) / 2;
                  t.remove(o, i);
                }
              });
            }, t.setTimestampOffset = function (e) {
              this.schedule(function (t) {
                t.timestampOffset = e;
              });
            }, t.remove = function (e, t) {
              this.schedule(function (n) {
                var r = n.buffered;
                if (r.length) {
                  var i = Math.max(e, r.start(0)),
                    o = Math.min(t, r.end(r.length - 1));
                  i < o && n.remove(i, o);
                }
              });
            }, t.block = function () {
              var e = this || _global;
              return new Promise(function (t) {
                e.schedule(function () {
                  e.blocked = !0, t();
                });
              });
            }, t.unblock = function () {
              (this || _global).blocked = !1, this.process();
            }, t.destroy = function () {
              (this || _global).pending = new a.o(), (this || _global).unsubscribers.forEach(function (e) {
                return e();
              }), (this || _global).srcBuf = void 0;
            }, t.schedule = function (e) {
              (this || _global).pending.empty() && this.canProcess() ? this.safeExecute(e) : ((this || _global).pending.push(e), this.process());
            }, t.safeExecute = function (e) {
              try {
                if (!(this || _global).srcBuf) throw new Error("srcBuf is undefined");
                e((this || _global).srcBuf);
              } catch (e) {
                this.onError(e, !1);
              }
            }, t.process = function () {
              for (; !(this || _global).pending.empty() && this.canProcess();) this.safeExecute((this || _global).pending.pop());
            }, t.canProcess = function () {
              return !(!(this || _global).srcBuf || (this || _global).srcBuf.updating || (this || _global).blocked);
            }, i()(e, [{
              key: "buffer",
              get: function () {
                return (this || _global).srcBuf;
              }
            }, {
              key: "codec",
              get: function () {
                return (this || _global).rawCodec;
              }
            }, {
              key: "timestampOffset",
              get: function () {
                return (this || _global).buffer ? (this || _global).buffer.timestampOffset : 0;
              }
            }]);
          }(),
          d = n(887),
          l = function () {
            function e(e, t, n) {
              (this || _global).mediaSource = e, (this || _global).onEnded = t, (this || _global).onError = n, (this || _global).sourceBuffers = Object.create(null), (this || _global).unsubscribers = [], (this || _global).unsubscribers.push((0, s.B1)(e, "sourceended", (this || _global).onEnded));
            }
            e.isSupported = function () {
              return void 0 !== self.MediaSource;
            }, e.isSupportedInWorker = function () {
              return e.isSupported() && MediaSource.canConstructInDedicatedWorker && "function" == typeof MediaSourceHandle;
            }, e.create = function (t, n) {
              var r = new MediaSource(),
                i = new Promise(function (i, o) {
                  var a = (0, s.B1)(r, "sourceopen", function () {
                    "open" === r.readyState ? (i(new e(r, t, n)), a()) : o("The MediaSource was closed upon opening");
                  });
                });
              return {
                ms: r,
                sink: i
              };
            };
            var t = e.prototype;
            return t.getBufferedRanges = function (e) {
              var t, n;
              return null != (t = null == (n = (this || _global).sourceBuffers[d.kD[e]]) ? void 0 : n.getBufferedRanges()) ? t : [];
            }, t.addTrack = function (e, t, n, r) {
              var i = (this || _global).mediaSource,
                o = (this || _global).sourceBuffers,
                a = function (e) {
                  return "video/mp4;" + e;
                }(t);
              if (o[e]) {
                var s,
                  d = u(o[e].codec);
                return u(t) !== d && o[e].changeType(a), null != (s = o[e].buffer) ? s : null;
              }
              try {
                var l = i.addSourceBuffer(a);
                return o[e] = new c(l, t, n, r, (this || _global).handleError.bind(this || _global)), l;
              } catch (e) {
                this.handleError(e, "open" === i.readyState);
              }
              return null;
            }, t.append = function (e, t) {
              var n;
              null == (n = (this || _global).sourceBuffers[e]) || n.appendBuffer(t);
            }, t.remove = function (e, t) {
              for (var n = (this || _global).sourceBuffers, r = 0, i = Object.keys(n); r < i.length; r++) n[i[r]].remove(e, t);
            }, t.setTimestampOffset = function (e, t) {
              var n = (this || _global).sourceBuffers[e];
              n && (n.abort(), n.setTimestampOffset(t));
            }, t.setDuration = function (e) {
              var t = this || _global;
              this.scheduleUpdate(function () {
                return t.mediaSource.duration = e;
              }).catch(function (e) {
                return t.handleError(e, !1);
              });
            }, t.setLiveSeekableRange = function (e, t) {
              var n = this || _global;
              this.scheduleUpdate(function () {
                return n.mediaSource.setLiveSeekableRange(e, t);
              }).catch(function (e) {
                return n.handleError(e, !1);
              });
            }, t.scheduleUpdate = function (e) {
              var t = this || _global;
              void 0 === e && (e = f);
              var n = Object.keys((this || _global).sourceBuffers).map(function (e) {
                return t.sourceBuffers[e];
              });
              return Promise.all(n.map(function (e) {
                return e.block();
              })).then(e).then(function () {
                return n.forEach(function (e) {
                  return e.unblock();
                });
              });
            }, t.isDrmProtected = function () {
              return (this || _global).bufferProperties.some(function (e) {
                return e.isProtected;
              });
            }, t.isAudioOnly = function () {
              return 1 === (this || _global).bufferProperties.length && "audio_only" === (this || _global).bufferProperties[0].group;
            }, t.destroy = function () {
              this.destroySourceBuffers(), (this || _global).unsubscribers.forEach(function (e) {
                return e();
              }), (this || _global).unsubscribers = [];
            }, t.handleError = function (e, t) {
              var n = e.code || o.lU,
                r = o.lU;
              "NotSupportedError" === e.name && (r = n = o.Pt), this.onError(r, n, e.message, t);
            }, t.destroySourceBuffers = function () {
              for (var e = (this || _global).mediaSource; e.sourceBuffers.length > 0;) try {
                e.removeSourceBuffer(e.sourceBuffers[0]);
              } catch (e) {
                this.handleError(e, !1);
                break;
              }
              for (var t = 0, n = Object.keys((this || _global).sourceBuffers); t < n.length; t++) {
                var r = n[t];
                (this || _global).sourceBuffers[r].destroy();
              }
              (this || _global).sourceBuffers = Object.create(null);
            }, i()(e, [{
              key: "duration",
              get: function () {
                return (this || _global).mediaSource.duration;
              }
            }, {
              key: "bufferProperties",
              get: function () {
                var e = (this || _global).sourceBuffers;
                return Object.keys(e).map(function (t) {
                  var n = e[t];
                  return {
                    trackID: Number(t),
                    codec: n.codec,
                    mode: "mse",
                    path: "",
                    isProtected: n.isProtected,
                    group: n.group,
                    srcObj: null
                  };
                });
              }
            }]);
          }(),
          f = function () {};
      },
      887: function (e, t, n) {
        "use strict";

        n.d(t, {
          HJ: function () {
            return a;
          },
          Pp: function () {
            return o;
          },
          Sf: function () {
            return i;
          },
          de: function () {
            return r;
          },
          kD: function () {
            return s;
          }
        });
        var r = 0.1,
          i = 1 << 30,
          o = 120000,
          a = 3000,
          s = {
            audio: 1936684398,
            video: 1986618469
          };
      },
      477: function (e, t, n) {
        "use strict";

        n.d(t, {
          B1: function () {
            return l;
          },
          GX: function () {
            return h;
          },
          V3: function () {
            return c;
          },
          gd: function () {
            return s;
          },
          ld: function () {
            return a;
          },
          tX: function () {
            return d;
          },
          v8: function () {
            return f;
          },
          vG: function () {
            return u;
          },
          xB: function () {
            return o;
          }
        });
        var r = n(806),
          i = n(887);
        function o(e) {
          return "number" == typeof e.webkitDecodedFrameCount ? e.webkitDecodedFrameCount : "function" == typeof e.getVideoPlaybackQuality ? e.getVideoPlaybackQuality().totalVideoFrames : "number" == typeof e.mozDecodedFrames ? e.mozDecodedFrames : 0;
        }
        function a(e) {
          return "number" == typeof e.webkitDroppedFrameCount ? e.webkitDroppedFrameCount : "function" == typeof e.getVideoPlaybackQuality ? e.getVideoPlaybackQuality().droppedVideoFrames : 0;
        }
        function s(e, t) {
          for (var n = 0; n < t.length; n++) console.info(e, "start: ", t.start(n), ", end: ", t.end(n));
        }
        function u(e, t, n) {
          for (var r = 0; r < e.length; r++) {
            var i = e.start(r),
              o = e.end(r);
            if (!(o <= t)) {
              if (i - n > t) break;
              for (var a = r + 1; a < e.length && !(e.start(a) - o > n); a++) o = e.end(a);
              for (var s = r - 1; s >= 0 && !(i - e.end(s) > n); s--) i = e.start(s);
              return {
                start: Math.min(i, t),
                end: o
              };
            }
          }
          return {
            start: t,
            end: t
          };
        }
        function c(e, t) {
          var n = u(e.buffered, e.currentTime, t).end,
            r = e.currentTime,
            i = n - r;
          return !(e.ended || e.duration - r < t) && i < t;
        }
        function d(e, t, n) {
          void 0 === n && (n = i.de);
          var r = u(e, t, n).end - t > n;
          if (e.length > 1 || !r) for (var o = 0; o < e.length; o++) {
            var a = e.start(o),
              s = e.end(o);
            if (t < a && s - a > n) return a + n;
          }
          return r ? t + n : t;
        }
        function l(e, t, n) {
          return e.addEventListener(t, n), function () {
            e.removeEventListener(t, n);
          };
        }
        function f(e) {
          if (e.src) {
            var t = e.src;
            r.Pr(e), e.load(), URL.revokeObjectURL(t);
          }
        }
        function h(e, t) {
          var n = e.playbackRate,
            r = e.src;
          r && URL.revokeObjectURL(r), e.src = t, e.playbackRate = n;
        }
      },
      422: function () {},
      569: function () {},
      721: function (e, t, n) {
        "use strict";

        n.d(t, {
          $: function () {
            return r;
          }
        });
        var r = function (e) {
          return e.DEBUG = "debug", e.INFO = "info", e.WARN = "warn", e.ERROR = "error", e;
        }({});
      },
      15: function () {},
      806: function (e, t, n) {
        "use strict";

        function r(e) {
          try {
            return JSON.parse(e);
          } catch (t) {
            return console.error("Failed JSON parse:", e), {};
          }
        }
        function i(e) {
          try {
            return JSON.stringify(e);
          } catch (t) {
            return console.error("Failed JSON stringify:", e), "";
          }
        }
        function o(e) {
          return "" === e.codecs || "undefined" == typeof MediaSource || MediaSource.isTypeSupported("video/mp4;codecs=\"" + e.codecs + "\"");
        }
        function a(e, t) {
          var n = [],
            r = [];
          return e.forEach(function (e) {
            t(e) ? n.push(e) : r.push(e);
          }), {
            supported: n,
            unsupported: r
          };
        }
        function s(e) {
          var t, n;
          return void 0 !== e.hidden ? (t = "hidden", n = "visibilitychange") : void 0 !== e.msHidden ? (t = "msHidden", n = "msvisibilitychange") : void 0 !== e.webkitHidden && (t = "webkitHidden", n = "webkitvisibilitychange"), {
            hidden: t,
            visibilityChange: n
          };
        }
        function u(e, t, n) {
          return Math.min(n, Math.max(t, e));
        }
        function c(e) {
          e.removeAttribute("src");
        }
        function d(e) {
          var t = window.location,
            n = document.createElement("a");
          return n.href = e, n.hostname === t.hostname && n.port === t.port && n.protocol === t.protocol;
        }
        function l(e) {
          if ("function" == typeof e.checkVisibility) return e.checkVisibility({
            visibilityProperty: !0
          });
          var t = e.style;
          return "none" !== t.display && "hidden" !== t.visibility;
        }
        n.d(t, {
          J6: function () {
            return d;
          },
          N8: function () {
            return r;
          },
          Pr: function () {
            return c;
          },
          YH: function () {
            return a;
          },
          dl: function () {
            return i;
          },
          h3: function () {
            return o;
          },
          j: function () {
            return l;
          },
          qE: function () {
            return u;
          },
          sQ: function () {
            return s;
          }
        });
      },
      27: function (e, t, n) {
        "use strict";

        n.d(t, {
          G: function () {
            return h;
          }
        });
        var r,
          i = n(949),
          o = n(502),
          a = n(338),
          s = n(214),
          u = n(638),
          c = function (e) {
            return e.DURATION_CHANGE = "durationchange", e.ENDED = "ended", e.ERROR = "error", e.LOADED_METADATA = "loadedmetadata", e.LOADSTART = "loadstart", e.PAUSE = "pause", e.PLAY = "play", e.PLAYING = "playing", e.RATE_CHANGE = "ratechange", e.SEEKED = "seeked", e.SEEKING = "seeking", e.TIME_UPDATE = "timeupdate", e.VOLUME_CHANGE = "volumechange", e.WAITING = "waiting", e;
          }({}),
          d = function (e) {
            return e[e.HAVE_NOTHING = 0] = "HAVE_NOTHING", e[e.HAVE_METADATA = 1] = "HAVE_METADATA", e[e.HAVE_CURRENT_DATA = 2] = "HAVE_CURRENT_DATA", e[e.HAVE_FUTURE_DATA = 3] = "HAVE_FUTURE_DATA", e[e.HAVE_ENOUGH_DATA = 4] = "HAVE_ENOUGH_DATA", e;
          }(d || {}),
          l = ((r = {})[s.p.IDLE] = 1, r[s.p.READY] = 1, r[s.p.BUFFERING] = 2, r[s.p.PLAYING] = 2, r[s.p.ENDED] = 1, r),
          f = "AmazonIVS";
        function h(e, t) {
          if (void 0 === e || "function" != typeof e.getTech) throw {
            message: "videojs not available, AmazonIVS tech not registered",
            code: 1
          };
          if (!u.i$) throw {
            message: "WebAssembly support is required for AmazonIVS tech",
            code: 2
          };
          if (!e.getTech(f)) {
            var n,
              r = {
                featuresProgressEvents: !0,
                featuresTimeupdateEvents: !0,
                featuresPlaybackRate: !0,
                featuresFullscreenResize: !0,
                featuresVolumeControl: !0,
                featuresMuteControl: !0,
                featuresNativeTextTracks: !1,
                privateContructor: function (n, r, i) {
                  (this || _global)._readyState = d.HAVE_NOTHING, (this || _global)._defaultPlaybackRate = 1, (this || _global)._seeking = !1, t.playerFramework = {
                    name: "videojs",
                    version: e.VERSION
                  }, (this || _global)._mediaPlayer = (0, u.vt)(t), (this || _global)._mediaPlayer.setAutoplay(!0 === n.autoplay), this._attachVideojsListeners(), (this || _global)._mediaPlayer.addEventListener(a.a.METADATA, (this || _global)._onCaptionEvent.bind(this || _global));
                  var o = this._createEl(n);
                  n.el = o, i(this || _global, n, r), window.vttjs && window.vttjs.restore(), this.triggerReady(), setTimeout(function () {
                    var e = this.options(),
                      t = e.loop,
                      n = e.muted;
                    t && (this || _global)._mediaPlayer.setLooping(!0), n && (this || _global)._mediaPlayer.setMuted(!0);
                  }.bind(this || _global), 0);
                },
                dispose: function () {
                  (this || _global)._mediaPlayer.delete();
                },
                setPreload: function () {},
                autoplay: function (e) {
                  if ("boolean" != typeof e) return (this || _global)._mediaPlayer.autoplay;
                  this.setAutoplay(e);
                },
                setAutoplay: function (e) {
                  (this || _global)._mediaPlayer.setAutoplay(e);
                },
                preload: function () {},
                load: function () {},
                readyState: function () {
                  return (this || _global)._readyState;
                },
                seeking: function () {
                  return (this || _global)._seeking;
                },
                networkState: function () {
                  if (!(this || _global)._mediaPlayer) return 0;
                  if (!(this || _global)._mediaPlayer.getHTMLVideoElement().src) return 3;
                  var e = (this || _global)._mediaPlayer.getState();
                  return l[e];
                },
                ended: function () {
                  return (this || _global)._mediaPlayer.getState() === s.p.ENDED;
                },
                seekable: function () {
                  return e.createTimeRange(0, (this || _global)._mediaPlayer.getDuration());
                },
                play: function () {
                  (this || _global)._mediaPlayer.play(), this.trigger(c.PLAY);
                },
                pause: function () {
                  (this || _global)._mediaPlayer.pause();
                },
                setCurrentTime: function (e) {
                  (this || _global)._mediaPlayer.getHTMLVideoElement().src && ((this || _global)._mediaPlayer.seekTo(e), (this || _global)._seeking = !0, this.trigger(c.SEEKING));
                },
                controls: function () {
                  return !1;
                },
                setControls: function () {
                  return !1;
                },
                muted: function () {
                  return (this || _global)._mediaPlayer.isMuted();
                },
                setMuted: function (e) {
                  (this || _global)._mediaPlayer.setMuted(e);
                },
                volume: function () {
                  return (this || _global)._mediaPlayer.getVolume();
                },
                setVolume: function (e) {
                  (this || _global)._mediaPlayer.setVolume(e);
                },
                defaultPlaybackRate: function (e) {
                  if (!e) return (this || _global)._defaultPlaybackRate;
                  (this || _global)._defaultPlaybackRate = e;
                },
                playbackRate: function () {
                  return (this || _global)._mediaPlayer.getPlaybackRate();
                },
                setPlaybackRate: function (e) {
                  (this || _global)._mediaPlayer.setPlaybackRate(e);
                },
                paused: function () {
                  return (this || _global)._mediaPlayer.isPaused();
                },
                duration: function () {
                  return (this || _global)._mediaPlayer.getDuration();
                },
                currentTime: function () {
                  return (this || _global)._mediaPlayer.getPosition();
                },
                _createEl: function (e) {
                  var t = (this || _global)._mediaPlayer.getHTMLVideoElement();
                  t.setAttribute("class", "vjs-tech"), void 0 !== e.disablePictureInPicture && (t.disablePictureInPicture = e.disablePictureInPicture), ["preload", "poster"].forEach(function (n) {
                    e[n] && t.setAttribute(n, e[n]);
                  }.bind(this || _global)), e.playsinline && (t.setAttribute("webkit-playsinline", ""), t.setAttribute("playsinline", ""));
                  var n = document.createElement("div");
                  return n.appendChild(t), n;
                },
                src: function (e) {
                  this.trigger(c.LOADSTART), (this || _global)._seeking = !1, (this || _global)._captionTrack && (this.textTracks().removeTrack((this || _global)._captionTrack), (this || _global)._captionTrack = null), e && (this || _global)._mediaPlayer.load(e);
                },
                addEventListener: function (e, t) {
                  (this || _global)._mediaPlayer.addEventListener(e, t);
                },
                removeEventListener: function (e, t) {
                  (this || _global)._mediaPlayer.removeEventListener(e, t);
                },
                getMediaPlayerAPI: function () {
                  return (this || _global)._mediaPlayer;
                },
                supportsFullScreen: function () {
                  return !0;
                },
                enterFullScreen: function () {
                  var e = (this || _global)._mediaPlayer.getHTMLVideoElement();
                  (e.requestFullscreen || e.webkitRequestFullscreen || e.mozRequestFullScreen || e.msRequestFullscreen || e.webkitEnterFullscreen || function () {
                    console.error("Fullscreen API is not available");
                  }).call(e);
                },
                exitFullScreen: function () {
                  (document.exitFullScreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen || function () {
                    console.error("Exitscreen API is not available");
                  }).call(document);
                },
                requestPictureInPicture: function () {
                  return (this || _global)._mediaPlayer.getHTMLVideoElement().requestPictureInPicture();
                },
                setDisablePictureInPicture: function (e) {
                  (this || _global)._mediaPlayer.getHTMLVideoElement().disablePictureInPicture = e;
                },
                disablePictureInPicture: function () {
                  return (this || _global)._mediaPlayer.getHTMLVideoElement().disablePictureInPicture;
                },
                _onCaptionEvent: function (e) {
                  if ("text/json" === e.type) {
                    var t = JSON.parse(e.data);
                    if (t.caption) {
                      var n = t.caption;
                      (this || _global)._captionTrack || ((this || _global)._captionTrack = this.addTextTrack("captions", n.format), (this || _global)._currentCue = null), (this || _global)._currentCue && (this || _global)._captionTrack.removeCue((this || _global)._currentCue);
                      var r = (this || _global)._mediaPlayer.getHTMLVideoElement(),
                        i = window.VTTCue || window.vttjs.VTTCue;
                      i ? ((this || _global)._currentCue = new i(r.currentTime, r.currentTime + 2, n.text), (this || _global)._captionTrack.addCue((this || _global)._currentCue)) : console.warn("No VTTCue implementation available, caption may not be available");
                    }
                  }
                },
                _attachVideojsListeners: function () {
                  (this || _global)._mediaPlayer.addEventListener(s.p.READY, function () {
                    (this || _global)._readyState = d.HAVE_METADATA, this.trigger(c.LOADED_METADATA);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(s.p.IDLE, function () {
                    (this || _global)._readyState = d.HAVE_NOTHING, this.trigger(c.PAUSE);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(s.p.PLAYING, function () {
                    (this || _global)._readyState <= d.HAVE_CURRENT_DATA && ((this || _global)._readyState = d.HAVE_FUTURE_DATA), this.trigger(c.PLAY), this.trigger(c.PLAYING);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(s.p.ENDED, function () {
                    (this || _global)._readyState = d.HAVE_NOTHING, this.trigger(c.ENDED);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(s.p.BUFFERING, function () {
                    (this || _global)._readyState = d.HAVE_CURRENT_DATA;
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.REBUFFERING, function () {
                    (this || _global)._readyState = d.HAVE_CURRENT_DATA, this.trigger(c.WAITING);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.TIME_UPDATE, function () {
                    this.trigger(c.TIME_UPDATE);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.VOLUME_CHANGED, function () {
                    this.trigger(c.VOLUME_CHANGE);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.MUTED_CHANGED, function () {
                    this.trigger(c.VOLUME_CHANGE);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.ERROR, function () {
                    this.trigger(c.ERROR);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.DURATION_CHANGED, function () {
                    this.trigger(c.DURATION_CHANGE);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.SEEK_COMPLETED, function () {
                    (this || _global)._seeking = !1, this.trigger(c.SEEKED);
                  }.bind(this || _global)), (this || _global)._mediaPlayer.addEventListener(a.a.PLAYBACK_RATE_CHANGED, function () {
                    this.trigger(c.RATE_CHANGE);
                  }.bind(this || _global));
                }
              },
              h = e.getTech("Tech");
            "function" == typeof e.extend ? (r.constructor = function (e, t) {
              this.privateContructor(e, t, function (e, t, n) {
                h.call(e, t, n);
              });
            }, n = e.extend(h, r, f)) : ((n = function (e, t) {
              this.privateContructor(e, t, function (e, t, n) {
                var r = h.prototype,
                  i = r.featuresProgressEvents,
                  o = r.featuresTimeupdateEvents,
                  a = r.featuresPlaybackRate,
                  s = r.featuresFullscreenResize,
                  u = r.featuresVolumeControl,
                  d = r.featuresMuteControl,
                  l = r.featuresNativeTextTracks;
                r.featuresProgressEvents = !0, r.featuresTimeupdateEvents = !0, r.featuresPlaybackRate = !0, r.featuresFullscreenResize = !0, r.featuresVolumeControl = !0, r.featuresMuteControl = !0, r.featuresNativeTextTracks = !1, Object.assign(e, new h(t, n)), e.on(c.PLAYING, function () {
                  e.hasStarted_ = !0;
                }), e.on(c.LOADSTART, function () {
                  e.hasStarted_ = !1;
                }), r.featuresProgressEvents = i, r.featuresTimeupdateEvents = o, r.featuresPlaybackRate = a, r.featuresFullscreenResize = s, r.featuresVolumeControl = u, r.featuresMuteControl = d, r.featuresNativeTextTracks = l;
              });
            }).prototype = Object.create(h.prototype), Object.assign(n.prototype, r)), n.supportsFullScreen = function () {
              return !0;
            }, n.isSupported = function () {
              return -1 === (navigator.appVersion || "").toLowerCase().indexOf("rv:11");
            }, n.canPlayType = function (e) {
              return "string" == typeof e && e.length > 0 && (e.indexOf("application/x-mpegURL") > -1 ? "undefined" != typeof MediaSource && MediaSource.isTypeSupported("video/mp4; codecs=\"avc1.42E01E,mp4a.40.2\"") : "" !== document.createElement("video").canPlayType(e));
            }, n.canPlaySource = function () {
              return !0;
            }, e.registerTech("AmazonIVS", n);
            var v = e.registerPlugin || e.plugin;
            v("getIVSEvents", function () {
              return {
                PlayerEventType: a.a,
                MetadataEventType: o.C,
                PlayerState: s.p,
                ErrorType: i.B
              };
            }), v("getIVSPlayer", function () {
              return this.tech(!0).getMediaPlayerAPI();
            });
          }
        }
      },
      371: function (e, t, n) {
        "use strict";

        n.d(t, {
          U: function () {
            return a;
          }
        });
        var r = n(338),
          i = n(214),
          o = "enableIVSQualityPlugin";
        function a(e) {
          if (void 0 === e || "function" != typeof e.getTech) throw {
            message: "videojs not available, Amazon IVS Quality Plugin not registered",
            code: 1
          };
          if (!e.getPlugin(o)) {
            var t,
              n = e.getComponent("MenuButton"),
              a = e.getComponent("MenuItem"),
              s = {
                privateConstructor: function (e, t, n) {
                  n(this || _global, e, t), this.controlText("Quality");
                },
                createItems: function () {
                  var e = this.player(),
                    t = e.getIVSPlayer(),
                    n = [],
                    i = new a(e, {
                      selectable: !0,
                      label: "Auto",
                      qualityGroup: "auto"
                    });
                  i.selected(t.isAutoQualityMode()), i.on(["click", "tap"], function () {
                    t.setAutoQualityMode(!0);
                  }), i.on(["click", "tap"], (this || _global)._clickHandler.bind(this || _global, i)), n.push(i);
                  var o = t.getQuality(),
                    s = t.getQualities();
                  return s && s.length > 0 && s.forEach(function (r) {
                    var i = new a(e, {
                        selectable: !0,
                        label: r.name,
                        qualityGroup: r.group
                      }),
                      s = function (e) {
                        t.setQuality(e);
                      }.bind(null, r);
                    i.on(["click", "tap"], s), i.on(["click", "tap"], (this || _global)._clickHandler.bind(this || _global, i)), t.isAutoQualityMode() || i.selected(o.group === r.group), n.push(i);
                  }.bind(this || _global)), t.addEventListener(r.a.QUALITY_CHANGED, function (n) {
                    var r;
                    if (!t.isAutoQualityMode()) {
                      var i = null == (r = e.controlBar) ? void 0 : r.getChild("QualityMenuButton");
                      null == i || i.items.forEach(function (e) {
                        var t = e.options().qualityGroup;
                        n && t && e.selected(n.group === t);
                      });
                    }
                  }), (this || _global).qualityItems = n, n;
                },
                buildCSSClass: function () {
                  return "vjs-icon-hd vjs-icon-placeholder " + n.prototype.buildCSSClass.call(this || _global);
                },
                _clickHandler: function (e) {
                  (this || _global).items.forEach(function (t) {
                    t !== e && t.selected(!1);
                  });
                }
              };
            "function" == typeof e.extend ? (s.constructor = function (e, t) {
              this.privateConstructor(e, t, function (e, t, r) {
                n.call(e, t, r);
              });
            }, t = e.extend(n, s)) : ((t = function (e, t) {
              this.privateConstructor(e, t, function (e, t, r) {
                var i = "quality-control";
                r.name = i;
                var o = new n(t, r);
                o.getChild(i).addClass("vjs-icon-hd vjs-icon-placeholder"), Object.assign(e, o), e.items = e.createItems(), e.items.forEach(function (t) {
                  e.menu.addItem(t);
                });
              });
            }).prototype = Object.create(n.prototype), Object.assign(t.prototype, s)), e.registerComponent("QualityMenuButton", t), (e.registerPlugin || e.plugin)(o, function () {
              var e = this || _global;
              e.getIVSPlayer().addEventListener(i.p.READY, function () {
                var t,
                  n,
                  r = null == (t = e.controlBar) ? void 0 : t.getChild("QualityMenuButton");
                r && (r.dispose(), e.controlBar.removeChild(r)), null == (n = e.controlBar) || n.addChild("QualityMenuButton");
              });
            });
          }
        }
      },
      898: function (e) {
        "use strict";

        e.exports = _createClass;
      }
    },
    t = {};
  function n(r) {
    var i = t[r];
    if (void 0 !== i) return i.exports;
    var o = t[r] = {
      exports: {}
    };
    return e[r](o, o.exports, n), o.exports;
  }
  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || _global || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  !function () {
    "use strict";

    n.r(r), n.d(r, {
      AuthorizationError: function () {
        return i.y;
      },
      CaptureEventType: function () {
        return s.P;
      },
      ErrorSource: function () {
        return t.g;
      },
      ErrorType: function () {
        return i.B;
      },
      LogLevel: function () {
        return v.$;
      },
      MediaPlayer: function () {
        return e.KJ;
      },
      MetadataEventType: function () {
        return o.C;
      },
      MetadataID3Type: function () {
        return o._;
      },
      PlayerEventType: function () {
        return a.a;
      },
      PlayerState: function () {
        return u.p;
      },
      RemotePlayerEvent: function () {
        return y.G;
      },
      create: function () {
        return e.vt;
      },
      createWorker: function () {
        return e.Zx;
      },
      getVersion: function () {
        return e.HF;
      },
      isPlayerSupported: function () {
        return e.i$;
      },
      isVP9Supported: function () {
        return g.YJ;
      },
      isWasmSupported: function () {
        return e.TH;
      },
      registerIVSQualityPlugin: function () {
        return m.U;
      },
      registerIVSTech: function () {
        return p.G;
      }
    });
    var e = n(638),
      t = n(296),
      i = n(949),
      o = n(502),
      a = n(338),
      s = n(601),
      u = n(214),
      c = n(569),
      d = {};
    for (var l in c) ["default", "LogLevel", "registerIVSTech", "registerIVSQualityPlugin", "isVP9Supported", "MediaPlayer", "create", "createWorker", "getVersion", "isPlayerSupported", "isWasmSupported", "ErrorSource", "AuthorizationError", "ErrorType", "MetadataEventType", "MetadataID3Type", "PlayerEventType", "CaptureEventType", "PlayerState"].indexOf(l) < 0 && (d[l] = function (e) {
      return c[e];
    }.bind(0, l));
    n.d(r, d);
    var f = n(15);
    for (var l in d = {}, f) ["default", "LogLevel", "registerIVSTech", "registerIVSQualityPlugin", "isVP9Supported", "MediaPlayer", "create", "createWorker", "getVersion", "isPlayerSupported", "isWasmSupported", "ErrorSource", "AuthorizationError", "ErrorType", "MetadataEventType", "MetadataID3Type", "PlayerEventType", "CaptureEventType", "PlayerState"].indexOf(l) < 0 && (d[l] = function (e) {
      return f[e];
    }.bind(0, l));
    n.d(r, d);
    var h = n(422);
    for (var l in d = {}, h) ["default", "LogLevel", "registerIVSTech", "registerIVSQualityPlugin", "isVP9Supported", "MediaPlayer", "create", "createWorker", "getVersion", "isPlayerSupported", "isWasmSupported", "ErrorSource", "AuthorizationError", "ErrorType", "MetadataEventType", "MetadataID3Type", "PlayerEventType", "CaptureEventType", "PlayerState"].indexOf(l) < 0 && (d[l] = function (e) {
      return h[e];
    }.bind(0, l));
    n.d(r, d);
    var v = n(721),
      p = n(27),
      m = n(371),
      g = n(856),
      y = n(385);
  }(), exports = r;
}();
export default exports;